export const trLangDashboard = {
  headerSearch: {
    placeholder: 'Ürün ara',
    cancel: 'İptal',
    empty: 'Ürün bulunamadı',
    noShop: 'Aranacak ürün henüz yok',
  },
  common: {
    you: 'Sen',
    post: 'Gönderi',
    article: 'Makale',
    create: 'Oluştur',
    message: 'Mesaj',
    popular: 'Popüler',
    emptyIntegrations: 'Önce entegrasyon eklemelisiniz',
    categories: 'Kategoriler',
    edit: 'Düzenle',
    share: 'Paylaş',
    plan: 'Plan',
    sort: 'Sırala',
    addArticle: 'Makale ekle',
    articles: 'Makaleler',
    users: 'kullanıcı',
    scans: 'tarama',
    clicks: 'tıklama',
    copy: 'Kopyala',
    customize: 'Özelleştir',
    link: 'bağlantı',
    save: 'Kaydet',
    uploadFile: 'Dosya Yükle',
    customImage: 'Özel Görsel',
    customImageTooltip: 'Özel görsel yükle',
    size: 'Boyut',
    sizeTooltip: 'Boyutu ayarlamak için kaydırıcıyı sürükleyin',
    auto: 'Otomatik',
    rectangle: 'Dikdörtgen',
    custom: 'Özel',
    clean: 'Temizle',
    cleaning: 'Temizleniyor',
    download: 'İndir',
    downloading: 'İndiriliyor',
    preview: 'ÖNİZLEME',
    cover: 'Kapak',
    coverTooltip: 'Kapak fotoğrafı yükleyin',
    title: 'Başlık',
    new: 'Yeni',
    pro: 'Pro',
    free: 'Ücretsiz',
    limit: 'Limit',
    websites: 'web siteleri',
    site: 'Site',
    apiKey: 'API Key',
    name: 'Ad',
    passwordChange: 'Şifre değiştir',
    draft: 'Taslak',
    page: 'Sayfa',
    areYouSure: 'Emin misiniz?',
    drop: 'Bırak',
    video: 'video',
    image: 'görsel',
    chooseFile: 'Dosya seç',
    nothingFound: 'Hiçbir Şey Bulunamadı',
    enterCorrectLink: 'Doğru bağlantıyı girin',
    off: 'Kapalı',
    disconnect: 'BAĞLANTIYI KES',
    connect: 'BAĞLAN',
    copied: 'Kopyalandı',
    saved: 'Kaydedildi',
    lostConnection: 'Bağlantı kesildi',
    addedCategory: 'Kategori eklendi',
    none: 'Yok',
    left: 'Sol',
    right: 'Sağ',
    solid: 'Düz',
    double: 'Çift',
    welcome: 'Hoş geldiniz',
    category: 'Kategori',
    product: 'Ürün',
    website: 'Web sitesi',
    items: 'Öğeler',
    square: 'Kare',
    round: 'Yuvarlak',
    border: 'Kenarlık',
    shadow: 'Gölge',
    subtle: 'İnce',
    soft: 'Yumuşak',
    hard: 'Sert',
    block: 'Blok',
    primary: 'Birincil',
    additional: 'Ek',
    normal: 'Normal',
    bold: 'Kalın',
    uploadVideo: 'Video yükle',
    compact: 'Kompakt',
    card: 'Kart',
    top: 'Üst',
    center: 'Orta',
    bottom: 'Alt',
    button: 'Düğme',
    addNewItem: 'Yeni öğe ekle',
    price: 'Fiyat',
    priceCaption: 'Ürününüzün fiyatını ekleyin',
    oldPrice: 'Eski fiyat',
    oldPriceCaption: 'Eski fiyatın üzeri çizilecek',
    areYouSureDeleteItem: 'Bu öğeyi kaldırmak istediğinizden emin misiniz?',
    add: 'Ekle',
    active: 'Aktif',
    isActive: 'aktif',
    isDisabled: 'devre dışı',
    uploadImage: 'Görsel yükle',
    design: 'Tasarım',
    addAccount: 'Hesap ekle',
    hey: 'Merhaba',
    activeBackground: 'Aktif arka plan',
    activeText: 'Aktif metin',
    connectDomain: 'Alan adı bağla',
    shortLink: 'Kısa Bağlantı',
    appearanceSaved: 'Görünüm kaydedildi!',
    blockAdded: 'Blok eklendi!',
    comingSoon: 'Yakında',
    easyMoney: 'Kolay para',
    content: 'İçerik',
    audience: 'Kitle',
    view: 'Görüntüle',
    delete: 'Sil',
    file: 'Dosya',
    type: 'Tür',
    from: 'Kimden',
    to: 'Kime',
    fullName: 'Ad soyad',
    lastTimeUsed: 'Son kullanım',
    noMediaFiles: 'Henüz medya dosyası yok...',
    withdraw: 'Para çek',
    congrats: 'Tebrikler!',
    makeMoneyOnline: 'Çevrimiçi para kazanın!',
    thin: 'İnce',
    blockEmptyTitle: 'Burada henüz bir şey yok',
    blockEmptyText: 'Bu blokta henüz öğe yok. Sayfanızda görmek için bir tane ekleyin.',
    noItemsTitle: 'Henüz hiç öğeniz yok',
    noItemsText: 'Bu bloğu doldurmak için ilk öğenizi ekleyin.',
  },
  sort: {
    title: 'Sırala',
    search: 'Ara',
    default: 'Varsayılan sıralama',
    dateNew: 'Tarih: Yeniden Eskiye',
    dateOld: 'Tarih: Eskiden Yeniye',
    priceLow: 'Fiyat: Düşükten Yükseğe',
    priceHigh: 'Fiyat: Yüksekten Düşüğe',
    nameA: `İsim: A'dan Z'ye`,
    nameZ: `İsim: Z'den A'ya`,
    popular: 'En popüler',
  },
  emailMenu: {
    broadcasts: 'Yayınlar',
    automations: 'Otomasyonlar',
    templates: 'Şablonlar',
    log: 'Günlük',
    settings: 'Ayarlar',
    noEmails: 'Henüz e-posta yok',
    newBroadcast: 'Yeni Yayınlar',
  },
  aiContent: {
    title: 'İlk AI içeriğinizi oluşturun!',
    text: 'Tüm sosyal medyaya tek seferde içerik planlayın ve yayınlayın!',
    create: 'AI içerik oluştur',
  },
  pageDesign: {
    page: 'Sayfa tasarımı',
    image: 'Görsel',
  },
  toolsMenu: {
    title: 'Araçlar',
    account: 'Hesap',
    instantPages: 'Anlık Sayfalar',
    instantPagesText: 'Hızlı yüklenen bağımsız sayfalar',
    agents: 'Ajanlar',
    agentsText: 'Profilinizi yöneten AI asistanları',
    socialPlanner: 'Sosyal Planlayıcı',
    socialPlannerText: 'İçerik planlama ve ilham',
    emailMarketing: 'E-posta Pazarlama',
    emailMarketingText: 'Kişi listenizi büyütün',
    smartReply: 'Instagram Reply',
    smartReplyText: 'Otomatik yorum ve mesaj gönderin',
    linkShortener: 'Kısa Bağlantılar',
    linkShortenerText: `Uzun URL'leri kısaltın`,
    posts: 'Gönderiler',
    postsText: 'Gönderi oluştur ve yönet',
    blog: 'Blog',
    blogText: 'Blog yazıları oluştur ve yönet',
  },
  insideMenu: {
    planner: 'Planlayıcı',
    aiContent: 'AI İçerik',
    aiPosts: 'AI Gönderiler',
    postIdeas: 'Gönderi Fikirleri',
    contentPlanner: 'İçerik Planlayıcı',
    aiImages: 'AI Görseller',
    brandProjects: 'Brand Identity',
    aiVideo: 'AI Video',
    integrations: 'Entegrasyonlar',
    products: 'Ürünler',
    orders: 'Siparişler',
    payments: 'Ödemeler',
    links: 'Bağlantılar',
    qrCodes: 'QR Kodları',
    adBuilder: 'Reklam Oluşturucu',
  },
  orders: {
    title: 'Siparişler',
    empty: 'Henüz hiç siparişiniz yok',
    all: 'Tüm siparişler',
    shop: 'Mağaza',
    digital: 'Dijital ürünler',
    appointments: 'Randevular',
    services: 'Hizmetler',
    donations: 'Bağışlar',
  },
  discounts: {
    title: 'İndirimler',
    newDiscount: '+ Yeni İndirim',
    code: 'Kod',
    titleCol: 'Başlık',
    type: 'Tür',
    value: 'Değer',
    status: 'Durum',
    used: 'Kullanılan',
    actions: 'İşlemler',
    statusAll: 'Tüm durumlar',
    statusActive: 'Aktif',
    statusExpired: 'Süresi doldu',
    statusScheduled: 'Zamanlanmış',
    statusInactive: 'Pasif',
    searchPlaceholder: 'Kod veya başlığa göre ara...',
    clearFilters: 'Filtreleri temizle',
    emptyTitle: 'Henüz indirim yok',
    emptySubtitle: 'Ürünlerinizde indirim sunmak için ilk promosyon kodunuzu oluşturun',
    createDiscount: 'İndirim Oluştur',
    createTitle: 'İndirim Oluştur',
    editTitle: 'İndirimi Düzenle',
    fieldTitle: 'Başlık',
    fieldTitlePlaceholder: 'örn. Bahar İndirimi',
    fieldCode: 'Kod',
    fieldCodePlaceholder: 'örn. SAVE20',
    generate: 'Oluştur',
    sectionDiscount: 'İndirim',
    fieldType: 'Tür',
    typePercentage: 'Yüzde',
    typeFixed: 'Sabit tutar',
    typeFreeShipping: 'Ücretsiz kargo',
    fieldValue: 'Değer',
    sectionConditions: 'Koşullar (isteğe bağlı)',
    appliesTo: 'Uygulanacak ürünler',
    appliesToAll: 'Tüm ürünler',
    appliesToShop: 'Mağaza',
    appliesToDigital: 'Dijital',
    appliesToCourses: 'Kurslar',
    appliesToServices: 'Hizmetler',
    appliesToEvents: 'Etkinlikler',
    minOrderAmount: 'Min sipariş tutarı ($)',
    maxDiscountAmount: 'Maks indirim tutarı ($) — 0 = sınırsız',
    minItemCount: 'Siparişte min. ürün — 0 = şart yok',
    specificProducts: 'Belirli ürünler — boş = tümü',
    specificProductsPlaceholder: 'Ürün ara...',
    noProductsFound: 'Ürün bulunamadı',
    sectionLimits: 'Limitler',
    usageLimit: 'Toplam kullanım limiti — 0 = sınırsız',
    usageLimitPerUser: 'Müşteri başına limit — 0 = sınırsız',
    sectionSchedule: 'Zamanlama',
    startDate: 'Başlangıç tarihi — boş = şimdi başlar',
    endDate: 'Bitiş tarihi — boş = süresiz',
    active: 'Aktif',
    cancel: 'İptal',
    save: 'İndirimi Kaydet',
    createdSuccess: 'İndirim oluşturuldu',
    updatedSuccess: 'İndirim güncellendi',
    deletedSuccess: 'İndirim silindi',
    loadError: 'İndirimler yüklenemedi',
    saveError: 'İndirim kaydedilemedi',
    deleteError: 'İndirim silinemedi',
    fieldTrigger: 'Nasıl uygulanır',
    triggerCode: 'İndirim kodu',
    triggerAutomatic: 'Otomatik (kodsuz)',
    triggerAutomaticHint:
      'Koşullar sağlandığında ödeme sırasında otomatik uygulanır — kod gerekmez. Sipariş tutarına bağlı indirim için aşağıya minimum sipariş tutarı belirleyin.',
    automaticBadge: 'Otomatik',
  },
  donation: {
    chooseSmiles: 'Emoji seç',
    item: 'Ürün',
    itemTitle: 'Bağış öğesi başlığı',
    price: 'Fiyat',
    thanksMessagePlaceholder: 'Çok teşekkür ederim',
    thanksMessage: 'Teşekkür mesajı',
    thanksMessageCaption: 'Teşekkür mesajı, bağış sonrası takipçilerinize gösterilecek',
    addDonation: 'Bağış ekle',
    addAmount: '+ Tutar ekle',
    buttonTitle: 'Buton başlığı',
    buttonTitleCaption: 'Bağış butonu başlığı',
    acceptDonations: 'Bağış kabul et',
    donationsType: 'Bağışlar',
    tips: 'Bahşişler',
    type: 'Tür',
    addAnotherAmount: '+ Başka tutar ekle',
  },
  blog: {
    empty: 'Henüz blogunuz yok',
  },
  apps: {
    empty: 'Henüz uygulamanız yok',
  },
  payments: {
    title: 'Ödemeler',
    text: 'Henüz hiç işleminiz yok',
    single: 'Tek seferlik ödemeler',
    subscriptions: 'Abonelikler',
    wallet: 'Cüzdan',
    connectPromo: 'Stripe veya PayPal hesabınızı UniLink sayfanıza bağlayın ve tüm ödemeleri cüzdanınıza alın.',
    connectSystem: 'Ödeme sistemini bağla',
    manageCards: 'Kartlarınızı yönetin',
    addNewCard: 'Yeni kart ekle',
    editCard: 'Kart bilgilerini düzenle',
    addCard: 'Kart bilgilerini ekle',
    cardHolder: 'Kart Sahibinin Adı',
    cardHolderNecessary: 'Bu alan zorunludur',
    withdrawalSuccess: 'Para çekme talebiniz başarıyla gönderildi!',
    withdrawalError: 'Bir şeyler ters gitti, lütfen daha sonra tekrar deneyin.',
    change: 'Değiştir',
  },
  store: {
    emptyTitle: 'Henüz hiç ürününüz yok',
    emptyText: 'İlk ürününüzü ekleyerek başlayın',
    emptyButton: 'Ürün ekle',
    createFirstProduct: 'İlk ürününüzü oluşturun',
    startAdding: 'Favori ürünlerinizi, dijital ürünlerinizi veya hizmetlerinizi ekleyerek başlayın. Sunduğunuz her şeyi satabileceğiniz ve tanıtabileceğiniz bir alan.',
    activate: 'Mağazayı Etkinleştir',
    empty: 'Henüz ürününüz yok',
    products: 'Ürünler',
    addProducts: 'Ürün ekle',
    whatDoYouWant: 'Ne satmak istiyorsunuz?',
    externalProduct: `Harici ürün URL'si`,
    createOwnProduct: 'Kendi ürününüzü oluşturun',
    shop: 'Mağaza',
    shopText: 'Fiziksel ve dijital ürünler satın',
    digital: 'Dijital ürünler',
    digitalText: 'Dijital İndirme Satın',
    course: 'Kurs veya Eğitim',
    courseText: 'Web sitesine kurs veya eğitim ekleyin',
    service: 'Hizmetler',
    serviceText: 'Müşterilerinize yönelik hizmetler ekleyin',
    appointment: 'Randevular',
    appointmentText: 'Ziyaretçilerin takviminizden zaman ayırtmasına izin verin',
    event: 'Etkinlikler veya Biletler',
    eventText: 'Etkinlik oluşturun ve kitlenizi davet edin',
    tips: 'İpuçları',
    tipsText: 'Favori içerik üreticilerinize bahşiş bırakın',
    donation: 'Bağışlar',
    donationText: 'Bağış yapın',
    membership: 'Üyelik',
    membershipText: 'Web sitesine üyelik ekleyin',
    links: 'Harici bağlantı',
    linksText: 'Herhangi bir web sitesine harici bağlantı ekleyin',
    coupon: 'Kupon',
    couponText: 'Web siteniz için kupon ekleyin',
    singleProduct: 'Tek Ürün',
    singleProductText: 'Basit bir ödeme ile tek bir ürün satın',
    booking: 'Rezervasyon',
    bookingText: 'Ziyaretçilerin alanlarınızı veya mülklerinizi rezerve etmesine izin verin',
    rental: 'Kiralama',
    rentalText: 'Müsaitlik durumu ve fiyatlandırma ile kiralık ürünleri listeleyin',
    add: 'Ekle',
    manageStore: 'Mağazayı Yönet',
    displayLast: 'Son ürünü göster',
  },
  products: {
    info: 'Bilgi',
    uploadCover: 'Bir kapak fotoğrafı yükleyin, ardından bir başlık ve açıklama ekleyin',
    thumbnail: 'Küçük resim',
    thumbnailTab: {
      intro:
        'İnsanların mağazanızda, ürünü açmadan önce gördüğü kart. Kendine ait fiyatı veya stoğu yoktur — onlar Details’te durur, burada yalnızca kartın hangilerini göstereceğini seçersiniz.',
      cardImage: 'Kart görseli',
      crop: 'Kırpma',
      cropSquare: 'Kare',
      cropPortrait: 'Dikey',
      cropWide: 'Geniş',
      imageHint: 'Boş bırakırsanız kart, Details’teki ilk görseli kullanır. 1200×1200 veya daha büyük en iyi görünür.',
      cardCopy: 'Kart metni',
      cardTitle: 'Kart başlığı',
      sameAsTitle: 'Ürün başlığıyla aynı',
      shortDescription: 'Kısa açıklama',
      shortDescriptionHint: 'Dokunmaya iten tek bir satır. Uzun açıklama Details’te.',
      buttonLabel: 'Buton metni',
      showOnCard: 'Kartta göster',
      showOnCardNote: 'değerler Details’ten gelir — burada yalnızca görünürlük belirlenir',
      editInDetails: 'Details’te düzenle ↗',
      rowPrice: 'Fiyat',
      rowOldPrice: 'Eski fiyat ve indirim',
      rowAvailability: 'Stok durumu',
      rowLabel: 'Etiket',
      inStock: 'Stokta',
      notShown: 'Gösterilmiyor',
    },
    thumbnailError: 'Lütfen bir küçük resim ekleyin',
    title: 'Başlık',
    titleTooltip: 'Ürününüzün adını girin',
    shortDescription: 'Kısa açıklama',
    shortDescriptionTooltip: 'Ürününüzün kısa açıklamasını girin',
    description: 'Açıklama',
    descriptionTooltip: 'Ürününüzün açıklamasını girin',
    descriptionTooltipExtra: 'Ürün özellikleri, türleri, rengi, bedenleri vb. için isteğe bağlı açıklama',
    price: 'Fiyat',
    priceTooltip: 'Ürününüzün fiyatını girin',
    oldPrice: 'Eski fiyat',
    oldPriceTooltip: 'Eski fiyatın üstü çizilecektir',
    category: 'Kategori',
    categoryTooltip: 'Ürününüzün kategorisini seçin',
    image: 'Görsel',
    imageTooltip: 'Ürününüz için görsel yükleyin',
    groups: 'Gruplar',
    rate: 'Puan',
    rateTooltip: 'Ürününüzün puanını girin',
    buttonTitle: 'Buton başlığı',
    buttonTitleTooltip: 'Ürün buton başlığını girin',
    limitQuantity: 'Adet Sınırı',
    itemsLeft: 'Kalan adet',
    itemsLeftTooltip: 'Ürün adetleri',
    trackStock: 'Stok takibi',
    stockQuantity: 'Stok adedi',
    stockQuantityTooltip: 'Mevcut stok adedi. Her ödenen siparişte otomatik olarak azalır; 0 olduğunda ürün artık satın alınamaz.',
    lowStockThreshold: 'Düşük stok uyarısı',
    lowStockThresholdTooltip: 'Stok bu sayıya veya altına düştüğünde bildirim alın.',
    maxOrderQuantity: 'Maksimum sipariş adedi',
    maxOrderQuantityTooltip: 'Bir müşterinin tek siparişte alabileceği maksimum adet. Sınır olmaması için boş bırakın.',
    minOrderQuantity: 'Minimum sipariş adedi',
    minOrderQuantityTooltip: 'Bir müşterinin tek siparişte alması gereken minimum adet. Sınır olmaması için boş bırakın.',
    attachments: 'Ekler',
    addAttachments: 'Ürünlerinize ekler ekleyin',
    addNewAttachment: 'Yeni öğe ekle',
    file: 'Dosya',
    uploadFile: 'Dosya yükle',
    uploadCoverTitle: 'Kapak yükle',
    optionalDescription: 'Ürün özellikleri, türleri, rengi, bedenleri vb. için isteğe bağlı açıklama',
    customReviews: 'Özel yorumlar',
    addCustomReviews: 'Ürünlerinize yorum ekleyin',
    name: 'Ad',
    nameTooltip: 'Müşterinizin adını girin',
    comment: 'Yorum',
    commentTooltip: 'Müşterinizin yorumunu girin',
    rateTooltipCustomer: 'Müşteri puanı',
    imageTooltipCustomer: 'Müşterinizin görselini yükleyin',
    displayPriceOnPreview: 'Önizlemede fiyatı göster',
    displayDetailsOnPreview: 'Önizlemede ayrıntıları göster',
    postOnSocials: 'Sosyal Medyada Paylaş',
    sendAnEmail: 'E-posta Gönder',
    highlights: 'Öne Çıkanlar',
    listProductSetup: 'Ürünü listeleyin ve mağaza bloğunuzu kurun',
    whereToSell: 'Bu ürünü nerede satmak istersiniz?',
    youHaveProducts: '{count} ürününüz var',
    shareThisProduct: 'Bu ürünü paylaş',
    shareAProduct: 'Bir ürün paylaş',
    monetizeWays: `Unilink'te gelir elde etmenin farklı yolları`,
    addProductToProfile: 'Profilinize bir {title} ekleyin',
    productPage: 'Ürün sayfası',
    setUpPayments: 'Ödemelerinizi ayarlayın',
    connectPaymentMethods: `Unilink'te para kazanmaya başlamak için ödeme yöntemlerinizi bağlayın`,
    addPaymentMethod: 'Takipçi ödemelerini almak için bir {type} ödeme yöntemi ekleyin',
    withdrawAttempt: 'Bu, bir borcu tahsil etme girişimidir ve tüm bilgiler bu amaçla kullanılacaktır.',
    withdrawSuccess: 'Para çekme talebiniz başarıyla gönderildi!',
    yourVisitorsPay: 'Ziyaretçileriniz önce ödeme yapacak ve ardından {method} hesabınıza yönlendirilecek',
    emailAddress: 'e-posta adresi',
    calendlyLink: 'Calendly bağlantısı',
    features: 'Özellikler',
    featuresTooltip: 'Vitrin kart düzeninde gösterilen avantajlar listesi',
    featurePlaceholder: 'Avantaj',
    addFeature: 'Özellik ekle',
    pendingReviews: {
      title: 'Bekleyen değerlendirmeler',
      subtitle: 'Alıcı değerlendirmelerini herkese açık olmadan önce onaylayın veya gizleyin',
      empty: 'Moderasyon bekleyen değerlendirme yok.',
      approve: 'Onayla',
      hide: 'Gizle',
    },
  },
  posts: {
    posts: 'Gönderiler',
    title: 'İlk gönderinizi oluşturun',
    description: 'Gönderiler, sohbet otomasyonlarını kolay ve görsel bir şekilde oluşturduğunuz yerdir. Hedeflerinize göre önerdiğimiz bazı otomasyonları deneyin',
    activate: 'Gönderileri Etkinleştir',
    managePosts: 'Gönderileri Yönet',
    postsTab: 'Gönderiler Sekmesi',
    displayLast: 'Son gönderileri göster',
    tabNavigation: 'Sekme gezinme ayarları',
    createFirstPost: 'İlk sosyal gönderinizi oluşturun!',
    autoPostsText: 'Tüm sosyal medya hesaplarınız için tek seferde içerik planlayın ve yayınlayın!',
    createPost: 'Gönderi oluştur',
  },
  messages: {
    title: 'Mesajlar',
    empty: 'Mesaj Yok',
    addText: 'Header bloğuna bir mesaj düğmesi ekleyerek kullanıcıların size kolayca mesaj göndermesine olanak tanıyın.',
    addButton: 'Mesaj düğmesi ekle',
  },
  smartReply: {
    title: 'Instagram Reply',
    clicks: 'tıklama',
    createTitle: `İlk Instagram Reply'inizi oluşturun!`,
    text: `Kitlenizle otomatik olarak bağlantı paylaşmak için Instagram Otomatik DM'lerini kullanın!`,
    createButton: 'Otomatik DM oluştur',
    subtitleComment: 'Bir yoruma yanıt olarak bağlantı içeren otomatik DM',
    subtitleDm: `Bir mesaja veya Hikâye'ye yanıt olarak otomatik DM`,
    ready: 'hazır',
    edit: 'Düzenle',
    stepContentTitle: 'IG içeriği',
    stepContentSub: 'Bir gönderi veya Reel seçin',
    storiesAndDmsSub: `Biri bir Hikâye'ye yanıt verdiğinde veya size yazdığında otomatik DM`,
    stepTriggerTitle: 'Tetikleyici',
    stepTriggerSub: 'Yorumlardaki anahtar kelimeler',
    stepTriggerSubDm: 'Mesajlardaki anahtar kelimeler',
    stepDmTitle: 'DM',
    stepDmSub: 'Otomatik gönderilen mesaj',
    dmSummary: 'Mesaj ayarlandı',
    activatesNow: 'Otomatik yanıt hemen etkinleşir',
    saveAutomation: 'Otomatik yanıtı kaydet',
    savedToast: 'Otomatik yanıt oluşturuldu',
    linkLabel: 'Bağlantı hedefini seçin',
    selectDestination: 'Bir bağlantı, ürün veya makale seçin',
    change: 'Değiştir',
    choose: 'Seç',
    remove: 'Kaldır',
    optional: 'isteğe bağlı',
    buttonText: 'Düğme metni',
    addLink: 'Bağlantı ekle',
    attachLink: 'Bağlantı ekle',
    noLinks: `Henüz bağlantı yok — önce Link in Bio'nuza bir bağlantı ekleyin.`,
    tabLinks: 'Bağlantılar',
    tabProducts: 'Ürünler',
    noProducts: 'Henüz ürün yok — önce mağazanızda bir ürün oluşturun.',
    tabArticles: 'Makaleler',
    noArticles: 'Henüz makale yok — önce bir makale oluşturun.',
    choosePost: 'Bir gönderi veya Reel seçin',
    searchPosts: 'Gönderilerinizde arayın',
    loadingPosts: 'Gönderileriniz yükleniyor…',
    done: 'Bitti',
    oneSelected: '1 gönderi seçildi',
    postSelected: 'Gönderi seçildi',
    noPosts: `Henüz gönderi yok — Instagram'da bir gönderi veya Reel paylaşın.`,
    postsError: 'Gönderiler yüklenemedi. Lütfen tekrar deneyin.',
    reauthTitle: `Bazı DM'ler teslim edilemeyebilir.`,
    reauthText: 'Instagram, hesabı yeniden yetkilendirmenizi gerektiriyor.',
    reconnect: 'Yeniden bağlan',
    statActive: 'Etkin otomasyonlar',
    statDmSent: 'Gönderilen DM · 30 gün',
    statClicks: 'Bağlantı tıklamaları',
    activeReplies: 'Etkin otomatik yanıtlar',
    filterAll: 'Tümü',
    filterActive: 'Etkin',
    filterOff: 'Kapalı',
  },
  businessCards: {
    title: 'Kartvizitler',
    emptyTitle: 'Dijital kartvizitinizi oluşturun',
    emptySubtitle: 'İletişim bilgilerinizi ekleyin, böylece herkes tek dokunuşla telefonuna kaydedebilsin — ardından bir QR kod veya .vcf dosyasıyla paylaşın.',
    createButton: 'Kartvizit oluştur',
    sectionButton: 'Kişiyi kaydet düğmesi',
    sectionButtonSubtitle: '"Kişiyi kaydet" düğmesinin görünümü ve profilinizde nerede göründüğü.',
    showButton: 'Profilimde göster',
    showButtonSubtitle: 'Herkese açık sayfanızda "Kişiyi kaydet" düğmesini görüntüleyin.',
    placement: 'Düğme yerleşimi',
    placementSubtitle: 'Düğmenin nerede görüneceğini seçin.',
    showInHeader: 'Başlıkta göster',
    placementHeader: 'Profil başlığı',
    placementHeaderHint: 'Adınızın ve avatarınızın hemen altında görünür.',
    placementContact: 'İletişim bölümü',
    placementContactHint: 'Kişiler penceresinde görünür.',
    placementBottom: 'Yüzen düğme',
    placementBottomHint: 'Kaydırırken sayfanın altına sabitlenir.',
    none: 'Yok',
    buttonLabel: 'Düğme etiketi',
    buttonLabelSubtitle: 'Düğmede gösterilen metin.',
    saveContact: 'Kişiyi kaydet',
    sectionDetails: 'İletişim bilgileri',
    sectionDetailsSubtitle: 'Bu bilgiler kartvizit kartına kaydedilir.',
    delete: 'Kartviziti sil',
    previewHint: 'Kartınız ziyaretçilere bu şekilde görünür.',
    share: 'Paylaş ve QR',
    shareSubtitle: 'Profilinizi açmak için kodu tarayın veya bağlantıyı paylaşın.',
    download: '.vcf indir',
    copyLink: 'Bağlantıyı kopyala',
    copied: 'Bağlantı kopyalandı!',
    digitalCard: 'Dijital kart',
    physicalCard: 'Fiziksel kart',
    cardStyle: 'Kart stili',
    cardStyleSubtitle: 'Görünen adınızı belirleyin, bir arka plan rengi seçin ve kartınızı bir cüzdana ekleyin.',
    displayName: 'Görünen ad',
    backgroundColour: 'Arka plan rengi',
    addAppleWallet: "Apple Wallet'a ekle",
    addGoogleWallet: "Google Wallet'a ekle",
    nameLabel: 'Ad',
    urlLabel: 'URL',
    walletScanTitle: 'Cüzdanınıza kaydetmek için QR kodunu tarayın',
    walletScanSubtitle: 'Telefonunuzun dijital cüzdanına kaydedilecek.',
    walletUseLink: 'Veya bunun yerine bu bağlantıyı kullanın',
    walletComingSoonTitle: 'Neredeyse hazır',
    walletComingSoon: 'Cüzdan kartları yakında geliyor.',
    done: 'Tamam',
    physicalTitle: 'Fiziksel bir kart sipariş edin',
    physicalSubtitle: 'NFC kartvizitler yakında geliyor.',
    leadCapture: 'Kişileri topla',
    leadCaptureSubtitle: 'Kartınızı alan kişilerin kendi bilgilerini paylaşmasına izin verin — doğrudan Kitlenize.',
    leadCaptureToggle: '«Bilgilerinizi paylaşın» seçeneğini etkinleştir',
    leadCaptureToggleHint: 'Herkese açık kartınızda bir iletişim formu gösterir.',
    leadTag: 'Yeni potansiyel müşterileri etiketle',
    leadTagSubtitle: 'Toplanan her kişi bununla etiketlenir (ör. bir etkinlik veya kampanya adı).',
    leadTagPlaceholder: 'ör. Konferans 2026',
    renewLink: 'Bağlantıyı yenile',
    renewing: 'Yenileniyor…',
    renewConfirm: 'Kart bağlantısını yenilemek istiyor musunuz? Mevcut QR kodunuz ve paylaşılan bağlantılar çalışmayı durduracak.',
    linkRenewed: 'Kart bağlantısı yenilendi',
    scans: '{count} tarama',
  },
  shortLinks: {
    title: 'Kısa Bağlantılar',
    addLink: 'Bağlantı ekle',
    name: 'Ad',
    slug: 'Slug',
    slugTooltip: `Düzenle düğmesine tıklayarak Slug'ı değiştirebilirsiniz`,
    destinationUrl: 'Hedef URL',
    metadata: 'Meta Veri',
    utmTags: 'UTM Etiketleri',
    customizeMetadata: 'Bağlantının meta verilerini özelleştirin',
    metaTitle: 'Başlık',
    metaDescription: 'Açıklama',
    favicon: 'Favicon',
    imagePreview: 'Görsel önizleme',
    addUtm: 'Bağlantıya UTM etiketleri ekleyin (isteğe bağlı)',
    utmCampaign: 'UTM Campaign',
    utmMedium: 'UTM Medium',
    utmSource: 'UTM Source',
    utmTerm: 'UTM Term',
    utmContent: 'UTM Content',
    utmId: 'UTM Id',
    utmPlacement: 'UTM Placement',
    utmCreative: 'UTM Creative',
    pasteLink: 'Uzun bağlantınızı buraya yapıştırın',
    shorten: 'Bağlantıyı kısalt',
    edit: 'Öğe ayrıntılarını düzenle',
  },
  audience: {
    title: 'Kitle',
    total: 'Toplam',
    totalMembers: 'Toplam Kitle Üyeleri',
    totalContacts: 'Toplam Kişi',
    forms: 'Formlar',
    subscribers: 'Aboneler',
    customers: 'Müşteriler',
    noAudienceMembers: 'Kişi Yok',
    emptyAudienceMembers: 'Butona tıklayarak yeni kişiler ekleyin',
    addAudienceMember: 'Kişi Ekle',
    noSubscribers: 'Abone Yok',
    emptySubscribers: `Link in Bio'nuza bloklar ekleyerek yeni aboneler edinin`,
    addDataCollect: 'Veri Toplama bloğu ekle',
    noResponses: 'Yanıt Yok',
    emptyResponses: `Link in Bio'nuza bloklar ekleyerek yeni yanıtlar alın`,
    addFormBlock: 'Form bloğu ekle',
    noCustomers: 'Müşteri Yok',
    emptyCustomers: `Link in Bio'nuza ürün ekleyerek yeni müşteriler edinin`,
    addProduct: 'Ürün Ekle',
    addContactModal: {
      title: 'Yeni kişi ekle',
      name: 'Ad',
      nameTooltip: 'Kişiniz için adı girin',
      email: 'E-posta',
      emailTooltip: 'Kişiniz için e-posta adresini girin',
      phone: 'Telefon',
      phoneTooltip: 'Kişiniz için telefon numarasını girin',
      telegram: 'Telegram',
      telegramTooltip: `Kişiniz için Telegram kullanıcı adını veya URL'sini girin`,
      whatsapp: 'WhatsApp',
      whatsappTooltip: 'Kişiniz için WhatsApp numarasını girin',
      instagram: 'Instagram',
      instagramTooltip: `Kişiniz için Instagram kullanıcı adını veya URL'sini girin`,
      messenger: 'Messenger',
      messengerTooltip: `Kişiniz için Messenger kullanıcı adını veya URL'sini girin`,
      viber: 'Viber',
      viberTooltip: 'Kişiniz için Viber numarasını girin',
      address: 'Adres',
      addressTooltip: 'Kişiniz için adresi girin',
      add: 'Ekle',
    },
    search: {
      search: 'Ara',
      error: 'Arama alanına geçersiz karakter girildi',
      notFound: 'Sonuç bulunamadı',
    },
  },
  auth: {
    logIn: 'Giriş yap',
    logInWith: 'Şununla giriş yap',
    signIn: 'Giriş yap',
    signInWith: 'Şununla kaydol',
    email: 'E-posta',
    password: 'Parola',
    notHaveAccount: 'Hesabınız yok mu?',
    createAccount: 'Yeni Hesap Oluştur',
    createYourAccount: 'Hesabınızı Oluşturun',
    signUp: 'Kaydol',
    haveAccount: 'Zaten bir hesabınız varsa',
    or: 'veya',
    reset: 'Sıfırla',
    resetPassword: 'Şifreyi sıfırla',
    resetTitle: 'Kurtarma bağlantısı e-postanıza gönderildi',
    goToHome: 'Ana sayfaya git',
    byClicking: 'Tıklayarak',
    youAreAgree: `UniLink'in şu koşullarını kabul etmiş olursunuz:`,
    terms: 'Hizmet Şartları',
    andConfirm: 've',
    usagePolicy: 'Kullanım Politikamızı',
    signInGoogle: 'Google ile giriş yap',
    forgotPassword: 'Şifrenizi mi unuttunuz?',
  },
  menu: {
    moreApps: 'Daha fazla uygulama',
    account: 'Hesap',
    more: 'Daha fazla',
    storyWidget: 'Hikayeleri Göm',
    integrations: 'Entegrasyonlar',
    socialAccounts: 'Sosyal hesaplar',
    aiContent: 'AI İçerik',
    aiPosts: 'AI Gönderiler',
    postIdeas: 'Gönderi Fikirleri',
    contentPlanner: 'İçerik Planlayıcı',
    aiImages: 'AI Görseller',
    aiVideo: 'AI Video',
    planner: 'Planlayıcı',
    customers: 'Müşteriler',
    subscribers: 'Aboneler',
    forms: 'Formlar',
    allAudience: 'Tüm kitle',
    payments: 'Ödemeler',
    orders: 'Siparişler',
    products: 'Ürünler',
    events: 'Etkinlikler',
    appointments: 'Randevular',
    discounts: 'İndirimler',
    affiliates: 'Ortaklar',
    instantPages: 'Anında Sayfalar',
    openInNewTab: 'Yeni sekmede aç',
    linkInBio: 'Link in Bio',
    linkInBioApps: 'Link in Bio',
    website: 'Web sitesi',
    store: 'Mağaza',
    audience: 'Kitle',
    emailMarketing: 'E-posta Pazarlama',
    postPlaner: 'Gönderi Planlayıcı',
    posts: 'Gönderiler',
    agents: 'Ajanlar',
    community: 'Topluluk',
    profileHealth: 'Profil Sağlığı',
    socialPlanner: 'Sosyal Planlayıcı',
    shortLinks: 'Kısa Bağlantılar',
    businessCards: 'Kartvizitler',
    views: 'Görüntülenme',
    clicks: 'Tıklama',
    allWebsites: 'Tüm Web Siteleri',
    createNewAccount: 'Yeni hesap oluştur',
    createNewWebsite: 'Yeni profil oluştur',
    tools: 'Araçlar',
    borderGenerator: 'Kenarlık Oluşturucu',
    yourPlan: 'Planınız:',
    upgrade: 'Yükselt',
    accountSettings: 'Hesap ayarları',
    manageWebsites: 'Profilleri yönet',
    updates: 'Güncellemeler',
    autoUpdate: 'Otomatik güncelleme',
    logOut: 'Çıkış yap',
    myPages: 'Sayfalarım',
    design: 'Tasarım',
    heading: 'Başlık',
    analytics: 'Analitik',
    settings: 'Ayarlar',
    open: 'Aç',
    language: 'Dil',
    siteLanguage: 'Herkese açık site dili',
    dashboardLanguage: 'Panel dili',
    movePage: 'Sayfayı Taşı',
    editBlock: 'Bloğu Düzenle',
    renameBlock: 'Bloğu Yeniden Adlandır',
    rename: 'Yeniden Adlandır',
    deleteBlock: 'Bloğu Sil',
    archiveBlock: 'Bloğu Arşivle',
    archive: 'Arşivle',
    scheduleBlock: 'Bloğu Zamanla',
    copyBlock: 'Bloğu Kopyala',
    dublicateBlock: 'Bloğu Çoğalt',
    content: 'İçerik',
    preview: 'Önizle',
    copy: 'Kopyala',
    moveBlock: 'Bloğu Taşı',
    move: 'Taşı',
    edit: 'Düzenle',
    delete: 'Sil',
    schedule: 'Zamanla',
    dublicate: 'Çoğalt',
    smartReply: 'Instagram Reply',
    marketing: 'Pazarlama',
    selectBlocks: 'Blokları seç',
    selectAll: 'Tümünü seç',
    cancelSelection: 'İptal',
    blocksSelected: 'seçildi',
    moveToPage: 'Sayfaya taşı',
    newPage: 'Yeni sayfa',
    openPage: 'Sayfayı aç',
    pageSettings: 'Sayfa ayarları',
    deletePage: 'Sayfayı sil',
    appInBio: 'App in Bio',
    blog: 'Blog',
    publish: 'Yayınla',
    creatorHub: 'Creator Hub',
    qrCodes: 'QR Kodları',
    apps: 'Uygulamalar',
    automations: 'Otomasyonlar',
    messages: 'Gelen Kutusu',
    form: 'Form Yerleştir',
    embedTools: 'Araç Yerleştir',
    adBuilder: 'Reklam Oluşturucu',
    emailSignatures: 'E-posta İmzaları',
    virtualBackgrounds: 'Sanal Arka Planlar',
    adsCampaigns: 'Reklam Yöneticisi',
    thumbnail: 'Küçük resim',
    buildFromReference: 'Referanstan oluştur',
  },
  modal: {
    addInstagram: 'Instagram Ekle',
    addYourInstagram: 'Instagram hesabınızı ekleyin',
    cropYourAvatar: 'Avatarınızı kırpın',
    removeSite: 'Siteyi kaldırmak istediğinizden emin misiniz?',
    areYouSure: 'Şunu yapmak istediğinizden emin misiniz:',
    areYouSureDelete: 'Bu bölümü silmek istediğinizden emin misiniz?',
    areYouSureArchive: 'Bu bloğu arşivlemek istediğinizden emin misiniz?',
    areYouSurePermanentDelete: 'Bu bloğu kalıcı olarak silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    remove: 'kaldır',
    site: 'site',
    removeAccountText: 'hesabınızı kaldır',
    moveBlock: 'Bloğu başka bir sayfaya taşı',
    moveBlockText: 'Bu, bloğu başka bir sayfanın en altına taşıyacaktır. Daha sonra bloğu yeni sayfada yeniden düzenleyebilirsiniz',
    profileTitle: 'Profil resmini değiştir',
    profileText: 'Cihazınızdan bir görsel veya GIF seçin.',
    profileAvatar: 'Profil Avatarı',
    addProfilePicture: 'Profil Resmi Ekle',
    storiesTitle: 'Hikayeler',
    storiesText: 'Günlük anlarınızı paylaşın.',
    thoughtsTitle: 'Düşünceler',
    thoughtsText: 'Düşüncelerinizi paylaşın.',
    accountPageDescription: 'Burası hesap sayfanız; sayfanızın görünümünü özelleştirebilir, farklı özellik blokları ekleyebilir ve daha fazlasını yapabilirsiniz.',
  },
  modalSubscribe: {
    plan: 'Plan',
    usdMonth: 'USD/ay',
    sites: 'Siteler',
    sitesMuch: 'Siteler',
    notification: 'Bildirimler',
    noNotification: 'Henüz bildirim yok',
    inCategory: 'Bu kategoride henüz',
    categoryYet: 'öğe yok.',
    externalPixels: 'Harici Pixeller',
    parameters: 'parametreler',
    analyticsReports: 'Analiz ve Raporlar',
    noUniLinkLogo: 'UniLink Logosu Yok',
    inProfile: 'profilde',
    verifiedBadge: 'Onaylı rozet',
    your: 'Sizin',
    customDomain: 'özel Alan adınız',
    emailMarketing: 'E-posta Pazarlama',
    liveSupport: 'Canlı Destek',
    dataSecured: 'Veriler PCI DSS standardına uygun şekilde güvence altına alınmıştır',
    thankYou: 'İlginiz için teşekkür ederiz. Sizinle yakında iletişime geçeceğiz.',
    socialMediaScheduler: 'Sosyal Medya Planlayıcı',
    featureRequest: 'Özellik talebi',
    markAllRead: 'Tümünü okundu işaretle',
    currentPlan: 'Mevcut Plan',
    features: 'Özellikler',
  },
  buttons: {
    upgrade: 'Planı Yükselt',
    buyProPlan: 'Pro Plan Satın Al',
    continue: 'Devam et',
    skip: 'Atla',
    cancel: 'İptal',
    confirm: 'Onayla',
    back: 'Geri',
    save: 'Kaydet',
    add: 'Ekle',
    added: 'Eklendi',
    done: 'Tamam',
    ok: 'Tamam',
    edit: 'Düzenle',
    delete: 'Sil',
    remove: 'Kaldır',
    setAsDefault: 'Varsayılan olarak ayarla',
    subscribeNow: 'Şimdi Abone Ol',
    yes: 'Evet',
    preview: 'Önizleme',
    generate: 'Oluştur',
    changePassword: 'Şifreyi değiştir',
    deleteAccount: 'Hesabı sil',
    removeAccount: 'Hesabı kaldır',
    deleteProfile: 'Profili sil',
    addBlock: 'Blok ekle',
    copyLink: 'Bağlantıyı kopyala',
    active: 'Aktif',
    update: 'Güncelle',
    updatePro: 'Planı Yükselt',
    prev: 'Önceki',
    next: 'Sonraki',
    uploadImage: 'Görsel yükle',
    uploadVideo: 'Video yükle',
    loadMore: 'Daha fazla yükle',
    uploadProductImage: 'Ürün görseli yükle',
    claim: 'Talep et',
    removeSite: 'Siteyi kaldır',
    move: 'Taşı',
    addButton: 'Buton ekle',
    actionButton: 'Eylem butonu',
    directMessage: 'Doğrudan mesaj',
    subscribe: 'Abone ol',
    button: 'Buton',
    generateWithAI: 'Yapay zeka ile oluştur',
    cta: 'CTA',
    cart: 'Sepet',
    direct: 'Doğrudan',
    follow: 'Takip et',
    addNewItem: 'Yeni öğe ekle',
  },
  support: {
    liveSupport: 'Canlı Destek',
    response: 'Çalışma saatleri içinde (08.00 - 22.00) GMT+3 genellikle 1 dakika içinde yanıt veriyoruz',
    founder: 'Denys Bilozor',
    ceo: `UniLink Kurucusu ve CEO'su`,
  },
  wizard: {
    createNewProfile: 'Yeni bir profil oluştur',
    createProfile: 'Profil Oluştur',
    continue: 'Devam et',
    tellUs: 'Kendinizden bahsedin',
    addSocialLinks: 'Tüm sosyal ağları ekleyin, biz de onları veritabanınızda gösterelim',
    addMoreLinks: 'Daha Fazla Bağlantı Ekle',
    addLink: 'Bağlantı Ekle',
    selectCategory: 'Sizi en iyi tanımlayan bir kategori seçin:',
    chooseTemplate: 'Şablon seçin',
    skip: 'Atla',
    step: 'Adım',
    of: '/',
    yourName: 'Adınız',
    search: 'Ara',
    blog: 'Blog',
    creator: 'İçerik Üreticisi',
    music: 'Müzik',
    events: 'Etkinlikler',
    esoteric: 'Ezoterik',
    fashion: 'Moda',
    influencer: 'Influencer',
    food: 'Yemek',
    smallBusiness: 'Küçük İşletme',
    marketing: 'Pazarlama',
    education: 'Eğitim',
    socialMedia: 'Sosyal Medya',
    coaching: 'Koçluk',
    ecommerce: 'E-ticaret',
    healthAndFitness: 'Sağlık ve Fitness',
    beautyWellness: 'Güzellik ve Wellness',
  },
  billing: {
    back: 'Geri',
    findPlan: 'Size uygun planı bulun',
    changeAnytime: 'İstediğiniz zaman değiştirebilirsiniz.',
    subtitle: 'İstediğiniz zaman yükseltin, düşürün veya iptal edin.',
    currentPlan: 'Mevcut plan',
    mostPopular: 'En popüler',
    upgradeTo: '{plan} planına yükselt',
    includes: 'İçerir:',
    everythingIn: '{plan} içindeki her şey, ayrıca:',
    secure: 'Ödemeler PCI DSS standardına uygun olarak güvenceye alınır.',
  },
  field: {
    fullName: 'Ad Soyad',
    username: 'kullanıcı adı',
    addValue: 'Değer ekle',
    newValue: 'Yeni değer',
    placeholderDefault: 'Metin, sayılar, semboller vb.',
    addInstagramUsername: 'Instagram kullanıcı adı ekle',
    nameDefault: 'Jhon',
    enterYourLink: 'Bağlantınızı girin',
    searchImage: 'Görsel ara',
    pasteLink: 'Bağlantıyı yapıştır',
    pasteLinkTip: 'Herhangi bir web sayfasına bağlantı ekleyin',
    searchGIFs: 'GIF ara',
    searchIcons: 'Simge ara',
    searchVideo: 'Video ara',
    search: 'Ara',
    insertURL: 'URL ekle',
    writeYourDescription: 'Açıklamanızı yazın',
    headerCTAbutton: 'Başlık, CTA düğmesi',
    enterTitle: 'Başlık girin',
    enterDescription: 'Açıklama girin',
    enterURL: 'Canonical URL girin',
  },
  tooltip: {
    addImage: 'Görsel ekle',
    labelModalTitle: 'Etiket ayarları',
    addLabel: '+ Etiket ekle',
    label: 'Etiket',
    labelCaption: 'Etiket girin',
    labelText: 'Etiket metni',
    labelTextCaption: 'Etiket metnini girin',
    labelTextPlaceholder: 'Etiket',
    labelUrl: `Etiket URL'si`,
    labelUrlCaption: `Etiket URL'sini girin`,
    labelUrlPlaceholder: 'https://example.com',
    noLabel: 'Etiket yok',
    colorFrom: 'Başlangıç rengi',
    colorTo: 'Bitiş rengi',
    highlight: 'Vurgu',
    firstName: 'Ad',
    firstNameCaption: 'Adınızı girin',
    lastName: 'Soyad',
    lastNameCaption: 'Soyadınızı girin',
    jobTitle: 'Unvan',
    jobTitleCaption: 'Unvanınızı girin',
    organization: 'Kuruluş',
    organizationCaption: 'Kuruluşunuzu girin',
    email: 'E-posta',
    emailCaption: 'E-postanızı girin',
    workPhone: 'İş telefonu',
    workPhoneCaption: 'İş telefonunuzu girin',
    mobilePhone: 'Cep telefonu',
    mobilePhoneCaption: 'Cep telefonunuzu girin',
    website: 'Web sitesi',
    websiteCaption: 'Web sitenizi girin',
    information: 'Bilgi',
    informationCaption: 'Bilgilerinizi girin',
    streetAddress: 'Açık adres',
    streetAddressCaption: 'Açık adresinizi girin',
    city: 'Şehir',
    cityCaption: 'Şehrinizi girin',
    state: 'İl',
    stateCaption: 'İlinizi girin',
    postalCode: 'Posta kodu',
    postalCodeCaption: 'Posta kodunuzu girin',
    country: 'Ülke',
    countryCaption: 'Ülkenizi girin',
    titleColor: 'Başlık rengi',
    titleColorCaption: 'Başlık rengini değiştirebilirsiniz',
    fontFamily: 'Yazı tipi ailesi',
    fontFamilyCaption: 'Yazı tipi ailesini değiştirebilirsiniz',
    fontSize: 'Yazı tipi boyutu',
    fontSizeLabel: 'Etiket yazı tipi boyutu',
    fontSizeCaption: 'Yazı tipi boyutunu değiştirebilirsiniz',
    fontSelect: 'Yazı tipi',
    fontSelectCaption: 'Bir yazı tipi seçin',
    imageMargin: 'Görsel kenar boşluğu',
    profilePicture: 'Profil fotoğrafı',
    profilePictureCaption: 'Profil fotoğrafınızı değiştirin',
    pictureSize: 'Fotoğraf boyutu',
    pictureSizeCaption: 'Fotoğraf boyutunu değiştirebilirsiniz',
    title: 'Başlık',
    titleCaption: 'Bir başlık girin',
    blockCaption: 'Bloğunuzun başlığını girin',
    titlePageCaption: 'Sayfanızın başlığını girin',
    templates: 'Şablonlar',
    templatesCaption: 'Sayfanız için bir şablon seçin',
    background: 'Arka plan',
    backgroundColor: 'Arka plan rengi',
    textBackground: 'Metin Arka Planı',
    textBackgroundCaption: 'Metin arka plan rengini seçin',
    textColor: 'Metin Rengi',
    textColorCaption: 'Metin rengini seçin',
    gradientBackground: 'Degrade Arka Plan',
    gradientColor: 'Degrade Rengi',
    BackgroundType: 'Tür',
    backgroundSource: 'Arka plan kaynağı',
    backgroundSourceCaption: 'Arka plan kaynağını seçin',
    backgroundStyle: 'Arka plan stili',
    backgroundStyleCaption: 'Arka plan stilini seçin',
    backgroundStylesNormal: 'Normal',
    backgroundStylesGlass: 'Cam',
    backgroundStylesOutline: 'Çerçeve',
    backgroundTypeCaption: 'Arka plan türünü seçin',
    color: 'Renk',
    colorTooltip: 'Rengi değiştirebilirsiniz',
    backgroundOpacityTooltip: 'Arka plan saydamlığını ayarlamak için kaydırıcıyı sürükleyin',
    backgroundBlur: 'Arka plan bulanıklığı',
    backgroundBlurCaption: 'Arka planı bulanıklaştırmak için kaydırıcıyı sürükleyin',
    backgroundBrightness: 'Arka plan parlaklığı',
    backgroundBrightnessCaption: 'Arka plan parlaklığını değiştirmek için kaydırıcıyı sürükleyin',
    backgroundContrast: 'Arka plan kontrastı',
    backgroundContrastCaption: 'Arka plan kontrastını değiştirmek için kaydırıcıyı sürükleyin',
    color1: 'Renk 1',
    color2: 'Renk 2',
    colorCaption: 'Sayfanızın rengini girin',
    gradient: 'Degrade',
    image: 'Görsel',
    photo: 'Fotoğraf',
    gif: 'GIF',
    animation: 'Animasyon',
    video: 'Video',
    hexColor: 'Hex renk',
    direction: 'Yön',
    gradientDirection: 'Degrade yönü',
    directionCaption: 'Degrade yönünü ayarlamak için kaydırıcıyı sürükleyin',
    offset: 'Ofset',
    gradientOffset: 'Degrade ofseti',
    offsetCaption: 'Gradyan ofsetini ayarlamak için kaydırıcıyı sürükleyin',
    backgroundDarkness: 'Arka plan koyuluğu',
    backgroundDarknessCaption: 'Arka plan görselini koyulaştırmak için kaydırıcıyı sürükleyin',
    uploadVideo: 'Video yükle',
    uploadFile: 'Dosya yükle',
    uploadVideoCaption: 'Sayfa arka planınızın videosu',
    linkToVideo: 'Video bağlantısı',
    linkToVideoCaption: 'Videoya bağlantı ekle',
    videoWithSound: 'Sesli video',
    videoWithSoundCaption: 'Videoyu sesli oynat',
    fonts: 'Yazı tipleri',
    fontWeight: 'Yazı tipi kalınlığı',
    fontWeightCaption: 'Kaderini seçmek için tıkla',
    preloader: 'Ön yükleyici',
    preview: 'Önizleme',
    hideLogo: 'UniLink logosunu gizle',
    cover: 'Kapak',
    coverCaption: 'Kapağı değiştir',
    coverCaptionHeader: 'Üst kapağa görsel veya video ekle',
    pageNavigation: 'Sayfa gezinmesi',
    websiteNavigation: 'Sekme gezinmesi',
    backgroundOpacity: 'Arka plan opaklığı',
    backgroundOpacityCaption: 'Buton arka planı opaklığı için kaydırıcıyı sürükleyin',
    borderRadius: 'Kenar yuvarlaklığı',
    borderRadiusCaption: 'Kenar yuvarlaklığını ayarlamak için kaydırıcıyı sürükleyin',
    heightTabs: 'Sekme yüksekliği',
    heightTabsCaption: 'Sekme yüksekliğini ayarlamak için kaydırıcıyı sürükleyin',
    backgroundShadow: 'Arka plan gölgesi',
    backgroundShape: 'Arka plan şekli',
    backgroundBorder: 'Arka plan kenarlığı',
    opacity: 'Opaklık',
    opacityCaption: 'Opaklığı ayarlamak için kaydırıcıyı sürükleyin',
    shape: 'Şekil',
    shapeCaption: 'Şekil ayarla',
    text: 'Metin',
    textCaption: 'Metin girin',
    textSize: 'Metin boyutu',
    textSizeCaption: 'Metin boyutunu ayarlamak için kaydırıcıyı sürükleyin',
    additionalText: 'Ek metin',
    username: 'Kullanıcı adı',
    currency: 'Para birimi',
    language: 'Dil',
    timeZone: 'Saat dilimi',
    websiteNiche: 'Web sitesi nişi',
    websiteNicheCaption: 'Web sitesi nişinizi girin',
    renameCaption: 'Blok başlığını yeniden adlandır',
    description: 'Açıklama',
    descriptionCaption: 'Bir açıklama girin',
    actionButton: 'Eylem butonu',
    actionButtonCaption: 'Harekete Geçirici Mesaj butonu, ziyaretçileri eyleme geçmeye motive eder',
    animationDirection: 'Animasyon yönü',
    animationDirectionCaption: 'Animasyon yönünü seçin',
    buttonTitle: 'Buton başlığı',
    buttonTitleCaption: 'Buton başlığını girin',
    buttonUrl: `Buton URL'si`,
    buttonUrlCaption: 'URL yeni bir pencerede açılır',
    imageSize: 'Görsel boyutu',
    imageSizeCaption: 'Görsel boyutunu ayarlamak için kaydırıcıyı sürükleyin',
    view: 'Görünüm',
    viewCaption: 'Bir görünüm seçin',
    margin: 'Kenar boşluğu',
    marginCaption: 'Öğenin hem üst hem alt kısmına kenar boşluğu eklemek için kaydırıcıyı sürükleyin',
    separateTopBottom: 'Üst / Alt',
    padding: 'İç boşluk',
    paddingCaption: 'Öğenin üst ve alt kısmına iç boşluk eklemek için kaydırıcıyı sürükleyin',
    fullWidth: 'Tam genişlik',
    lineHeight: 'Satır yüksekliği',
    lineHeightCaption: 'Satır yüksekliğini değiştirebilirsiniz',
    button: 'Düğme',
    titleSize: 'Başlık boyutu',
    titleSizeCaption: 'Başlık boyutunu değiştirebilirsiniz',
    titleLineHeight: 'Başlık satır yüksekliği',
    titleLineHeightCaption: 'Metne daha fazla tasarım çözümü getirmek için başlık satır yüksekliğini özelleştirin',
    layout: 'Düzen',
    layoutCaption: 'İstediğiniz başlık düzenini oluşturun',
    layoutAlign: 'Düzen hizalaması',
    alignText: 'Metni hizala',
    align: 'Hizala',
    alignCaption: 'Hizalama seçin',
    position: 'Konum',
    positionCaption: 'Konum seçin',
    width: 'Genişlik',
    widthCaption: `Banner'ınızın genişliğini seçin`,
    nameHeader: 'Ad',
    nameCaption: 'Hesabınızın adını girin',
    shortBio: 'Kısa biyografi',
    shortBioCaption: 'Hesabınızın kısa biyografisini girin',
    externalLink: 'Harici bağlantı',
    externalLinkCaption: 'Hesabınıza harici bağlantı girin',
    location: 'Konum',
    locationCaption: 'Konumunuzu girin',
    locationMap: 'Konum haritası',
    locationMapCaption: `Konumunuzun URL'sini girin`,
    rightIcon: 'Sağ ikon',
    rightIconCaption: 'Bu ikon düğmenin sağ tarafında görünecek',
    buttons: 'Düğmeler',
    buttonsCaption: 'İşlem düğmeleri ekle',
    nameLogo: 'Ad logosu',
    nameLogoCaption: 'Adınız için logo yükleyin',
    buttonText: 'Düğme metni',
    buttonTextCaption: 'Düğmenizin adını girin',
    buttonColor: 'Düğme rengi',
    buttonColorCaption: 'Düğme için renk seçin',
    buttonColorCTACaption: 'CTA düğmesi için arka plan rengi seçin',
    cartColor: 'Sepet rengi',
    cartColorCaption: 'Sepet için arka plan rengi seçin',
    ctaButton: 'CTA düğmesi',
    ctaButtonCaption: 'Bu ikon düğmenin sağ tarafında görünecek',
    style: 'Stil',
    socialIconsStyleCaption: 'Sosyal ikonlarınızın stilini seçebilirsiniz',
    socialIconsShape: 'Sosyal ikon şekli',
    socialIconsShapeCaption: 'Sosyal ikon şeklini seçebilirsiniz',
    headerTextColorCaption: 'Başlık metin rengini seçebilirsiniz',
    pictureShape: 'Resim şekli',
    pictureShapeCaption: 'Profil resmi şeklini seçebilirsiniz',
    socialLinks: 'Sosyal bağlantılar',
    socialLinksCaption: 'Sizinle müşterileriniz arasında tek tıkla hızlı bağlantı için sosyal bağlantı düğmeleri ekleyin',
    URL: 'URL',
    URLCaption: 'URL adresini girin',
    heading: 'Başlık',
    headingTitle: 'Başlık',
    headingTitleCaption: 'Başlığı girin',
    headingDescription: 'Başlık açıklaması',
    headingDescriptionCaption: 'Başlık açıklamasını girin',
    headingImage: 'Başlık görseli',
    headingImageCaption: 'Başlığınız için görsel yükleyin',
    headingPosition: 'Başlık konumu',
    headingInsideBlock: 'Blok içinde',
    headingOutsideBlock: 'Blok dışında',
    headingDivider: 'Başlık ayırıcı',
    canonicalURL: 'Kanonik URL',
    seo: 'SEO',
    seoCaption: 'Ürününüzü meta SEO etiketleriyle özelleştirin',
    themes: 'Temalar',
    brandColors: 'Brand Kit',
    applyBrandColors: 'Profile Uygula',
    syncBlocks: 'Tüm Blokları Senkronize Et',
    brandColorsApplied: 'Marka renkleri uygulandı',
    generatedPalette: 'Oluşturulan Palet',
    applying: 'Uygulanıyor...',
    syncing: 'Senkronize ediliyor...',
    backgroundType: 'Arka plan türü',
    palettes: 'Paletler',
    previewTitle: 'Başlık',
    previewTitleCaption: 'Önizleme başlığını girin',
    previewDescription: 'Açıklama',
    previewDescriptionCaption: 'Önizleme açıklamasını girin',
    previewButton: 'Buton metni',
    previewButtonCaption: 'Önizleme buton metnini girin',
    previewLabel: 'Etiket metni',
    previewLabelCaption: 'Önizleme etiket metnini girin',
    previewThumbnail: 'Küçük resim',
    previewThumbnailCaption: 'Önizleme küçük resmini yükleyin',
    myTemplates: 'Şablonlarım',
    myTemplatesEmpty: 'Henüz şablon yok. Daha sonra yeniden kullanmak için mevcut sayfa tasarımınızı kaydedin.',
    saveAsTemplate: 'Şablon Olarak Kaydet',
    saveCurrentAsTemplate: 'Mevcut olanı şablon olarak kaydet',
    templateSaved: 'Şablon kaydedildi',
    templateApplied: 'Şablon uygulandı',
    buildFromReference: 'Referanstan oluştur',
    templateAppliedCount: 'Şablon uygulandı — {n} blok eklendi',
    searchTemplates: 'Şablon ara…',
    favorites: 'Favoriler',
    previewLive: 'Canlı önizle',
    previewingTemplate: 'Önizleniyor',
    exitPreview: 'Çık',
    templateKind: 'Neler dahil edilsin',
    publish: 'Yayınla',
    unpublish: 'Yayından kaldır',
    templatePublished: 'Şablon yayınlandı',
    templateUnpublished: 'Şablon yayından kaldırıldı',
    discoverTemplates: 'Topluluğu keşfet',
    discoverSubtitle: `UniLink'teki diğer içerik üreticileri tarafından yayınlanan ücretsiz şablonlar.`,
    discoverEmpty: 'Henüz herkese açık şablon yok — ilk yayınlayan siz olun.',
    pricing: 'Fiyatlandırma',
    fontRoles: {
      heading: 'Başlık',
      subtitle: 'Alt başlık',
      body: 'Genel',
    },
  },
  table: {
    clicks: 'Tıklamalar',
    signups: 'Kayıtlar',
    views: 'Gösterimler',
    orderNumber: 'Sipariş numarası',
    amount: 'Tutar',
    credits: 'Kredi',
    invoice: 'Fatura',
    email: 'E-posta',
    card: 'Kart',
    currency: 'Para birimi',
    name: 'Ad',
    contact: 'İletişim',
    optIn: 'Abonelik',
    notes: 'Notlar',
    address: 'Adres',
    date: 'Tarih',
    action: 'İşlem',
    custom: 'Özel',
    status: 'Durum',
    tags: 'Etiketler',
    view: 'Görüntüle',
    remove: 'Kaldır',
    sendEmail: 'E-posta Gönder',
    details: 'Detaylar',
    purchases: 'Satın Alımlar',
    order: 'Sipariş',
    money: 'Para',
    type: 'Tür',
    orderCode: 'Sipariş kodu',
  },
  settings: {
    title: 'Ayarlar',
    settings: 'ayarlar',
    accountSettings: 'Hesap ayarları',
    email: 'E-posta',
    subscription: 'Abonelik',
    billingHistory: 'Fatura geçmişi',
    dueTo: 'Bitiş tarihi',
    subscriptionDueTo: 'Abonelik bitiş tarihi',
    cancelSubscription: 'Aboneliği iptal et',
    cancelSubscriptionConfirm: 'Aboneliğinizi iptal etmek istediğinizden emin misiniz?',
    subscriptionCancelled: 'Aboneliğiniz iptal edildi. Planınız fatura döneminin sonuna kadar aktif kalacaktır.',
    subscriptionCancelError: 'Abonelik iptal edilemedi. Lütfen destek ekibiyle iletişime geçin.',
    deleteFirst: 'Şunu kalıcı olarak sil:',
    deleteSecond: 've tüm verileri. Bu işlem geri alınamaz.',
    account: {
      title: 'Hesap',
      usernameNotAvailable: 'Kullanıcı adı kullanılamıyor',
      setupCustomDomain: 'Özel alan adı kur',
      subtitle: 'Hesap e-postası, faturalandırma, parola ve API anahtarı',
    },
    profile: {
      title: 'Profil',
      usernameNotAvailable: 'Kullanıcı adı kullanılamıyor',
      setupCustomDomain: 'Özel alan adı kur',
      subtitle: 'Kullanıcı adı, dil, para birimi ve saat dilimini yönet',
      category: 'Kategori',
      categoryCaption: 'Profilinizin kategorisini girin',
      usernameDesc: 'Herkese açık kullanıcı adınız',
      currencyDesc: 'Kazançlar ve ödemeler için kullanılır',
      languageDesc: 'Ziyaretçilerinize gösterilen dil',
      timeZoneDesc: 'Zamanlama ve analizler için',
      categoryDesc: 'Profilinizi en iyi tanımlar',
      privateProfile: 'Gizli profil',
      privateProfileDesc: 'Yalnızca onaylı takipçiler profilinizi görebilir',
    },
    aiassistant: {
      title: 'AI Asistan',
      subtitle: 'Daha iyi ve kişiselleştirilmiş yanıtlar için AI asistanınızı özelleştirin',
      titleText: `Daha alakalı yanıtlar için AI'nın sizi tanımasına yardımcı olun`,
      customAiTitle: 'Özel talimatlar',
      customAiPlaceholder: 'AI için özel talimatlar ekleyin...',
      customAiDescription: 'Bu talimatlar AI ile yapılan her sohbete uygulanacaktır',
      nicknameTitle: 'AI size nasıl hitap etsin?',
      nicknamePlaceholder: 'Takma ad',
      titleBio: 'Biyografi/ Açıklama',
      bioPlaceholder: 'Bize kendinizden biraz bahsedin...',
      occupation: 'Ne iş yapıyorsunuz?',
      occupationPlaceholder: `örn. University of Waterloo'da Mühendislik öğrencisi`,
      aboutYouTitle: 'Hakkınızda',
      aboutYouTooltip: 'AI asistanınıza kendinizden biraz bahsedin',
      locationTitle: 'Konum',
      locationPlaceholder: 'örn. Kiev, Ukrayna',
      categoryTitle: 'Kategori',
    },
    notifications: {
      title: 'Bildirimler',
      subtitle: 'Yeni ziyaretçi e-postaları ve siparişler hakkında bildirimleri ayarlayın',
      text: 'Yeni müşteri e-postası ve siparişleri hakkında bildirim almak için mesajlaşma uygulamalarını bağlayın',
      setUpWebhooks: `Webhook'ları Webhooks bölümünden ayarlayın`,
      save: 'Kaydet',
      connect: 'BAĞLAN',
      disconnect: 'BAĞLANTIYI KES',
      webhook: 'Webhook',
      emailSubmit: 'Veri toplama gönderimi',
      formSubmit: 'Form gönderimi',
      showSubmit: 'Mağaza gönderimi',
      digitalSubmit: 'Dijital gönderim',
      appointmentSubmit: 'Randevu gönderimi',
      requestSubmit: 'Hizmet gönderimi',
      donationSubmit: 'Bağış gönderimi',
      email: 'E-posta',
      settings: 'ayarlar',
      cartSubmit: 'Sepet gönderimi',
      linkClick: 'Bağlantı tıklaması',
      contactClick: 'İletişim tıklaması',
      all: 'Tümü',
      updates: 'Güncellemeler',
      messages: 'Mesajlar',
      opportunities: 'Fırsatlar',
      insights: 'İçgörüler',
      activity: 'Etkinlik',
      system: 'Sistem',
      news: 'Haberler',
      more: 'Daha fazla göster',
      less: 'Daha az göster',
      connectedAccounts: 'Bağlı hesaplar',
      addEmailAccount: 'E-posta hesabı ekle',
    },
    paymentSystem: {
      title: 'Ödeme sistemi',
      subtitle: 'Stripe veya PayPal üzerinden ödemeleri ayarlayın',
      text: 'İşlem ücretlerini görüntüle',
      connected: 'Bağlandı',
      active: 'Web sitesinde ödeme kabul edin',
      pending: 'Beklemede',
      disconnect: 'Bağlantıyı kes',
      connect: 'Bağlan',
      add: 'Ekle',
      ofYourAccount: 'hesabınızın',
      save: 'Kaydet',
    },
    shop: {
      title: 'Mağaza',
      subtitle: 'Kategori ve özellik ayarlama',
      label: {
        title: 'Etiketler',
        subtitle: 'Ürün kartlarına etiket ekleyin',
        addValue: 'Değer ekle',
        save: 'Kaydet',
        value: 'Değer',
        enterTitle: 'Başlık girin',
        maximum: 'Maksimum değer sayısı 5 olabilir',
        add: 'Ekle',
        edit: 'Düzenle',
        labels: 'Etiketler',
      },
      category: {
        title: 'Kategoriler',
        subtitle: 'Ürünlerinize kategori ekleyin',
        addCategory: 'Kategori ekle',
        save: 'Kaydet',
        maximum: 'Maksimum sayı şu olabilir',
        editTitle: 'Kategori',
        name: 'Ad',
        namePlaceholder: 'Kategoriyi girin',
        visibility: 'Görünürlük',
        visible: 'Görünür',
        hidden: 'Gizli',
        description: 'Açıklama',
        descriptionHint: 'Açıklama 100 karakterden az olmalıdır',
        descriptionPlaceholder: 'Kısa bir açıklama ekleyin',
        cover: 'Kapak',
        view: 'Görüntüle',
        share: 'Paylaş',
        linkCopied: 'Bağlantı kopyalandı',
        saveFirst: 'Önce kategoriyi kaydedin',
        moveOut: 'Dışarı taşı',
      },
      property: {
        title: 'Özellik',
        subtitle: 'Ürünlerinize özellik ekleyin',
        addProperties: 'Özellik ekle',
        properties: 'Özellikler',
        type: 'Tür',
        typeTooltip: 'Özelliklerinizin türü',
        titleModal: 'Başlık',
        titleModalTooltip: 'Özelliklerinizin adı',
        enterTitle: 'Başlığı girin',
        value: 'Değer',
        addValue: 'Değer ekle',
        maximum: 'Maksimum değer sayısı şu olabilir',
        save: 'Kaydet',
        cancel: 'İptal',
        remove: 'Kaldır',
        addPropertyToItem: 'Ürüne özellik ekle',
        add: 'Ekle',
        edit: 'Düzenle',
        propertiesSmall: 'özellikler',
        required: 'Zorunlu',
        requiredTooltip: 'Satın alma için zorunlu özellikleri ayarla',
        selectAll: 'Tümünü seç',
      },
      actionButtons: {
        contentTab: 'İçerik',
        designTab: 'Tasarım',
        buttonTitle: 'Buton başlığı',
        buttonColor: 'Buton rengi',
        cancel: 'İptal',
        save: 'Kaydet',
        maxChars: 'En fazla {count} karakter',
        minChars: 'En az {count} karakter',
        enterTitle: 'Bir buton başlığı girin',
        contactTooltip: 'Müşterilerin size ulaşmasının tek yolu: e-posta, mesaj veya form',
        contactNotConfigured: 'Müşterilerin size nasıl ulaşacağını ayarlayın',
        methodEmail: 'E-posta ile mektup',
        methodMessenger: 'Mesajlaşma uygulaması',
        methodForm: 'Talep formu',
        enterAddress: 'Bir adres girin',
        invalidAddress: 'Geçersiz adres',
        enterContact: 'Numara veya kullanıcı adı girin',
        summaryFields: '{count} alan',
        dragToReorder: 'Sıralamak için sürükleyin',
        fieldName: 'Alan adı',
        fieldRequired: 'Zorunlu',
        deleteField: 'Alanı sil',
        enterFieldName: 'Alan adı girin',
        addAtLeastOneField: 'En az bir alan ekleyin',
        maxFields: 'En fazla {count} alan',
        typeText: 'Metin',
        typeEmail: 'E-posta',
        typePhone: 'Telefon',
        preorderTooltip: 'Bu ürün için ön sipariş formu',
        preorderRowHint: 'Alıcının dolduracağı alanlar — düzenlemek için açın',
        saveFailed: 'Kaydedilemedi. Tekrar deneyin.',
        preorderNotConfigured: 'Ön sipariş formunu ayarlayın',
        enableAtLeastOneField: 'En az bir alanı etkinleştirin',
        enterSubmitTitle: 'Gönder butonunun başlığını girin',
        invalidUrl: 'Geçersiz bağlantı',
        redirectHelper: 'Boş bırakılırsa müşteri sayfada kalır ve aşağıdaki metni görür.',
        discardTitle: 'Kaydetmeden kapatılsın mı?',
        discardText: 'Buton ayarlarındaki değişiklikler kaybolacak.',
        discardContinue: 'Düzenlemeye devam et',
        discardClose: 'Kapat',
        contactModalTitle: 'Contact düğmesi',
        preorderModalTitle: 'Ön sipariş düğmesi',
        contactModalSubtitle: 'Eklediğiniz her eylem, ürün sayfasında ayrı bir düğme olur',
        actionTab: 'Eylem',
        methodFormDesc: 'Müşteri alanları doldurur',
        methodChat: 'Canlı sohbet',
        methodChatDesc: 'Gerçek zamanlı yazışma burada',
        methodMessengerDesc: 'WhatsApp, Telegram, Viber…',
        methodEmailDesc: 'Müşterinin e-posta uygulamasını açar',
        inboxDefaultNote: 'Varsayılan olarak her şey Unilink Inbox’ınızda saklanır — bunu sonra değiştirebilirsiniz.',
        readyToSave: 'Kaydetmeye hazır',
        apply: 'Uygula',
        back: 'Geri',
        pickAction: 'Düğmenin ne yapacağını seçin',
        buttonText: 'Düğme yazısı',
        buttonBackground: 'Düğme arka planı',
        buttonTextColor: 'Yazı rengi',
        lowContrastWarning: 'Yazı arka plana karışıyor — müşteri etiketi okuyamaz.',
        colorsSharedNote: 'Renkler Contact düğmesinin bütün eylemleri için ortaktır.',
        chatNoSetup: 'Ayarlanacak bir şey yok: sohbet sayfada açılır, yazışma Inbox’ınıza düşer.',
        yourEmail: 'E-posta adresiniz',
        yourEmailHelper: 'Müşteride bu adrese yazılmış bir mektupla e-posta uygulaması açılır.',
        channelAndContact: 'Kanal ve iletişim',
        singleChannelNote: 'Düğme seçilen uygulamadaki sohbeti doğrudan açar.',
        whatToAsk: 'Ne sorulacak',
        fieldsOfMax: '{max} alandan {count} tanesi',
        fieldOptional: 'Zorunlu değil',
        typeLongText: 'Uzun metin',
        duplicateField: 'Bu adda bir alan yukarıda var',
        addReplyableField: 'E-posta ya da telefon ekleyin — yoksa yanıt verecek bir yol olmaz',
        presetName: 'Ad',
        presetEmail: 'E-posta',
        presetPhone: 'Telefon',
        presetComment: 'Yorum',
        presetOwnField: 'kendi alanım',
        thanksText: 'Gönderimden sonraki yazı',
        thanksPlaceholder: 'Teşekkürler! Gün içinde yanıtlayacağız.',
        recapForm: 'Talep {targets} düşer',
        recapChat: 'Yazışma Unilink Inbox’ınıza düşer',
        recapMessenger: 'Müşteri {app} uygulamasına geçer',
        recapEmail: 'Müşteride {address} adresine yazılmış bir mektupla e-posta açılır',
        recapEmailFallback: 'adresinize',
        recapTargetInbox: 'Unilink Inbox’a',
        actionsLabel: 'İletişim yolları',
        actionsOfMax: '{count} / {max}',
        actionsCount: '{count} eylem',
        addAction: 'Eylem ekle',
        addFirstAction: 'Müşterilerin size ulaşacağı ilk yolu ekleyin',
        deleteAction: 'Eylemi sil',
        actionNeedsAttention: 'Tamamlanmadı',
        severalActionsNote: 'Her eylem, ürün sayfasında bu sırayla ayrı bir düğme olur.',
        methodAlreadyAdded: 'Listede zaten var',
        duplicateChannel: 'Bu kanal bu iletişim bilgisiyle listede zaten var',
        duplicateTitle: 'Bu metni başka bir düğme kullanıyor',
        defaultTitleForm: 'Bize yazın',
        defaultTitleChat: 'Sohbet edin',
        defaultTitleEmail: 'E-posta gönder',
      },
      preorderForm: {
        title: 'Ön sipariş formu',
        subtitle: 'Ön sipariş formu alanlarını ayarla',
        fields: 'Alanlar',
        fieldsTooltip: 'Forma alan ekle',
        required: 'Zorunlu',
        submitButton: 'Gönder düğmesi başlığı',
        redirectUrl: `Yönlendirme URL'si (isteğe bağlı)`,
        resultText: 'Sonuç metni',
        save: 'Kaydet',
        name: 'Ad',
        emailAddress: 'E-posta adresi',
        phone: 'Telefon',
        address: 'Adres',
        comment: 'Yorum',
      },
      shipping: {
        title: 'Ödeme formu',
        subtitle: 'Alıcının sipariş verirken doldurduğu alanlar',
        fields: 'Alanlar',
        fieldsTooltip: 'Kargo formuna alan ekle',
        required: 'Zorunlu',
        save: 'Kaydet',
        name: 'Ad',
        emailAddress: 'E-posta adresi',
        phone: 'Telefon',
        address: 'Adres',
        comment: 'Yorum',
        askDetails: 'Alıcıdan bilgi iste',
        askDetailsHint: 'Kapalı — ödeme adımı siparişi formsuz alır',
        askDetailsPaymentWarning:
          'Ödeme adımı çevrimiçi tahsilat yapıyor. E-posta olmadan makbuzun gideceği yer yok: en azından E-postayı açık bırakın veya «Siparişi al, ödeme alma» moduna geçin.',
        askDetailsRedirectNote: 'Ödeme başka bir sitede tamamlanıyor — bu alanlar alıcılara hiç gösterilmez.',
        askDetailsNoContactNote: 'Sipariş iletişim bilgisi olmadan gelecek. Alıcıyı arayacaksanız Telefonu açık bırakın.',
        promoCode: 'Promosyon kodu',
        addCustomField: 'Özel alan ekle',
        addFormInfo: 'Form bilgisi ekle',
        editFormInfo: 'Form bilgisini düzenle',
        type: 'Tür',
        typeTooltip: 'Özel alan türü',
        fieldName: 'Alan adı',
        fieldNameTooltip: 'Özel alan için ad',
        placeholder: 'Yer tutucu',
        placeholderTooltip: 'Özel alan için yer tutucu',
        delete: 'Sil',
        update: 'Güncelle',
        add: 'Ekle',
      },
      delivery: {
        title: 'Teslimat yöntemleri',
        subtitle: 'Kargo, teslimat ve teslim alma',
        loading: 'Yükleniyor…',
        inactive: 'pasif',
        confirmDelete: 'Bu teslimat yöntemi silinsin mi?',
        category: {
          shipping: 'Kargo',
          localDelivery: 'Yerel teslimat',
          selfPickup: 'Mağazadan teslim',
        },
        rateType: {
          free: 'Ücretsiz',
          conditionalFree: 'Koşullu ücretsiz',
          flatRate: 'Sabit ücret',
          customRates: 'Özel ücretler',
          carrierApi: 'Kargo API',
        },
        carrier: {
          custom: 'Özel kargo firması',
        },
        add: {
          shipping: 'Kargo ekle',
          localDelivery: 'Yerel teslimat ekle',
          selfPickup: 'Mağazadan teslim ekle',
        },
        actions: {
          edit: 'Düzenle',
          delete: 'Sil',
          save: 'Kaydet',
          cancel: 'İptal',
        },
        fields: {
          name: 'Ad',
          namePh: 'örn. Standart kargo',
          description: 'Açıklama',
          isActive: 'Aktif',
          estimatedDays: 'Tahmini gün',
          currency: 'Para birimi',
          countryCodes: 'Ülke kodları (CSV)',
          carrier: 'Kargo firması',
          rateType: 'Ücret türü',
          flatPrice: 'Sabit fiyat',
          freeThreshold: 'Şu tutarın üzerinde ücretsiz (ara toplam)',
          fallbackPrice: 'Yedek fiyat',
          customRates: 'Özel ücret satırları',
          senderCity: 'Gönderen şehir adı',
          senderCityRef: 'Gönderen şehir referansı',
          pickupInstructions: 'Teslim alma talimatları',
          pickupCharge: 'Teslim alma ücreti',
          askPickupDateTime: 'Ödemede teslim alma tarih/saatini sor',
        },
        rateRow: {
          subtotal: 'Ara toplama göre',
          weight: 'Ağırlığa göre (g)',
          min: 'Min',
          max: 'Maks',
          price: 'Fiyat',
          add: 'Satır ekle',
        },
      },
      legal: {
        title: 'Yasal belgeler',
        subtitle: 'Koşullar, gizlilik, iade',
        loading: 'Yükleniyor…',
        empty: 'Henüz yasal belge yok.',
        inactive: 'pasif',
        required: 'zorunlu',
        confirmDelete: 'Bu belge silinsin mi?',
        addNew: '+ Belge ekle',
        types: {
          terms: 'Hizmet Şartları',
          privacy: 'Gizlilik Politikası',
          returns: 'İade / Geri Ödeme Politikası',
          shipping: 'Kargo Politikası',
          cookies: 'Çerez Politikası',
          custom: 'Özel',
        },
        fields: {
          title: 'Başlık',
          titlePh: 'örn. Hizmet Şartları',
          type: 'Belge türü',
          content: 'İçerik',
          contentPh: 'Yasal metninizi buraya yazın…',
          isActive: 'Aktif',
          requireAcceptance: 'Ödemede kabul zorunlu olsun',
        },
        actions: {
          edit: 'Düzenle',
          delete: 'Sil',
          save: 'Kaydet',
          cancel: 'İptal',
        },
      },
      checkoutGroup: 'Ödeme',
      serviceCharge: {
        title: 'Hizmet bedeli',
        subtitle: 'Her siparişe bir hizmet ücreti veya bahşiş ekleyin.',
        label: 'Açıklama',
        labelPh: 'örn. %5 hizmet ücreti ve 3$ teslimat bahşişi',
        rate: 'Oran',
        rateHint: 'Sipariş ara toplamının yüzdesi.',
        amount: 'Tutar',
        amountHint: 'Üzerine eklenen sabit tutar.',
      },
      tip: {
        title: 'Bahşişler',
        subtitle: 'Müşterilerin ödeme sırasında siparişlerine bahşiş eklemesine izin verin.',
        enable: 'Bahşişleri etkinleştir',
        presets: 'Bahşiş hazır ayarları (%)',
        noPresets: 'Henüz hazır ayar yok — aşağıya bir tane ekleyin.',
        presetPh: 'örn. 10',
        addPreset: '+ Hazır ayar ekle',
        presetsHint: 'Ödemede hızlı seçim düğmeleri olarak gösterilir. En fazla 6.',
        remove: 'Kaldır',
        allowCustom: 'Özel tutara izin ver',
        label: 'İstem etiketi',
        labelPh: 'örn. Harika hizmet için bahşiş ekleyin',
        save: 'Kaydet',
        saving: 'Kaydediliyor…',
      },
      orderNumber: {
        title: 'Sipariş numarası',
        subtitle: 'Sipariş numaralarının görünümünü özelleştirin.',
        next: 'Sonraki sipariş numarası',
        prefix: 'Ön ek',
        suffix: 'Son ek',
        showInMessage: 'Faturada ve sipariş mesajında göster',
        reset: 'Sipariş numarasını sıfırla',
      },
      orderMessage: {
        title: 'Sipariş mesajı',
        subtitle: 'Müşterilere gönderilen sipariş onayını özelleştirin.',
        footer: 'Mesaj alt bilgisi',
        footerPh: 'örn. Siparişiniz için teşekkürler! Bizi takip edin @markanız',
        footerHint: 'Her sipariş onay mesajına eklenir.',
        plain: 'Düz mesaj',
        plainHint: 'Sipariş mesajındaki tüm biçimlendirmeyi kaldırın.',
      },
      invoice: {
        title: 'Fatura',
        subtitle: 'Ödenen siparişlere eklenen markalı fatura.',
        upgrade: 'Yükselt',
        showLogo: 'Logoyu göster',
        header: 'Üst bilgi',
        footer: 'Alt bilgi',
        companyName: 'Şirket adı',
        companyEmail: 'Şirket e-postası',
        companyPhone: 'Şirket telefonu',
        companyAddress: 'Şirket adresi',
        companyAddressPh: 'Adres girin',
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'Sayfanı meta SEO etiketleriyle özelleştir',
      titleText: 'Başlık',
      titlePlaceholder: 'Sayfa başlığını gir',
      description: 'Açıklama',
      descriptionPlaceholder: 'Sayfa açıklamasını gir',
      favicon: 'Favicon',
      uploadFavicon: 'Favicon yükle',
      imagePreview: 'Görsel önizleme',
      useCustom: 'Özel görsel kullan',
      save: 'Kaydet',
      visualise: `Web sitesi önizlemenin Google'da nasıl görüneceğini görselleştir`,
      inMessengers: 'Mesajlaşma uygulamalarında',
      inSocial: 'Sosyal medyada',
      searchEngine: 'Arama motoru',
      googleIndexable: 'Google tarafından dizine eklenebilir',
      sitemap: {
        title: 'Site haritası',
        entryHint: 'Arama motorlarının hangi sayfaları ve ürünleri dizine ekleyebileceğini yönetin.',
        setupLink: 'özelleştir',
        mainEntry: 'Web Sitesini Dizine Ekle',
        subtitle: 'Arama motorlarının hangi sayfaları dizine ekleyeceğini seçin. Devre dışı bırakılan sayfalar noindex etiketi alır ve site haritanızdan kaldırılır.',
        mainPage: 'Ana profil sayfası',
        pagesSection: 'Sayfalar',
        pagesHint: 'Sitenizdeki her ek sayfa için dizine eklemeyi açıp kapatın.',
        noPages: 'Henüz ek sayfa yok.',
        productsSection: 'Ürünler',
        productsHint: 'Bireysel ürün sayfaları için dizine eklemeyi açıp kapatın.',
        noProducts: 'Henüz ürün yok.',
        postsSection: 'Gönderiler',
        postsHint: 'Bireysel gönderiler için dizine eklemeyi açıp kapatın.',
        noPosts: 'Henüz gönderi yok.',
        blogSection: 'Blog makaleleri',
        blogHint: 'Bireysel blog makaleleri için dizine eklemeyi açıp kapatın.',
        noArticles: 'Henüz blog makalesi yok.',
        loadMore: 'Daha fazla yükle',
        loading: 'Yükleniyor…',
      },
    },
    analytics: {
      title: 'Analitik',
      subtitle: 'Facebook Pixel, Google Analytics ve UTM parametrelerini entegre et',
      facebookTooltip: `Analitikleri görüntülemek için Facebook'u bağlayın`,
      googleAnalyticsTooltip: 'Google Analytics, reklam yatırım getirinizi ölçmenize ve tüm bağlantılarınızı izlemenize olanak tanır.',
      googleTagManagerTooltip: 'Google Etiket Yöneticisi, web sitenizde etiketleri yapılandırmanıza ve anında dağıtmanıza olanak tanır',
      tikTokPixelTooltip: 'TikTok Pixel, TikTok reklamlarınızın web sitenizdeki etkisini izleyen güçlü bir ölçüm aracıdır',
      pinterestTag: 'Pinterest etiketi',
      pinterestTagTooltip: `Pinterest etiketi, web sitenize eklediğiniz bir kod parçasıdır ve Pinterest'in sitenize gelen ziyaretçileri ve Pinterest reklamınızı gördükten sonra sitenizde gerçekleştirdikleri eylemleri izlemesine olanak tanır.`,
      tag: 'etiket',
      headerTagTooltip: 'Web sitenizin head bölümünde görünen etiketi yapıştırın',
      bodyTagTooltip: 'Web sitenizin body bölümünde görünen etiketi yapıştırın',
      utmParameters: 'UTM parametreleri',
      utmParametersTooltip: `Özel URL'lerle kampanya verilerini toplayın. Trafiği yönlendiren kampanyaları tanımlamak için URL'lere parametreler ekleyin.`,
      makeAnalytics: `Google Analytics'in UniLink trafiğini Sosyal olarak göstermesini sağlayın`,
      the: '',
      campaign: 'kampanya',
      parameter: 'parametresi, her gönderi veya bağlantının başlığından dinamik olarak ayarlanır',
      save: 'Kaydet',
    },
    customDomain: {
      title: 'Özel alan adı',
      subtitle: 'Sayfanızı özel alan adıyla kişiselleştirin',
      titleTooltip: 'Özel alan adı ekle',
      save: 'Kaydet',
      connect: 'Bağlan',
      connecting: 'Bağlanıyor',
      instructions: 'Talimatlar',
      submit: 'Gönder',
      submitting: 'Gönderiliyor...',
      enterDomain: 'Alan adınızı girin',
      domainPlaceholder: 'alan-adiniz.com',
      steps: {
        submitting: 'Talep gönderiliyor',
        validation: 'Alan adı doğrulama',
        certificate: 'Sertifika sağlama',
        complete: 'Tamamlandı',
      },
      txtRecord: {
        title: 'TXT Kaydı',
        description: 'DNS ayarlarınıza aşağıdaki TXT kaydını ekleyin:',
        verifyButton: 'TXT Kaydını Doğrula',
        verifying: 'Doğrulanıyor...',
        verified: 'TXT kaydı doğrulandı',
      },
      cnameRecord: {
        title: 'CNAME Kaydı',
        description: 'DNS ayarlarınıza aşağıdaki CNAME kaydını ekleyin:',
        verifyButton: 'CNAME Kaydını Doğrula',
        verifying: 'Doğrulanıyor...',
        verified: 'CNAME kaydı doğrulandı',
      },
      dnsTable: {
        type: 'Tür',
        host: 'Host',
        value: 'Değer',
        ttl: 'TTL',
        copy: 'Kopyala',
        copied: 'Kopyalandı!',
      },
      provisioning: {
        title: 'SSL sertifikası sağlanıyor...',
        description: 'Bu birkaç dakika sürebilir. Lütfen bekleyin.',
        timeout: 'Sertifika sağlama beklenenden uzun sürüyor. Lütfen daha sonra tekrar kontrol edin.',
      },
      complete: {
        title: 'HTTPS, alan adınızda başarıyla etkinleştirildi.',
        connected: 'Bağlandı',
      },
      failed: {
        title: 'Alan adı bağlantısı başarısız',
        tryAgain: 'Tekrar Dene',
      },
      rootDomainWarning: 'Kök alan adları, DNS sağlayıcınızın CNAME flattening desteğini gerektirir (ör. Cloudflare, Route53).',
      deleteConfirm: {
        title: 'Alan adı bağlantısını kes',
        message: 'Bu alan adının bağlantısını kesmek istediğinizden emin misiniz? Web siteniz artık bu alan adı üzerinden erişilebilir olmayacak.',
        confirm: 'Bağlantıyı kes',
        cancel: 'İptal',
      },
    },
    webhooks: {
      title: `Webhook'lar`,
      subtitle: 'Harici servislere gerçek zamanlı etkinlik bildirimleri gönderin',
      webhook: 'Webhook',
      webhookTooltip: 'Webhook ekle',
      send: 'Üçüncü taraf web sitesine etkinlik gönder',
      webhookUrl: 'Webhook URL (POST isteği)',
      error: 'Doğru bağlantıyı girin',
      save: 'Değişiklikleri kaydet',
      enableWebhooks: `Webhook'ları etkinleştir`,
      enableDescription: 'Seçili etkinliklerde POST istekleri',
      endpointUrl: 'Uç nokta URL',
      endpointTooltip: 'Seçili etkinlikler gerçekleştiğinde POST isteklerini alacak URL',
      endpointPlaceholder: 'https://example.com/api/webhook',
      events: 'Etkinlikler',
      selectAll: 'Tümünü seç',
      deselectAll: 'Tüm seçimleri kaldır',
      filterPlaceholder: 'Etkinlikleri filtrele...',
      all: 'Tümü',
      none: 'Hiçbiri',
      active: 'Aktif',
      inactive: 'Pasif',
      categories: {
        submissions: 'Gönderimler',
        engagement: 'Etkileşim',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'Başlık Aboneliği',
        SubmitHeaderMessage: 'Başlık Mesajı',
        SubmitDataCollect: 'Veri Toplama',
        SubmitForm: 'Form Gönderimi',
        SubmitShop: 'Mağaza Siparişi',
        SubmitShopPreorder: 'Mağaza Ön Siparişi',
        SubmitDigital: 'Dijital Ürün',
        SubmitAppointment: 'Randevu',
        SubmitService: 'Hizmet Siparişi',
        SubmitEvent: 'Etkinlik Kaydı',
        SubmitCourse: 'Kurs Kaydı',
        SubmitDonation: 'Bağış',
        SubmitMembership: 'Üyelik',
        SubmitBlog: 'Blog Satın Alımı',
        SubmitCoupon: 'Kupon Kullanımı',
        SubmitTip: 'Bahşiş',
        SubmitLink: 'Bağlantı Satın Alımı',
        SubmitProductMessage: 'Ürün Sorusu',
        SubmitPodcast: 'Podcast Satın Alımı',
        SubmitBooking: 'Rezervasyon',
        SubmitRental: 'Kiralama',
        SubmitSingleProduct: 'Tekil Ürün',
        SubmitDiscount: 'İndirimli Sipariş',
        SubmitListing: 'Listeleme Talebi',
        SubmitUnlock: 'İçerik Kilidini Açma',
        SubmitChatAi: 'AI Sohbet Mesajı',
        ClickLink: 'Bağlantı Tıklaması',
        ClickContact: 'İletişim Tıklaması',
        AddToCart: 'Sepete Ekleme',
        AddToCartSingleProduct: 'Tekil Ürünü Sepete Ekleme',
        AddToWishlist: 'İstek Listesine Ekleme',
        InitiateCheckout: 'Ödemeyi Başlatma',
        DownloadFile: 'Dosya İndirme',
        DownloadMusic: 'Müzik İndirme',
        CopyCoupon: 'Kupon Kopyalama',
        CopyDiscount: 'İndirim Kopyalama',
        QR_ScanQrCode: 'QR Kod Tarama',
        VisitPage: 'Sayfa Ziyareti',
      },
    },
    sensitive: {
      title: 'Hassas içerik',
      subtitle: 'Web sitenizi göstermeden önce hassas içerik uyarısı görüntüleyin',
    },
    socialIntegration: {
      title: 'Sosyal entegrasyonlar',
      subtitle: 'Instagram ve TikTok entegrasyonlarınızı yönetin',
      connectInstagram: `Instagram'ı bağla`,
    },
    emailIntegration: {
      title: 'Kitle entegrasyonları',
      subtitle: `Ziyaretçilerinizin e-posta adreslerini MailChimp ve Reply'a aktarın`,
      emailCaption: `Takipçilerinizin e-posta adreslerini MailChimp'e aktarmak için bir entegrasyon ekleyin`,
      mailChimp: 'MailChimp entegrasyonları',
      selzy: 'Selzy entegrasyonları',
      selzyCaption: `Takipçilerinizin e-posta adreslerini Selzy'ye aktarmak için bir API anahtarı ekleyin`,
      sendPulse: 'SendPulse entegrasyonları',
      sendPulseCaption: `Takipçilerinizin e-posta adreslerini SendPulse'a aktarmak için bir API anahtarı ekleyin`,
      reply: 'Reply entegrasyonları',
      replyCaption: 'Takipçilerinizin e-posta adreslerini aktarmak için bir API anahtarı ekleyin',
      integrations: 'entegrasyonlar',
    },
    calendarIntegration: {
      title: 'Takvim entegrasyonları',
      subtitle: 'Takvim hizmetlerinizi bağlayın',
      calendly: 'Calendly',
      calendlyDescription: `Etkinlik türlerinizi ve uygunluğunuzu senkronize etmek için Calendly'yi bağlayın`,
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: `Etkinlikleri senkronize etmek ve Google Meet bağlantıları oluşturmak için Google Calendar'ı bağlayın`,
      zoom: 'Zoom',
      zoomDescription: `Toplantı bağlantılarını otomatik olarak oluşturmak için Zoom'u bağlayın`,
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Google Meet bağlantılarını otomatik olarak oluşturun (Google Calendar gerektirir)',
    },
    storage: {
      title: 'Depolama',
      subtitle: `Ziyaretçi siparişlerini Google E-Tablolar'a kaydedin`,
      storageCaption: `Tüm müşteri siparişlerini Google E-Tablolar'a kaydetmek için bir entegrasyon ekleyin`,
      emailSignup: 'E-posta kaydı',
      emailSignupsCaption: 'E-posta kaydını saklamak için tablo seçin',
      formSignups: 'Form Kaydı',
      forSignupsCaption: 'Form kaydını saklamak için tablo seçin',
      shopOrders: 'Mağaza siparişleri',
      shopOrderCaption: 'Mağaza siparişlerini saklamak için tablo seçin',
      disconnect: 'E-tablo bağlantısını kes',
      storageUsage: 'Depolama kullanımı',
      of: '/',
      uses: 'Bu uygulama',
      space: 'boş disk alanınızı kullanıyor',
      view: 'ayrıntıları görüntüle',
      noItems: 'Hiç öğe yok',
      files: 'Dosyalar',
      images: 'Görseller',
      videos: 'Videolar',
      audio: 'Ses',
      settings: 'ayarlar',
      free: 'boş',
      needMoreSpace: 'Daha fazla alan mı lazım?',
      unlockStorage: 'Sınırsız depolama, 4K video kilidini açın',
      upgradePlan: 'Planı Yükselt',
      addFile: 'Dosya ekle',
      uploading: 'Yükleniyor...',
      dragDrop: 'veya buraya sürükleyip bırakın',
      noFilesYet: 'Henüz dosya yok',
      noImagesYet: 'Henüz görsel yok',
      noVideosYet: 'Henüz video yok',
      noAudioYet: 'Henüz ses yok',
      filesHint: `PDF'leri, belgeleri ve diğer indirmeleri bio sayfası bağlantılarınıza eklemek için yükleyin.`,
      imagesHint: 'Bio sayfanızda kullanmak için görseller yükleyin.',
      videosHint: 'Bio sayfanıza gömmek için videolar yükleyin.',
      audioHint: 'Bio sayfanızda paylaşmak için ses parçaları yükleyin.',
    },
    accountLabel: 'Hesap',
    profileLabel: 'Profil',
    switchProfile: 'Profil değiştir',
    createNewProfile: 'Yeni profil oluştur',
    active: 'Aktif',
    currentPlan: 'Mevcut plan',
    freePlanHint: 'Pro özelliklerini açmak ve limitleri kaldırmak için yükseltin.',
    to: '-',
    renews: 'Yenilenme',
    passwordChangeDesc: 'Hesap şifrenizi değiştirin',
    apiKeyDesc: 'API isteklerini doğrulamak için bu anahtarı kullanın',
    apiDocumentation: 'API dokümantasyonu',
    dashboardLanguageDesc: 'Hesabınızın arayüz dili',
    manualPayments: {
      title: 'Manuel / Çevrimdışı ödemeler',
      hint: 'Müşteriler çevrimdışı öder (banka havalesi, nakit, QR). Siparişi manuel olarak onaylarsınız.',
      save: 'Kaydet',
      iban: 'IBAN',
      accountHolder: 'Hesap sahibinin adı',
      bankName: 'Banka adı',
      phone: 'Telefon',
      payeeName: 'Alacaklı adı',
      instruction: 'Talimat',
      instructionHint: '**kalın** ~üstü çizili~ _italik_ ile biçimlendirin',
      requireProof: 'Ödeme kanıtı iste',
      requireProofHint: 'Ödemeyi tamamlamak için müşteriler bir ekran görüntüsü (makbuz, banka havalesi onayı veya herhangi bir ödeme kanıtı) yüklemelidir.',
      markPaidOnConfirm: 'Müşteri onayında ödendi olarak işaretle',
      markPaidOnConfirmHint: `Müşteri ödemesini onayladığında ödeme durumunu otomatik olarak 'Ödendi' olarak günceller.`,
      contactBeforePay: 'Ödemeden önce satıcıyla iletişimi etkinleştir',
      contactBeforePayHint: 'Müşterilerin satıcıya mesaj göndermek için ödemeyi atlamasına olanak tanır; bu, talepleri artırır ancak güven oluşturur ve iptalleri azaltır.',
    },
    developerApi: {
      title: 'Geliştirici API',
      subtitle: 'Siparişlerinize, ürünlerinize ve müşterilerinize /api/v2 uç noktaları üzerinden erişmek için API anahtarları oluşturun.',
      keyName: 'Anahtar adı',
      keyNamePh: 'örn. Depo senkronizasyonu',
      scopes: 'İzinler',
      scopeLabels: {
        'orders:read': 'Siparişleri oku',
        'products:read': 'Ürünleri oku',
        'products:write': 'Ürün stoğunu güncelle',
        'customers:read': 'Müşterileri oku',
      },
      create: 'Anahtar oluştur',
      creating: 'Oluşturuluyor…',
      created: 'API anahtarı oluşturuldu',
      copyWarning: 'Bu anahtarı şimdi kopyalayın — tekrar gösterilmeyecek.',
      done: 'Tamam',
      revoke: 'İptal et',
      revoked: 'İptal edildi',
      confirmRevoke: 'Bu API anahtarı iptal edilsin mi? Onu kullanan uygulamalar çalışmayı durduracak.',
      empty: 'Henüz API anahtarı yok.',
    },
    whatsapp: {
      title: 'WhatsApp Business',
      subtitle: 'Müşteri mesajlarını almak ve yanıtlamak için WhatsApp Business numaranızı bağlayın.',
      phoneNumberId: `Telefon numarası ID'si`,
      accessToken: `Erişim token'ı`,
      displayPhone: 'Görünen telefon (isteğe bağlı)',
      connect: 'Bağlan',
      connecting: 'Bağlanıyor…',
      connected: 'Bağlandı',
      disconnect: 'Bağlantıyı kes',
      confirmDisconnect: 'WhatsApp bağlantısı kesilsin mi?',
      webhookHelp: `Bu Geri Çağırma URL'sini ve Doğrulama token'ını Meta App → WhatsApp → Configuration bölümünde ayarlayın:`,
      webhookUrl: `Geri çağırma URL'si`,
      verifyToken: `Doğrulama token'ı`,
      inbox: 'Gelen kutusu',
      noMessages: 'Henüz mesaj yok.',
      selectThread: 'Bir konuşma seçin.',
      replyPlaceholder: 'Bir mesaj yazın…',
      send: 'Gönder',
      broadcast: {
        title: 'Toplu mesaj',
        audienceInbox: 'Gelen kutusu kişileri',
        audienceCrm: 'CRM kitlesi (şablon)',
        message: 'Mesaj',
        inboxHint: 'Serbest metin — yalnızca 24 saatlik müşteri hizmetleri penceresindeki kişilere iletilir.',
        templateName: 'Şablon adı',
        templateLang: 'Şablon dili',
        crmHint: 'Onaylanmış bir WhatsApp şablonu kullanın — 24 saatlik pencere dışındaki kişilere ulaşmak için gereklidir.',
        send: 'Toplu mesaj gönder',
        sending: 'Gönderiliyor…',
        empty: 'Henüz toplu mesaj yok.',
        sent: 'gönderildi',
        failed: 'başarısız',
      },
      autoReply: {
        title: 'Otomatik yanıtlar',
        type: 'Tür',
        typeKeyword: 'Anahtar kelime',
        typeGreeting: 'Karşılama (ilk mesaj)',
        typeAway: 'Uzakta (çalışma saatleri dışında)',
        keyword: 'Anahtar kelime',
        from: 'Saat başlangıcı',
        to: 'Saat bitişi',
        reply: 'Yanıt metni',
        add: 'Kural ekle',
        empty: 'Henüz otomatik yanıt kuralı yok.',
        delete: 'Sil',
      },
    },
  },
  productStore: {
    title: 'Link-in-bio sayfanızda Mağaza sekmesini göster',
    subtitle: 'Mağazanız şu anda gizli.',
  },
  sections: {
    splashScreen: {
      title: 'Açılış Ekranı',
      subtitle: 'Sayfa yüklenirken görüntülenir',
    },
    promo: {
      title: 'Promosyon çubuğu',
      subtitle: 'Promosyonlarınızı öne çıkaran vurgu',
      masterPromoMessage: `Ana Promobar şu anda etkin. Bu sayfa için özel bir promobar oluşturmak istiyorsanız, önce Ana Promobar'ı devre dışı bırakmanız gerekir.`,
      titlePlaceholder: 'Web siteme hoş geldiniz!',
      switcherIsMasterPromobar: 'Tüm sayfalarda göster',
    },
    contact: {
      title: 'İletişim',
      subtitle: 'Sizinle iletişim kurma yolunu sağlayın',
      caption: 'Sizinle müşterileriniz arasında tek tıkla hızlı bağlantı için messenger düğmeleri ekleyin',
      tooltip: `İletişim, kullanıcıların sizinle doğrudan iletişim kurmasına olanak tanır. Telefonunuzu, e-postanızı, messenger'ınızı veya konumunuzu ekleyin`,
      addNewContact: 'Yeni kişi ekle',
      addContact: 'Kişi ekle',
      chooseContact: 'Kişi seç',
      enterLink: 'Kişi bağlantınızı girin',
      showDetails: 'Ayrıntıları göster',
      enterAnyContact: 'Lütfen bir kişi girin',
      enterAnyContactCaption: '(WhatsApp, Telegram, Viber, Messenger)',
    },
    membership: {
      title: 'Üyelik',
      subtitle: 'İçeriğinize ücretsiz veya ücretli abonelik oluşturun',
      addNewTier: 'Yeni paket ekle',
      editTier: 'Paketi düzenle',
      name: 'Ad',
      nameCaption: 'Paketinizin adını girin',
      price: 'Aylık fiyat',
      priceCaption: 'Paketinizin fiyatını girin',
      month: 'ay',
      image: 'Görsel',
      imageCaption: 'Paketiniz için görsel yükleyin',
    },
    pricing: {
      title: 'Fiyatlandırma',
      subtitle: 'Fiyatlı bir menü oluşturun',
      add: 'Yeni öğe ekle',
      edit: 'Öğeyi düzenle',
      name: 'Ad',
      nameCaption: 'Öğenizin adını girin',
      duration: 'Özellik',
      durationCaption: 'Öğenizin süresini, miktarını veya zamanını girin',
      category: 'Kategori',
      categoryCaption: 'Öğenizin kategorisini girin',
      price: 'Fiyat',
      priceCaption: 'Öğenizin fiyatını girin',
      month: 'ay',
      image: 'Görsel',
      imageCaption: 'Öğeniz için görsel yükleyin',
    },
    subscribe: {
      dataCollectTitle: 'Veri Toplama',
      title: 'Abone ol',
      subtitle: 'Ziyaretçilerinizden e-posta veya telefon numarası toplayın',
      instructionsMessage: 'Sayfanıza bir E-posta kayıt alanı ekleyin, ziyaretçileriniz kolayca kayıt olabilsin!',
      instructionsLink: `E-postaları pazarlama kampanyaları için MailChimp'e aktarın.`,
      sectionHeaderCaption: 'Bültenimize abone olun',
      collecting: 'Toplanıyor',
      collectingCaption: 'Giriş türünüzü seçin',
      addDataToCollect: 'Toplanacak veri ekleyin',
      email: 'E-posta',
      enterEmail: 'E-posta girin',
      thanksForEmail: 'E-postanız için teşekkürler',
      phone: 'Telefon',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'YouTube',
      whatsapp: 'WhatsApp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: 'Güncellenmiş bağlantıları ekle',
      placeholder: 'Yer tutucu',
      placeholderCaption: 'Yer tutucu metnini girin',
      button: 'Düğme',
      buttonCaption: 'Ziyaretçiyi e-posta girmeye teşvik edecek metin (%10 indirim, hemen abone ol, dosya indir vb.)',
      submitButton: 'Gönder düğmesi',
      enterButton: 'Giriş düğmesi',
      thanksMessage: 'Teşekkür mesajı',
      thanksMessageCaption: 'Aboneleriniz için teşekkür mesajı',
      resultAction: 'İşlem (gönderdikten sonra)',
      resultActionCaption: 'Formu doldurduktan sonraki işlem',
      sendAnEmail: 'E-posta gönder',
      downloadFile: 'Dosya indir',
      redirect: 'Yönlendir',
      messageBody: 'Mesaj içeriği',
      messageBodyCaption: 'Bu veriler, kullanıcıya e-postası için hediye olarak gönderilir (kupon, dosya indirme bağlantısı vb.)',
      integration: 'Entegrasyon',
      integrationCaption: `Ziyaretçilerinizin e-posta adreslerini MailChimp, Reply'a iletin`,
      storage: 'Depolama',
      storageCaption: `Ziyaretçi siparişlerini Google Spreadsheet'e kaydet`,
      maxSize: 'En fazla 3 kanal ekleyebilirsiniz',
    },
    text: {
      title: 'Metin',
      subtitle: 'Kendiniz/şirketiniz hakkında bir şeyler yazın',
      trimBio: 'Daha Fazla Göster düğmesi',
    },
    header: {
      title: 'Başlık',
      subtitle: 'Sayfanızda büyütülmüş öne çıkan görsel veya video',
      verifiedBadge: 'Doğrulanmış rozeti',
      showProfilePic: 'Profil resmini göster',
      profilePicRatio: 'Oran',
      profilePicRatioSquare: 'Kare',
      profilePicRatioLandscape: 'Yatay',
      profilePicRatioPortrait: 'Dikey',
      namePlaceholder: 'Adınız',
      shortBioPlaceholder: 'Kısa bilgilerim',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: 'Şehir',
      addSocial: '+ Sosyal ekle',
      addCover: '+ Kapak ekle',
      addButton: '+ Düğme ekle',
      addText: '+ Metin ekle',
      addLabel: '+ Etiket ekle',
      subtitleName: 'İsim görünümünüzü özelleştirin',
      subtitleShortBio: 'Kısa biyografi görünümünüzü özelleştirin',
      shortBioSize: 'Kısa Biyografi boyutu',
      subtitleShortBioSize: 'Kısa biyografi boyutunu değiştirebilirsiniz',
      subtitleLocation: 'Ziyaretçileri belirli bir yere yönlendirmek için şehir/ülke ayarlayın',
      headerCoverWarningMessage: 'Tarayıcınız video etiketini desteklemiyor.',
      headerCoverTitle: 'Başlığın üstüne kapak ekleyin',
      coverHeight: 'Kapak yüksekliği',
      subtitleCoverHeight: 'Kapak yüksekliğini değiştirebilirsiniz',
      coverDarkness: 'Kapak karartması',
      subtitleCoverDarkness: 'Kapak görselini karartmak için kaydırıcıyı sürükleyin',
      nameSize: 'İsim boyutu',
      subtitleNameSize: 'İsim boyutunu değiştirebilirsiniz',
      positionText: 'İsim konumu',
      subtitlePositionName: 'İsim konumunu ayarlamak için kaydırıcıyı sürükleyin',
      positionContent: 'İçerik konumu',
      subtitlePositionContent: 'Biyografi, bağlantı ve konum için konum ayarlayın',
      coverText: 'Kapak üzerinde metin',
      subtitleCoverText: 'Kapağınıza metin ekleyin',
      position: 'Konum',
      subtitlePosition: 'Düğme konumunu ayarlamak için kaydırıcıyı sürükleyin',
      buttonCover: 'Kapak üzerinde düğme',
      subtitleButtonCover: 'Bir işlem seçerek kapağınıza düğme ekleyin',
      subtitleFollow: 'Takip et düğmesi, kullanıcıların haberlerinizi takip etmesini sağlar',
      buttonOpacity: 'Düğme şeffaflığını değiştirmek için kaydırıcıyı sürükleyin',
      subtitleCart: 'Alışveriş deneyimi sunmak için sepet simgesi',
      subtitleDirect: 'Ziyaretçiyi mesajlaşma uygulamalarına yönlendiren hızlı buton',
      subtitleCTAButton: 'Kullanıcıyı tıklamaya teşvik eden (harekete geçirici) buton',
      subtitleSocialLinks: 'Sosyal ağlarınıza görsel bir hava katın',
      chooseSocialLink: 'Sosyal bağlantı seçin',
      alignSocialLink: 'Sosyal bağlantı hizalama',
      enterYourSocialLink: 'Sosyal bağlantınızı girin',
      blockShadow: 'Blok gölgesi',
      activeButtonPosition: 'Aktif buton konumu',
      gradientColor: 'Degrade rengi',
      bottomGradient: 'Alt degrade',
      autoGradient: 'Otomatik',
      customGradient: 'Özel',
      transparentGradient: 'Şeffaf',
      uploadLogo: 'Logo Yükle',
      customBackground: 'Özel arka plan',
      headingLabel: 'Başlık Etiketi',
      customizeLabel: 'Başlık etiketinizin görünümünü özelleştirin',
      labelText: 'Etiket Metni',
      enterLabelText: 'Başlık etiketi için metin girin',
      verticalCropStep: 'dikey fotoğraf',
      squareCropStep: 'kare avatar',
      topButtons: 'Üst düğmeler',
      bottomButtons: 'Alt düğmeler',
      buttonSubtitleLanguage: 'Dil değiştirici',
      buttonSubtitleContact: 'Ara / mesaj gönder',
      buttonSubtitleCart: 'Alışveriş sepeti',
      buttonSubtitleCta: 'Eylem çağrısı',
      buttonSubtitleMessage: 'Mesaj',
      buttonSubtitleSubscribe: 'Abone ol',
      buttonSubtitleQrcode: 'QR kodu',
      buttonSubtitleSearch: 'Ürün arama',
      buttonDisabledHint: 'Gizli · devre dışı',
      gradientPositionLabel: 'Gölge konumu',
      gradientPositionPhoto: 'Fotoğrafın altında',
      gradientPositionHeader: 'Başlıkta daha aşağıda',
      bottomBadge: 'Alt renk tonu',
      addTint: 'Renk tonu ekle',
      bottomBadgeText: 'Metin (isteğe bağlı)',
      bottomBadgePreset: 'Hazır ayar',
      bottomBadgeShape: 'Şekil',
      bottomBadgeSize: 'Yükseklik',
      bottomBadgeAction: 'Eylem',
      bottomBadgeBgColor: 'Arka plan rengi',
      bottomBadgeTextColor: 'Metin rengi',
      bottomBadgeGradientFrom: 'Gradyan başlangıcı',
      bottomBadgeGradientTo: 'Gradyan bitişi',
      bottomBadgeGradientAngle: 'Gradyan açısı',
    },
  },
  billingHistory: {
    title: 'Fatura geçmişi',
    invoices: 'Faturalar',
    messageText: 'Henüz ödeme geçmişiniz yok.',
  },
  migrate: {
    title: 'Linktree veya Taplink hesabınız mı var?',
    text: `Bağlantıyı yapıştırın ve tek tıkla UniLink'e geçin!`,
    button: 'Geçiş yap',
  },
  pages: {
    title: 'Sayfalar',
    addPage: 'Sayfa ekle',
    addNewPage: 'Yeni sayfa ekle',
    deleteTitle: 'Bu sayfayı silmek istediğinizden emin misiniz?',
    managePage: 'Sekmeleri Yönet',
    empty: 'Bu sayfada henüz hiçbir blok yok.',
    dragAndDrop: 'Diğer sekmeleri sürükleyip bırakarak yeniden sıralayın',
    pageNavigation: 'Sayfa navigasyon ayarları',
    goToDesign: 'Tasarım ayarlarına git',
    viewArchive: 'Arşivi görüntüle',
    archivedBlocks: 'Arşivlenen bloklar',
    noArchivedBlocks: 'Şu anda kullanmadığınız blokları arşivleyerek sayfanızı temiz ve odaklı tutun.',
    archiveAllUnpublished: 'Yayınlanmamış tüm blokları arşivle',
    restore: 'Geri yükle',
    permanentDelete: 'Kalıcı olarak sil',
  },
  analytics: {
    lifeTimeAnalytics: 'Tüm Zamanların Analitiği',
    impressions: 'Gösterimler',
    impressionsText: 'Seçili dönem için gösterim istatistiklerinin performansı',
    clicks: 'Tıklamalar',
    clicksText: 'Seçili dönem için "tıklama" olaylarının performansı',
    signUps: 'Kayıtlar',
    signUpsText: 'Seçili dönem için "kapatma" olaylarının performansı',
    totalInteractions: 'Etkileşimler',
    totalInteractionsText: 'Seçili dönemdeki tıklamalar ve form kayıtları',
    engagementRate: 'Etkileşim Oranı',
    engagementRateText: 'Etkileşime yol açan profil görüntülemelerinin oranı',
    visitor: 'Ziyaretçi Kaynakları',
    country: 'Ülke',
    countries: 'Ülkeler',
    linkClicks: 'Bağlantı tıklamaları',
    content: 'İçerik',
    views: 'Görüntülenmeler',
    links: 'Bağlantılar',
    products: 'Ürünler',
    blocks: 'Bloklar',
    pages: 'Sayfalar',
    clicksLower: 'tıklama',
    of: '/',
    noContentData: 'Seçilen dönem için henüz veri yok',
  },
  aiInsights: {
    title: 'AI İçgörüleri',
    generate: 'Profilimi analiz et',
    description: 'Profil performansınızı iyileştirmek için AI destekli öneriler alın.',
    analyzing: 'Profiliniz analiz ediliyor...',
    refresh: 'Yenile',
    action: 'Eylem',
  },
  post: {
    subscriptionTypePlaceholder: `'type' aboneliği ve üzeri için kullanılabilir`,
    postButtonText: 'Gönderi',
    newPostPlaceholder: 'Aklınızdan ne geçiyor',
    free: 'Ücretsiz',
    pro: 'Pro',
    premium: 'Premium',
    noPost: 'Henüz gönderiniz yok',
    editPost: 'Gönderiyi düzenle',
  },
  preview: {
    buy: 'Satın al',
    connect: 'Bağlan',
  },
  activeButton: {
    initialText: 'Web sitesi',
    inputPlaceholder: 'Eylem ara...',
    existing: 'Mevcut',
    redirect: 'Yönlendir',
    scroll: 'Kaydır',
    title: 'Aktif Buton',
    modalTitle: 'Aktif buton eylemi',
    subtitle: 'Kullanıcıyı bir eylem yapmaya teşvik eden buton',
    next: 'İleri',
    save: 'Kaydet',
    opensALinkFromLinksBlock: 'Bağlantılar bloğundan bir bağlantıyı açar',
    url: 'URL',
    opensAWebsite: 'Bir web sitesini açar',
    openInApp: 'Uygulamada Aç',
    addAction: 'Eylem Ekle',
    actionTitle: 'Eylem',
    actionCaption: 'Eylem türünü düzenle',
    chooseOption: 'Bir seçenek seçin',
    tellPeople: 'İnsanlara eylem butonunu nasıl kullanacaklarını anlatın',
    urlRedirect: 'URL Yönlendirmesi',
    customUrl: 'Özel URL',
    customUrlText: 'Bir web sitesini açar',
    links: 'Bağlantılar',
    linksText: 'Bağlantılar bloğundan bir bağlantıyı açar',
    downloadDocument: 'Belgeyi İndir',
    sendEmail: 'E-posta Gönder',
    opensEmailClient: 'E-posta istemcisini açar',
    phoneCall: 'Telefon Araması',
    initiatesPhoneCall: 'Telefon aramasını başlatır',
    navigation: 'Navigasyon',
    openPage: 'Sayfayı Aç',
    opensInternalPage: 'Dahili sayfayı açar',
    openPageText: 'Dahili sayfayı açar',
    openProduct: 'Ürünü Aç',
    openProductText: 'Mağazadan ürün sayfasını açar',
    openBlog: 'Blogu Aç',
    opensBlogPageFromStore: 'Mağazadan blog sayfasını açar',
    openBlock: 'Bloğu Aç',
    opensContentBlock: 'İçerik bloğunu açar',
    openItem: 'Öğeyi Aç',
    opensItemPageFromStore: 'Mağazadan öğe sayfasını açar',
    showNewModal: 'Yeni Modal Göster',
    displayContentInModalWindow: 'İçeriği modal pencerede görüntüle',
    showProduct: 'Ürünü Göster',
    displayProductInModalWindow: 'Ürünü modal pencerede görüntüle',
    showBlog: 'Blogu Göster',
    scrollToBlock: 'Bloğa Kaydır',
    scrollToBlockText: 'Belirtilen sayfa bloğuna kaydır',
    scrollToItem: 'Öğeye Kaydır',
    action: 'Eylem',
    showBlock: 'Bloğu Göster',
    showBlockText: 'Mağazadan içerik bloğu',
    showItem: 'Öğeyi Göster',
    showItemText: 'Mağazadan öğe sayfasını açar',
    linksCaption: 'Bağlantılar',
    linksTooltip: 'Bağlantılar bloğundan bir bağlantı seçin',
    pagesCaption: 'Sayfalar',
    pagesTooltip: 'Sayfalardan birini seçin',
    productsCaption: 'Ürünler',
    productsTooltip: 'Listeden bir ürün seçin',
    blocksCaption: 'Bloklar',
    blocksTooltip: 'Listeden bir blok seçin',
    itemsCaption: 'Öğeler',
    itemsTooltip: 'Listeden bir öğe seçin',
    showProductText: 'Ürünü sayfada modal pencere içinde göster',
    more: 'Daha fazla göster',
    less: 'Daha az göster',
    showNewModalTitle: 'Yeni Modal Verisi',
    uploadDocumentTitle: 'Yüklemek için tıklayın veya sürükleyip bırakın',
    uploadProgressTitle: 'Yükleniyor...',
    haveNoModal: 'Modalınız yok',
    haveModal: 'Modal seçtiniz',
    openNewModalHandler: 'Yeni modal oluştur',
    linkGroupSubTitle: 'Bir blok seçin',
    linkItemSubTitle: 'Bir bağlantı seçin',
    urlItemSubTitle: 'Web Sitesi URL',
    openInAppItemSubTitle: 'Uygulama URL',
    sendEmailItemSubTitle: 'E-posta Adresi',
    phoneCallItemSubTitle: 'Telefon Numarası',
    openPageGroupSubTitle: 'Sayfa Seç',
    openPageItemSubTitle: 'Sayfa Seç',
    openProductGroupSubTitle: 'Ürün Türü Seç',
    openProductItemSubTitle: 'Ürün Seç',
    openBlogGroupSubTitle: 'Blog Kanalı Seç',
    openBlogItemSubTitle: 'Blog Makalesi Seç',
    openBlockGroupSubTitle: 'Sayfa Seç',
    openBlockItemSubTitle: 'Blok Seç',
    openItemGroupSubTitle: 'Blok Seç',
    openItemItemSubTitle: 'Öğe Seç',
    showProductGroupSubTitle: 'Ürün Türü Seç',
    showProductItemSubTitle: 'Ürün Seç',
    showBlogGroupSubTitle: 'Blog Kanalı Seç',
    showBlogItemSubTitle: 'Blog Makalesi Seç',
    showBlockGroupSubTitle: 'Sayfa Seç',
    showBlockItemSubTitle: 'Blok Seç',
    showItemGroupSubTitle: 'Blok Seç',
    showItemItemSubTitle: 'Öğe Seç',
    scrollToBlockGroupSubTitle: 'Sayfa Seç',
    scrollToBlockItemSubTitle: 'Blok Seç',
    scrollToItemGroupSubTitle: 'Blok Seç',
    scrollToItemItemSubTitle: 'Öğe Seç',
    linkGroupPlaceholder: 'Bir blok seçin...',
    linkItemPlaceholder: 'Bir bağlantı seçin...',
    openPageItemPlaceholder: 'Bir sayfa seçin...',
    openProductGroupPlaceholder: 'Bir ürün türü seçin...',
    openProductItemPlaceholder: 'Bir ürün seçin...',
    showProductGroupPlaceholder: 'Bir ürün grubu seçin...',
    showProductItemPlaceholder: 'Bir ürün seçin...',
    openBlogGroupPlaceholder: 'Bir blog kanalı seçin...',
    openBlogItemPlaceholder: 'Bir blog makalesi seçin...',
    openBlockGroupPlaceholder: 'Bir sayfa seçin...',
    openBlockItemPlaceholder: 'Bir blok seçin...',
    openItemGroupPlaceholder: 'Bir sayfa ve blok seçin...',
    openItemItemPlaceholder: 'Bir öğe seçin...',
    showBlogGroupPlaceholder: 'Bir blog grubu seçin...',
    showBlogItemPlaceholder: 'Bir blog yazısı seçin...',
    showBlockGroupPlaceholder: 'Bir sayfa seçin...',
    showBlockItemPlaceholder: 'Bir blok seçin...',
    showItemGroupPlaceholder: 'Bir sayfa ve blok seçin...',
    showItemItemPlaceholder: 'Bir öğe seçin...',
    scrollToBlockGroupPlaceholder: 'Bir sayfa seçin...',
    scrollToBlockItemPlaceholder: 'Bir blok seçin...',
    scrollToItemGroupPlaceholder: 'Bir sayfa ve blok seçin...',
    scrollToItemItemPlaceholder: 'Bir öğe seçin...',
    linkReadable: 'Bağlantı',
    urlReadable: 'URL',
    openInAppReadable: 'Uygulamada Aç',
    downloadDocumentReadable: 'Belgeyi İndir',
    sendEmailReadable: 'E-posta Gönder',
    phoneCallReadable: 'Telefon Araması',
    openPageReadable: 'Sayfayı Aç',
    openProductReadable: 'Ürünü Aç',
    showNewModalReadable: 'Yeni Pencere Göster',
    showProductReadable: 'Ürünü Göster',
    openBlogReadable: 'Blogu Aç',
    openBlockReadable: 'Bloğu Aç',
    openItemReadable: 'Öğeyi Aç',
    showBlogReadable: 'Blogu Göster',
    showBlockReadable: 'Bloğu Göster',
    showItemReadable: 'Öğeyi Göster',
    scrollToBlockReadable: 'Bloğa Kaydır',
    scrollToItemReadable: 'Öğeye Kaydır',
  },
  design: {
    textColorHint: 'Bu bloğun içeriğinin rengi. Başlığın kendi rengi vardır.',
    tabs: 'Sekmeler',
    imageView: 'Görsel görünümü',
    preview: 'Önizleme',
    buttonOpacity: 'Düğme şeffaflığı',
    buttonBorder: 'Düğme kenarlığı',
    buttonShadow: 'Düğme gölgesi',
    itemView: 'Öğe görünümü',
    itemViewTooltip: 'Öğe görünümü seçin',
    itemLayout: 'Öğe düzeni',
    itemLayoutTooltip: 'Öğe düzeni seçin',
    top: 'Üst',
    center: 'Orta',
    bottom: 'Alt',
    bottomLeft: 'Sol Alt',
    bottomHorizontal: 'Alt Yatay',
    under: 'Altında',
    title: 'Başlık',
    titleButton: 'Başlık ve Düğme',
    displayOptions: 'Görüntüleme seçenekleri',
    displayOptionsTooltip: 'Görüntüleme seçeneklerini seçin',
    landscape: 'Yatay',
    square: 'Kare',
    portrait: 'Dikey',
    desktopMode: 'Masaüstü modu',
    mobile: 'Kompakt',
    desktop: 'Geniş',
    responsive: 'Duyarlı',
    custom: 'Özel',
    templates: 'Şablonlar',
    chooseTemplates: 'Şablonlarınızı seçin',
    viewAll: 'Tümünü gör',
    previousTheme: 'Önceki temanın kalıcı olarak silineceğini lütfen unutmayın.',
    useThisTemplate: 'Bu şablonu kullan',
    notSupportedVideo: 'Tarayıcınız video etiketini desteklemiyor.',
    photosBy: 'Fotoğraflar:',
    animationBy: 'Animasyon:',
    searchTheSame: 'Farklı sonuçlar için aynı terimi tekrar arayın.',
    addImage: 'Görsel ekle',
    addVideo: 'Video ekle',
    orSelectFrom: 'veya şuradan seçin',
    noImagesYet: 'Henüz görsel yok',
    noVideosYet: 'Henüz video yok',
    videoBy: 'Video:',
    hamburgerMenu: 'Hamburger menü',
    tabsOnTop: 'Üstte sekmeler',
    tabsOnBottom: 'Altta sekmeler',
    borderType: 'Kenarlık türü',
    subTitle: 'Şekil, kenarlık türü, gölge vb. seçin.',
    icon: 'Simge',
    iconTooltip: 'Düğmeniz için doğru simgeyi seçin',
    background: 'Arka plan',
    color: 'Renk',
    backgroundOpacity: 'Arka plan opaklığı',
    backgroundOpacityTooltip: 'Arka plan opaklığını ayarlamak için kaydırıcıyı sürükleyin',
    gradient: 'Degrade',
    color1: 'Renk 1',
    color2: 'Renk 2',
    direction: 'Yön',
    directionTooltip: 'Degradenin yönünü ayarlamak için kaydırıcıyı sürükleyin',
    offset: 'Kayma',
    offsetTooltip: 'Degradenin kaymasını ayarlamak için kaydırıcıyı sürükleyin',
    minHeight: 'Minimum yükseklik',
    minHeightTooltip: 'Düğmenin minimum yüksekliğini değiştirmek için kaydırıcıyı sürükleyin',
    align: 'Hizala',
    alignTooltip: 'Düğme konumunu değiştir',
    insert: 'URL ekle',
    upload: 'Video yükle',
    search: 'Video ara',
    layout: 'Düzen',
    layoutTooltip: 'İstediğiniz düzeni seçin',
    view: 'Görünüm',
    viewTooltip: 'İstediğiniz görünümü seçin',
    media: 'Medya',
    mediaTooltip: 'İstediğiniz medyayı seçin',
    none: 'Yok',
    small: 'Küçük',
    medium: 'Orta',
    large: 'Büyük',
    round: 'Yuvarlak',
    feed: 'Akış',
    slider: 'Kaydırıcı',
    text: 'Metin',
    colorTooltip: 'Renkleri seçin',
    button: 'Düğme',
    buttonTooltip: 'Düğme renklerini seçin',
    chooseEmoji: 'Emoji seç',
    changeEmoji: 'Emojinizi değiştirin',
    quantum: 'Quantum',
    emoji: 'Emoji',
    warp: 'Warp',
  },
  components: {
    quickAdd: {
      addLink: 'Bağlantı ekle',
      addVideo: 'Video ekle',
      addProduct: 'Ürün ekle',
      addPost: 'Gönderi ekle',
      addArticle: 'Makale ekle',
      addPhoto: 'Fotoğraf ekle',
      addMusic: 'Müzik ekle',
      addFiles: 'Dosya ekle',
      addStory: 'Hikaye ekle',
    },
    emoji: {
      search: 'Ara',
      clear: 'Temizle',
      notfound: 'Emoji Bulunamadı',
      skintext: 'Varsayılan ten tonunuzu seçin',
      categories: {
        search: 'Arama Sonuçları',
        recent: 'Sık Kullanılanlar',
        smileys: 'Yüzler ve Duygular',
        people: 'İnsanlar ve Vücut',
        nature: 'Hayvanlar ve Doğa',
        foods: 'Yiyecek ve İçecek',
        activity: 'Etkinlik',
        places: 'Seyahat ve Yerler',
        objects: 'Nesneler',
        symbols: 'Semboller',
        flags: 'Bayraklar',
        custom: 'Özel',
      },
      categorieslabel: 'Emoji Kategorileri',
      skintones: {
        1: 'Varsayılan Ten Tonu',
        2: 'Açık Ten Tonu',
        3: 'Orta-Açık Ten Tonu',
        4: 'Orta Ten Tonu',
        5: 'Orta-Koyu Ten Tonu',
        6: 'Koyu Ten Tonu',
      },
    },
    blogPreviewModal: {
      title: 'Blog Önizleme',
      notify: 'Aboneleri bilgilendir',
    },
    standAloneModal: {
      title: 'Bağlantı Önizleme',
      save: 'Kaydet',
      chooseLayout: 'Bağlantınız için bir düzen seçin',
      linkSettings: 'Bağlantı Ayarları',
      linkSettingsSubtitle: 'Yönlendirme, görünüm',
      whenVisitorsClicks: 'Bir ziyaretçi bu bağlantıya tıkladığında:',
      redirect: 'Yönlendir',
      redirectText: `Ziyaretçileri doğrudan URL'ye gönder`,
      highlight: 'Vurgula',
      highlightText: `Ziyaretçileri UniLink'inize yönlendirin ve vurgulayın`,
      standalone: 'Bağımsız',
      standaloneText: 'YouTube bağlantınızı öne çıkarın ve içeriğin doğrudan üzerinde oynatılmasını sağlayın',
      cover: 'Kapak',
      imageTab: 'Görsel',
      videoTab: 'Video',
      uploadImage: 'Görsel yükle',
      whenVisitors: 'Bir ziyaretçi paylaşılan bağlantıyı seçtiğinde:',
      compact: 'Kompakt görünüm',
      fullView: 'Tam görünüm',
      videoSound: 'Videoyu sesli oynat',
    },
    instagramModal: {
      title: `Otomatik Instagram DM'leri gönder`,
      subtitle: `Birisi IG gönderinize veya Reel'inize yorum yaptığında bu bağlantıyı doğrudan mesaj olarak gönderin`,
      promo: 'Hangi IG hesabından göndermek istediğinizi seçin',
      connect: 'Instagram hesabını bağla',
      added: 'Instagram hesabı eklendi',
      addNew: 'Yeni otomasyon ekle',
      igContent: 'IG içeriği',
      trigger: 'Tetikleyici',
      dmContent: 'DM',
      linkDestination: 'Bağlantı Hedefi',
      buttonTitle: 'Buton başlığı',
      buttonTitleTooltip: 'Buton başlığını girin',
      directMessage: 'Direkt mesaj',
      directMessageTooltip: 'Direkt mesajı girin',
      selectPosts: `Otomatik DM'inizi tetikleyecek gönderiyi veya Reel'i seçin.`,
      onePost: 'Belirli bir gönderi veya Reel',
      allPosts: `Tüm gönderiler veya Reel'ler`,
      triggerText: `Yorumlar bunu içerdiğinde DM'iniz gönderilir.`,
      addMessage: 'Bağlantınızla birlikte otomatik gönderilecek bir mesaj ekleyin.',
      clickLink: `Birisi DM'inizdeki bağlantıya tıkladığında:`,
      anyComment: 'Herhangi bir yorum',
      storiesAndDms: 'Stories & DMs',
      anyMessage: 'Herhangi bir mesaj',
      specificKeywords: 'Belirli anahtar kelimeleri içeren yorumlar',
      sendLink: `Onları UniLink'inize yönlendirin ve öne çıkarın `,
      skipLink: `UniLink'i atlayın ve onları doğrudan gönderin`,
      keywordsTitle: 'Belirli anahtar kelimeleri içeren yorumlar',
      keywordsText: "DM'leriniz, yorumlar belirli anahtar kelimeleri içerdiğinde\nveya hariç tuttuğunda gönderilir (büyük/küçük harfe duyarlı değildir):",
      keywordsPlaceholder: 'Bir anahtar kelime yazın',
      keywordsExclude: 'Anahtar kelimeleri hariç tut',
      keywordsExcludeText: 'Bunlardan herhangi birini hariç tutmalı',
      replyComment: 'Yorumu yanıtla',
      replyCommentTooltip: 'Yanıt yorumunu girin',
    },
    blockEditProduct: {
      productPreview: 'Küçük resim',
      productDetails: 'Detaylar',
      settings: 'Ayarlar',
      design: 'Tasarım',
    },
    editMenuItems: {
      overview: 'Genel Bakış',
      analytics: 'Analitik',
    },
    botToken: {
      bot: 'Bot',
      botTooltip: `Botunuzun token'ını girin`,
      connect: 'Bağlan',
      token: 'Token',
    },
    rewards: {
      title: 'Başlık',
      titleTooltip: 'Yanıt için başlık girin',
      text: 'Metin',
      textTooltip: 'Yanıt için metin girin',
      link: 'Bağlantı',
      linkTooltip: 'Yanıt için bağlantı girin',
      code: 'Kod',
      codeTooltip: 'Yanıt için kod girin',
      files: 'Dosyalar',
      filesTooltip: 'Yanıt için dosyaları girin',
      removeReward: 'Bu yanıtı kaldırmak istediğinizden emin misiniz?',
    },
    addRewardModal: {
      addReward: 'Yanıt Ekle',
      textTitle: 'Metin',
      textText: 'Rich Editor ile talimatlara veya herhangi bir metne erişim verin',
      fileTitle: 'Dosyalar',
      fileText: 'Dosyalara erişim verin ve iletişim bilgilerini toplayın',
      linkTitle: 'Bağlantı',
      linkText: 'Özel içeriğe erişim verin ve iletişim bilgilerini toplayın',
      codeTitle: 'Kod',
      codeText: 'Özel promosyonlara erişim verin ve iletişim bilgilerini toplayın',
    },
    blockEmpty: {
      isNotAdded: 'eklenmedi',
      itSeems: 'Görünüşe göre',
      itemsNot: 'öğeleriniz henüz eklenmedi. Videolarınızı şimdi ekleyin',
      add: 'Ekle',
    },
    blockList: {
      add: 'Ekle',
      item: 'öğe',
    },
    submitAction: {
      action: 'Eylem (gönderdikten sonra)',
      actionTooltip: 'Gönderdikten sonra bir eylem seçin',
      upload: 'Ek yükleyin',
      none: 'Yok',
      page: 'Onay Sayfasını Göster',
      email: 'Onay E-postası Gönder',
      redirect: `URL'ye Yönlendir`,
    },
    blockEditItem: {
      content: 'İçerik',
      preview: 'Önizleme',
      settings: 'Ayarlar',
    },
    domainButton: {
      customizeDomain: 'Alan adınızı özelleştirin.',
      upgradeToLink: `Link in Bio Pro'ya yükseltin ve özel bir alan adı kullanın.`,
    },
    coverText: {
      text: 'Metin',
      textTooltip: 'Kapağınıza metin girin',
      description: 'Açıklama',
      descriptionTooltip: 'Kapağınıza açıklama girin',
      textColor: 'Metin rengi',
    },
    itemModal: {
      edit: 'Düzenle',
      addNew: 'Yeni ekle',
      item: 'öğe',
      update: 'Güncelle',
      add: 'Ekle',
    },
    productSheet: {
      openFullEditor: 'Tam düzenleyiciyi aç',
      copyLink: 'Bağlantıyı kopyala',
      active: 'Aktif',
      notActive: 'Aktif değil',
      statistics: 'İstatistikler',
      clicks: 'Tıklamalar',
      sales: 'Satışlar',
      revenue: 'Gelir',
      onlyName: 'Yalnızca ad zorunlu',
      name: 'Ad',
      required: 'Zorunlu',
      price: 'Fiyat',
      optional: 'İsteğe bağlı',
      free: 'Ücretsiz',
      appearance: 'Görünüm',
      cover: 'Kapak',
      coverNote: 'Kare, en az 600×600. Daha sonra da ekleyebilirsiniz.',
      description: 'Açıklama',
      descriptionPlaceholder: 'İçeriği bir satırda anlatın',
      remove: 'Kaldır',
      photo: 'Fotoğraf',
      enterName: 'Bir ad girin',
      adding: 'Ekleniyor…',
    },
    viewDesign: {
      compact: 'Kompakt',
      card: 'Kart',
      button: 'Düğme',
      list: 'Liste',
      hero: 'Hero',
      featured: 'Öne Çıkan',
    },
    moveItemModal: {
      title: 'Öğeyi başka bir sayfaya taşı',
      cancel: 'İptal',
      move: 'Taşı',
      page: 'Sayfa',
      pageTooltip: 'Öğeyi taşımak için bir sayfa seçin',
      blocks: 'Bloklar',
      blocksTooltip: 'Öğeyi taşımak için bir blok seçin',
      emptyBlocks: 'Bu sayfada gerekli blok yok.',
    },
    limitModal: {
      title: 'Limite ulaşıldı',
      text1: 'Sitenizin limitine ulaştınız.',
      text2: 'Planınızı yükseltmek için lütfen bizimle iletişime geçin.',
      close: 'Kapat',
    },
    cropPicture: {
      title: 'Görselinizi kırpın',
      cancel: 'İptal',
      save: 'Kaydet',
    },
    uploadFile: {
      uploadProductImage: 'Ürün görseli yükleyin',
      coverImage: 'Kapak görseli',
      uploadImages: 'Buraya yalnızca görsel yükleyebilirsiniz',
    },
    userMediaLibrary: {
      addImage: 'Görsel ekle',
      uploadImage: 'Görsel yükle',
      orSelectFrom: 'veya yükleyin',
      orSelectLink: 'veya bağlantı yapıştırın',
      myMedia: 'Medyalarım',
      stockImages: 'Stok Görseller',
      gifs: `GIF'ler`,
      icons: 'Simgeler',
      noImagesYet: 'Henüz görsel yok',
      loadMore: 'Daha fazla yükle',
    },
    itemMenu: {
      active: 'Aktif',
      willBeAvailable: 'Öğe şurada erişilebilir olacak:',
      save: 'Kaydet',
      copied: 'Kopyalandı',
      copyLink: 'Bağlantıyı kopyala',
      delete: 'Sil',
    },
    itemDesign: {
      linkColor: 'Bağlantı rengi',
      gradient: 'Gradyan',
      background: 'Arka plan',
      backgroundOpacity: 'Arka plan opaklığı',
      backgroundOpacityTooltip: 'Arka plan opaklığını ayarlamak için kaydırıcıyı sürükleyin',
      backgroundDarkness: 'Arka plan koyuluğu',
      backgroundDarknessTooltip: 'Arka plan koyuluğunu ayarlamak için kaydırıcıyı sürükleyin',
      text: 'Metin',
      color1: 'Renk 1',
      color2: 'Renk 2',
      direction: 'Yön',
      directionTooltip: 'Gradyanın yönünü ayarlamak için kaydırıcıyı sürükleyin',
      offset: 'Ofset',
      offsetTooltip: 'Gradyanın ofsetini ayarlamak için kaydırıcıyı sürükleyin',
      linkHeight: 'Bağlantı yüksekliği',
      linkHeightTooltip: 'Düğmenin yüksekliğini değiştirmek için kaydırıcıyı sürükleyin',
      icon: 'Simge',
      iconTooltip: 'Düğmeniz için simge seçin',
      imageShape: 'Görsel Şekli',
      imageShapeTooltip: 'Bağlantınız için görsel şekli seçin',
    },
    menu: {
      linkInBio: `Bio'da bağlantı`,
      linkInBioApps: `Bio'da Bağlantı`,
      posts: 'Gönderiler',
      audience: 'Kitle',
      orders: 'Siparişler',
      marketing: 'Pazarlama',
      emailMarketing: 'E-posta Pazarlama',
      socialPlanner: 'Sosyal Planlayıcı',
      shortLinks: 'Kısa Bağlantılar',
      businessCards: 'Kartvizitler',
      recentProfiles: 'Son Profiller',
      standalonePage: 'Bağımsız Sayfa',
      soloApps: `Bio'da Uygulama`,
      bots: 'Botlar',
      smartReply: 'Instagram Reply',
      analytics: 'Analitik',
      settings: 'Ayarlar',
      shop: 'Kazan',
      publish: 'Yayınla',
      studio: 'Stüdyo',
      blog: 'Blog',
      qrCodes: 'QR Kodları',
      singlePages: 'Uygulamalar',
      forms: 'Formlar',
      form: 'Formlar',
      automations: 'Otomasyonlar',
      community: 'Topluluk',
      messages: 'Gelen Kutusu',
      agents: 'Temsilciler',
      apps: 'Uygulamalar',
      emailSignatures: 'E-posta İmzaları',
      virtualBackgrounds: 'Sanal Arka Planlar',
    },
    notificationsBlockSetting: {
      title: 'Bildirimler',
      setUp: 'Kur',
      notifications: 'bildirimler',
      connect: 'Bağlan',
      telegramText: 'Biri işlem yaptığında Telegram bildirimi alın',
      change: 'değiştir',
      email: 'E-posta',
      emailText: 'Biri işlem yaptığında e-posta alın',
      webhook: 'Webhook',
      webhookTooltip: 'Webhook ekle',
      activate: 'Etkinleştir',
      webhookText: 'Birisi işlem yaptığında 3. taraf web sitesine olay gönder',
      webhookURL: 'Webhook URL (POST isteği)',
      error: 'Doğru bağlantıyı girin',
      save: 'Kaydet',
    },
    navigation: {
      content: 'İçerik',
      pages: 'Sayfalar',
      posts: 'Gönderiler',
      shop: 'Mağaza',
      blog: 'Blog',
      design: 'Tasarım',
      analytics: 'Analitik',
      settings: 'Ayarlar',
      apps: 'Uygulamalar',
      store: 'Mağaza',
    },
    headerSettings: {
      design: 'Tasarım',
      analytics: 'Analitik',
      settings: 'Ayarlar',
      editTabs: 'Sekmeleri Düzenle',
    },
    unlockModal: {
      title: 'Pro Özellikleri Aç',
      text: `Link-in-bio'nuzdan daha fazlasını elde edin. Yalnızca $5/ay — Pro'nun sunduğu her şeyi açın:`,
      checkBoxTitle1: 'Daha Fazla Blok:',
      checkBoxText1: 'Form, mağaza, geri sayım ve medya oynatıcı ekleyin',
      checkBoxTitle2: 'Gelişmiş Analitik:',
      checkBoxText2: 'Tıklamaları, görüntülemeleri ve kitle bilgilerini takip edin',
      checkBoxTitle3: 'Özel Alan Adı:',
      checkBoxText3: 'Profesyonel bir görünüm için kendi alan adınızı kullanın',
      checkBoxTitle4: 'Yerleşik Mağaza:',
      checkBoxText4: 'Ürünleri kolayca satın ve siparişleri yönetin',
      checkBoxTitle5: 'SEO Araçları:',
      checkBoxText5: `Meta etiketler, UTM ve özel slug'larla daha üst sıralarda yer alın`,
      checkBoxTitle6: 'Entegrasyonlar:',
      checkBoxText6: 'Mailchimp, Zapier ve diğer araçlarla senkronize edin',
      checkBoxTitle7: 'E-posta Pazarlama:',
      checkBoxText7: 'Potansiyel müşteri toplayın ve otomatik kampanyalar gönderin',
      checkBoxTitle8: 'Öncelikli Destek:',
      checkBoxText8: 'İhtiyaç duyduğunuzda daha hızlı yardım alın',
      upgradeToPro: `Pro'ya Yükselt`,
      viewAllPlans: 'Tüm planları görüntüle',
    },
    profileSwitcher: {
      title: 'Tüm Profiller',
      button: 'Yeni profil ekle',
    },
    account: {
      signOut: 'Çıkış yap',
      createNew: 'Yeni bir Link in Bio oluştur',
      tryPro: `Pro'yu şimdi deneyin!`,
      tryProText: 'Daha fazla ziyaretçi için gelişmiş özelleştirme ve daha derin kitle bilgileri edinin!',
    },
    accountSettings: {
      title: 'Hesap ayarları',
    },
    billingHistory: {
      title: 'Fatura geçmişi',
    },
    pages: {
      home: 'Ana Sayfa',
      newPage: 'Yeni Sayfa',
      managePages: 'Sayfaları Yönet',
    },
    blockItem: {
      actionRequired: 'işlem gerekli',
      hidden: 'Gizli · kimse görmüyor',
    },
    blockContent: {
      untitled: 'Başlıksız',
      clickToRename: 'Alt başlığı yeniden adlandırmak için tıklayın',
      saving: 'kaydediliyor',
      saved: 'kaydedildi',
      deleteTitle: 'Bu bloğu silmek istediğinize emin misiniz?',
      cancel: 'İptal',
      yes: 'Evet',
    },
    addButtonModal: {
      title: 'Eylem düğmesi ekle',
      close: 'Kapat',
      added: 'Eklendi',
      add: 'Ekle',
      messageTitle: 'Mesaj',
      messageText: 'Mesaj düğmesi, kullanıcıların sizinle messenger üzerinden iletişim kurmasını sağlar',
      subscribeTitle: 'Abone Ol',
      subscribeText: 'Abone Ol düğmesi, kullanıcıların e-posta veya messenger listenize abone olmasını sağlar',
      ctaTitle: 'CTA düğmesi',
      ctaText: 'CTA, kullanıcıya belirli bir eylemi gerçekleştirmesini söyleyen bir web sitesi yönlendirmesidir',
      cartTitle: 'Sepet',
      cartText: 'Ziyaretçilerin web sitenizden alışveriş yapabileceğini belirtmek için alışveriş sepeti simgesi gösterin',
      contactTitle: 'İletişim',
      contactText: 'Ziyaretçilerin iletişim bilgilerinize hızlıca erişmesini sağlayın',
      qrcodeTitle: 'QR Kodu',
      qrcodeText: 'Ziyaretçilerin sayfanızı hızlıca tarayıp paylaşabilmesi için QR kodu gösterin',
      languageTitle: 'Dil',
      languageText: 'Ziyaretçilerin sayfanızın dilini değiştirmesine izin verin',
      searchTitle: 'Ara',
      searchText: 'Ziyaretçilerin mağaza ürünlerinizi doğrudan başlıktan aramasına izin verin',
    },
    inputMask: {
      copyLink: 'Bağlantıyı kopyala',
    },
    videoLibrary: {
      addVideo: 'Video ekle',
      myVideos: 'Videolarım',
      stockVideos: 'Stok Videolar',
      pasteUrl: 'URL yapıştır',
      uploadVideo: 'Video Yükle',
    },
    createBlockModal: {
      searchTitle: 'Sayfanız için bir blok seçin',
      title: `UniLink'e ekle`,
      contentTitle: 'İçerik',
      contentText: 'Sayfanızı oluşturun ve yönetin',
      growTitle: 'Potansiyel Müşteriler',
      growText: 'Potansiyel müşteri toplayın ve etkileşimi artırın',
      monetizeTitle: 'Para Kazan',
      monetizeText: 'Ürün, içerik ve hizmet satın',
      monetizationTitle: 'Para kazanın ve toplayın',
      monetizationText: 'Ürün, hizmet satın ve bahşiş toplayın',
      socialTitle: 'Sosyal medya içeriği',
      socialText: `UniLink'inizde sosyal medya içeriği paylaşın`,
      toolsTitle: 'Büyüme araçları',
      toolsText: 'Kitlenizi büyütün, yönetin ve onlarla bağlantı kurun',
      search: 'Ara',
      all: 'Tümü',
      allCategories: 'Tüm kategoriler',
      content: 'İçerik',
      monetization: 'Para Kazanma',
      social: 'Sosyal',
      tools: 'Araçlar',
      header: 'Başlık',
      headerText: 'Profil resmi ve biyografi ekleyin',
      link: 'Bağlantılar',
      linkText: 'Bağlantı düzenini seçin',
      text: 'Metin',
      textText: 'Metin düzenini seçin',
      videos: 'Videolar',
      videosText: 'Video türünü seçin',
      image: 'Görsel',
      imageText: 'Görsel blokları ekleyin',
      music: 'Müzik',
      musicText: 'Müzik türünü seçin',
      socialFeeds: 'Sosyal Akışlar',
      socialFeedsText: 'Sosyal akış türünü seçin',
      moreContent: 'Daha Fazla',
      moreContentText: 'Daha fazla içerik bloğu ekle',
      dataCollect: 'Veri Toplama',
      dataCollectText: 'Veri toplama türünü seçin',
      form: 'Form',
      formText: 'Form türünü seçin',
      conversionTools: 'Etkileşim araçları',
      conversionToolsText: 'Dönüşüm blokları ekle',
      products: 'Ürünler',
      productsText: 'Ürün blokları ekle',
      donation: 'Bahşiş ve Bağışlar',
      tipsAndDonations: 'Bahşiş ve Bağışlar',
      tipsDonationsText: 'Bahşiş ve bağış blokları',
      event: 'Etkinlik',
      eventText: 'Etkinlik türünü seçin',
      quickAdd: 'Tüm bloklar',
      quickAddText: 'Herhangi bir blok ekle',
    },
    addBlockModal: {
      title: `UniLink'e ekle`,
      dragToAdd: 'Eklemek için sürükle',
      contentTitle: 'Temel içerik paylaş',
      contentText: `UniLink'inizde içeriği doğrudan paylaşın`,
      monetizationTitle: 'Para kazanın ve toplayın',
      monetizationText: 'Ürün, hizmet satın ve bahşiş toplayın',
      socialTitle: 'Sosyal medya içeriği',
      socialText: `UniLink'inizde sosyal medya içeriği paylaşın`,
      toolsTitle: 'Büyüme araçları',
      toolsText: 'Kitlenizi büyütün, yönetin ve onlarla bağlantı kurun',
      search: 'Ara',
      searchPlaceholder: 'İçerik ara...',
      all: 'Tümü',
      allCategories: 'Tüm kategoriler',
      content: 'İçerik',
      monetization: 'Para Kazanma',
      social: 'Sosyal',
      tools: 'Araçlar',
      suggestTitle: 'Bloğunu öner',
      suggestText: 'Bir blok mu eksik? Ne görmek istediğinizi söyleyin',
      suggestModalTitle: 'Blok öner',
      suggestModalSubtitle: `UniLink'te olmasını istediğiniz bloğu anlatın. Her fikri okuyoruz.`,
      suggestPlaceholder: 'ör. Google Takvim senkronizasyonlu bir rezervasyon bloğu…',
      suggestSubmit: 'Öneriyi gönder',
      suggestSending: 'Gönderiliyor…',
      suggestSuccessTitle: 'Öneri gönderildi!',
      suggestSuccess: 'Teşekkürler! Her fikri okuyup yol haritamızı şekillendirmek için kullanıyoruz.',
      suggestError: 'Gönderilemedi. Lütfen tekrar deneyin.',
    },
    tabNavigation: {
      tabView: 'Sekme görünümü',
      tabViewTooltip: 'Gezinme için sekme görünümü seçin',
      colors: 'Renkler',
      colorsTooltip: 'Gönderi ve düğmelerin renklerini seçin',
      tabs: 'Sekmeler',
      tabsTooltip: 'Web sitesi gezintisinde gösterilecek sekmeleri seçin',
      content: 'İçerik',
      posts: 'Gönderiler',
      store: 'Mağaza',
      shop: 'Mağaza',
      tabsSettings: 'Sekme gezinme ayarları',
    },
    hideLogo: {
      text: 'Sayfanızın altbilgisinde UniLink logosunu gösterin.',
      text2: 'Sayfanızın altbilgisinde UniLink logosunu gösterin.',
    },
    palettePreview: {
      custom: 'Özel Arka Plan Rengi',
      hexColor: 'Hex renk',
      hexColorTooltip: 'Önizlemenizin hex rengini girin',
    },
    backgroundVideo: {
      insert: 'URL ekle',
      upload: 'Video yükle',
      search: 'Video ara',
    },
    periodDropdown: {
      today: 'Bugün',
      yesterday: 'Dün',
      last7days: 'Son 7 gün',
      last30days: 'Son 30 gün',
      allTime: 'Tüm zamanlar',
      custom: 'Özel',
    },
    subsections: {
      content: 'İçerik',
      design: 'Tasarım',
      settings: 'Ayarlar',
    },
    wrapperSettings: {
      lock: 'PRO Plana Yükselt',
    },
    shareModal: {
      addSocials: 'Sosyallere Ekle',
      shareTo: 'Şuraya paylaş',
      qrCode: 'QR kodu',
      customizeUrl: `URL'yi Özelleştir`,
      goToMy: 'Şuna git:',
      print: 'Benzersiz QR kodunuzu şuraya yazdırabilirsiniz:',
      cards: 'kartvizitler ve broşürler',
      download: 'İndir',
      copy: 'Kopyala',
      previewMobile: 'Mobilde önizle',
      scanMobilePreview: 'Web sitenizi önizlemek için mobil cihazınızda QR kodunu tarayın',
      types: {
        socials: 'sosyaller',
        shareTo: 'paylaş',
        qrCode: 'QR',
        title: `UniLink'inizi paylaşın`,
        titleSocials: `UniLink'i sosyallerinize ekleyin`,
        titleShareTo: 'Şuraya paylaş...',
        titleQRCode: 'QR Kodu',
        titlePreviewMobile: 'Mobilde Önizle',
      },
      socialList: {
        instagramText: `UniLink'inizi Instagram profilinize ekleyin. UniLink URL'nizi kopyalayın, Profili Düzenle bölümüne gidin ve Web Sitesi alanına yapıştırın.`,
        facebookText: `UniLink'inizi Facebook profilinize ekleyin. UniLink URL'nizi kopyalayın, profilinizdeki Hakkında sayfasına gidin, İletişim ve temel bilgiler'e tıklayın, ardından + Web sitesi ekle'ye tıklayın, UniLink URL'nizi Web sitesi adresi alanına yapıştırın ve Kaydet'e tıklayın.`,
        tikTokText: `UniLink'inizi Facebook profilinize ekleyin. UniLink URL'nizi kopyalayın, profilinizdeki Hakkında sayfasına gidin, İletişim ve temel bilgiler'e tıklayın, ardından + Web sitesi ekle'ye tıklayın, UniLink URL'nizi Web sitesi adresi alanına yapıştırın ve Kaydet'e tıklayın.`,
        twitchText: `UniLink'inizi Twitch kanalınıza ekleyin. UniLink URL'nizi kopyalayın, Twitch kanalınıza gidin, Hakkında'ya tıklayın, ardından Hakkında ve bağlantı ayarlarını düzenle'ye tıklayın, Sosyal Bağlantılar'a kadar aşağı kaydırın, ilk metin alanına UniLink yazın ve UniLink URL'nizi ikinci metin alanına yapıştırın, ardından Ekle'ye tıklayın.`,
        youTubeText: `UniLink'inizi YouTube kanalınıza ekleyin. UniLink URL'nizi kopyalayın, YouTube kanalınıza gidin, Kanalı Özelleştir'e tıklayın, ardından Temel bilgiler'e tıklayın ve Bağlantılar altında bir bağlantı başlığı ekleyip UniLink URL'nizi URL alanına yapıştırın, ardından Yayınla'ya tıklayın.`,
        linkedInText: `UniLink'inizi LinkedIn profilinize ekleyin. UniLink URL'nizi kopyalayın, LinkedIn profilinize gidin, kalem simgesine tıklayın, İletişim bilgileri'ne kadar aşağı kaydırın, UniLink URL'nizi Web Sitesi URL'si alanına yapıştırın, ardından Uygula'ya tıklayın.`,
        pinterestText: `UniLink'inizi Pinterest profilinize ekleyin. UniLink URL'nizi kopyalayın, Pinterest ayarlarınıza gidin, UniLink URL'nizi Web Sitesi URL'si alanına yapıştırın, ardından Kaydet'e tıklayın.`,
        twitterText: `UniLink'inizi Twitter profilinize ekleyin. UniLink URL'nizi kopyalayın, profilinize gidin, Profili Düzenle'ye tıklayın ve UniLink URL'nizi Web Sitesi alanına yapıştırın.`,
      },
      share: {
        shareFacebook: `Facebook'ta Paylaş`,
        shareLinkedIn: `LinkedIn'de Paylaş`,
        shareTwitter: `Twitter'da Paylaş`,
        shareWhatsApp: 'WhatsApp ile Paylaş',
        shareMessenger: 'Messenger ile Paylaş',
        shareEmail: 'E-posta ile Paylaş',
      },
    },
  },
  popupMenu: {
    edit: 'Sayfayı düzenle',
    openInNewTab: 'Yeni sekmede aç',
    copyLink: `URL'yi Kopyala`,
    delete: 'Sil',
    showThumbnail: 'Sayfa küçük resimlerini panoda göster',
    manageTabs: 'Sekmeleri Yönet',
  },
  tabsDashboard: {
    labelAddNewTab: 'Yeni Sekme',
  },
  blocks: {
    header: {
      blockTitle: 'Başlık',
      blockText: 'Profil resminizi özelleştirin, kısa bir biyografi ekleyin ve sosyal simgelerinizi güncelleyin',
      blockShortText: 'Profilinizi özelleştirin',
      layout: 'Düzen',
      layoutTooltip: 'İstediğiniz başlık düzenini oluşturun',
      layoutAlign: 'Düzen hizalama',
      layoutAlignTooltip: 'Metni hizala',
      profilePicture: 'Profil resmi',
      profilePictureTooltip: 'Profil resminizi değiştirin',
      pictureSize: 'Resim boyutu',
      pictureSizeTooltip: 'Resim boyutunu değiştirebilirsiniz',
      pictureHeight: 'Resim yüksekliği',
      pictureHeightCaption: 'Resim yüksekliğini değiştirebilirsiniz',
      preview: 'Önizleme',
      badge: 'Rozet',
      badgeTooltip: 'Başlığa doğrulanmış rozet ekle',
      tags: 'Etiketler',
      tagsTooltip: 'Adınızın altında kategori etiketlerini gösterin (en fazla 5)',
      tagsAdd: 'Etiket ekle',
      addTags: '+ Etiket ekle',
      tagsEdit: 'Etiketleri düzenle',
      tagsCustomPlaceholder: 'Özel etiket ekle',
      tagsCustomAdd: 'Ekle',
      tagsSuggested: 'Önerilen kategoriler',
      tagsSelected: 'Seçilenler',
      tagsEmpty: 'Henüz etiket yok — önerilerden seçin veya kendinizinkileri ekleyin',
      tagsLimit: 'En fazla 5 etiket',
      visibility: 'Görünürlük',
      visibilityTooltip: 'Profil fotoğrafını göster veya gizle',
      cover: 'Kapak',
      coverTooltip: 'Başlık kapağına resim veya video ekle',
      addCover: 'Kapak ekle',
      image: 'Resim',
      video: 'Video',
      positionCover: 'Metin ve buton konumu',
      positionCoverTooltip: 'Konumu değiştirmek için kaydırıcıyı sürükleyin',
      buttons: 'Butonlar',
      block: 'Blok',
      videoProcessing: 'Video işleniyor',
      vibe: 'Vibe',
      vibeTooltip: `Vibe'ınızı ekleyin`,
      stories: 'Hikayeler',
      storiesTooltip: 'Hikayelerinizi ekleyin',
      addStory: 'Hikaye ekle',
      storiesSubtitle: 'Hikayelerinize resim veya video ekleyin',
      subscribeMethod: 'Abonelik yöntemi',
      subscribeMethodTooltip: 'Abonelik yönteminizi seçin',
      subscribeLink: 'Abonelik bağlantısı',
      subscribeLinkTooltip: 'Abonelik bağlantınızı kopyalayın',
      minWidth: 'Minimum genişlik',
      addVCard: 'vCard ekle',
      vCard: 'vCard',
      vCardTooltip: 'Kendinizle ilgili bilgi ekleyebilirsiniz',
      buttonInline: 'Satır içi başlık butonu',
      buttonInsideContact: 'İletişim butonu içinde buton',
      showSaveContact: `Kişiyi kaydet'i göster`,
      options: 'Seçenekler',
      showBusinessCard: 'Kartviziti göster',
      showBusinessCardCaption: 'Buraya bir “Kişiyi kaydet” düğmesi ekler.',
      editBusinessCard: 'Kartı düzenle',
      editContactDetails: `İletişim bilgilerini Business cards'ta düzenle`,
      needAddContact: 'İletişim butonu eklemeniz gerekiyor',
      socialGap: 'Boşluk',
      socialGapCaption: 'Boşluğu değiştirebilirsiniz',
      socialSize: 'Boyut',
      socialSizeCaption: 'Boyutu değiştirebilirsiniz',
      icons: 'İkonlar',
      iconsTooltip: 'Butona ikon ekle',
      bottomButtonsSettings: 'Alt düğmeler',
      bottomButtonsLayout: 'Düzen',
      bottomButtonsRow: 'Yan yana',
      bottomButtonsColumn: 'Üst üste',
      cropMismatch: 'Bu fotoğraf farklı bir düzen için kırpılmış.',
      adjustCrop: 'Kırpmayı ayarla',
      photoShapeLabel: 'Fotoğraf şekli',
      photoShapeTooltip: 'Bu düzenin kare fotoğrafı mı yoksa dikey kırpmayı mı göstereceğini seçin.',
      photoShapeSquare: 'Kare',
      photoShapeVertical: 'Dikey',
      coverShape: 'Kapak şekli',
      coverShapeTooltip: 'Kapağın alt kenarını seçin: düz, aşağı kavisli veya yukarı kavisli.',
      coverShapeStraight: 'Düz',
      coverShapeArcDown: 'Aşağı yay',
      coverShapeArcUp: 'Yukarı yay',
      avatarOffsetLabel: 'Avatar konumu',
      avatarOffsetTooltip: 'Avatarı kapak kenarına göre yukarı veya aşağı kaydırın.',
      photoStyleProTitle: 'Gelişmiş fotoğraf stillerinin kilidini açın',
      photoStyleProDesc: 'Arka plansız ve Metin arkada PRO özellikleridir.',
      photoShapeCustom: 'Özel',
      sliderStyleLabel: 'Kaydırıcı stili',
      sliderStyleTooltip: 'Kaydırma her seferinde bir fotoğraf gösterir; Galeri bir küçük resim satırı gösterir — ana fotoğrafı değiştirmek için bir küçük resme dokunun.',
      sliderStyleSwipe: 'Kaydırma',
      sliderStyleGallery: 'Galeri',
      photoPositionLabel: 'Fotoğraf konumu',
      photoPositionHint: 'Dikey çerçeveleme',
      verticalCropHint: 'Bu düzen orijinal bir fotoğraf gösterir. Görüntülemek istediğiniz dikey alanı seçin.',
      verticalCropReady: 'Bu düzende gösterilen dikey alanı ince ayarlayın.',
      pickVerticalArea: 'Dikey alanı seç',
      photoStyle: 'Fotoğraf stili',
      photoStyleTooltip: 'Fotoğrafı olduğu gibi, arka planı kaldırılmış olarak gösterin veya öznenin arkasına metin yerleştirin.',
      avatarModeOriginal: 'Orijinal',
      avatarModeCutout: 'Arka plansız',
      avatarModeLayered: 'Metin arkada',
      overlayText: 'Metin',
      overlayTextPlaceholder: 'Adınız (varsayılan)',
      overlayColor: 'Metin rengi',
      overlaySize: 'Boyut',
      overlayY: 'Dikey konum',
      overlayEffect: 'Animasyon',
      overlayEffectNone: 'Yok',
      overlayEffectShimmer: 'Parıltı',
      overlayEffectGlow: 'Işıltı',
      overlayEffectGradient: 'Gradyan',
      overlayEffectSparkle: 'Kıvılcım',
      overlayUsesName: 'Bu düzende metin, profil adınızdır — arkanızda görünür. “Ad” bölümünden düzenleyin.',
      cutoutGenerate: 'Kesit oluştur',
      cutoutRegenerate: 'Yeniden oluştur',
      cutoutUpload: 'Yükle',
      cutoutOr: 'veya',
      cutoutGenerating: 'Oluşturuluyor...',
      cutoutUploading: 'Yükleniyor...',
      cutoutVideoHint: 'Arka plan kaldırma yalnızca görsel fotoğraflarla çalışır, videoyla değil.',
      cutoutTimeout: 'Arka plan kaldırma çok uzun sürüyor. Lütfen tekrar deneyin.',
      profileBadges: 'Rozetler',
      profileBadgesTooltip: 'Adınızın yanında göstermek için en fazla 3 rozet seçin',
      profileBadgesProLockHint: `Bu rozeti kullanmak için PRO'ya yükseltin`,
      profileBadgesAdd: 'Rozet ekle',
      profileBadgesManage: 'Rozetleri yönet',
      profileBadgesModalTitle: 'Profilinize rozet ekleyin',
      profileBadgesModalSubtitle: 'Başarılarınızı ve ödüllerinizi sergileyin.',
      profileBadgesCustomCta: 'Kendi rozetinizi yükleyin',
      profileBadgesCustomDesc: 'Özel rozetiniz',
      profileBadgesCustomName: 'Rozet adı',
      profileBadgesCustomChoose: 'Görsel seç',
      profileBadgesCustomChange: 'Görseli değiştir',
      profileBadgesCustomUploading: 'Yükleniyor…',
      profileBadgesCustomAdd: 'Rozet ekle',
      ribbonLabel: 'Dekoratif şerit',
      ribbonLabelTooltip: 'Başlık kahramanının altına renkli bir çubuk ekleyin',
      addTint: 'Şerit ekle',
      ribbonTitle: 'Şerit',
      ribbonText: 'Şerit metni',
      ribbonTextPlaceholder: 'örn. Ay sonuna kadar %20 indirim',
      ribbonColor: 'Şerit rengi',
      ribbonTheme: 'Stil',
      ribbonThemes: {
        none: 'Dekor yok',
        birthday: 'Doğum günü',
        newyear: 'Yeni Yıl',
        valentine: 'Sevgililer Günü',
        halloween: 'Cadılar Bayramı',
        summer: 'Yaz',
      },
      ribbonEffect: 'Efekt',
      ribbonEffects: {
        none: 'Yok',
        gradient: 'Animasyonlu gradyan',
        shimmer: 'Parıltı',
        lights: 'Işık dizisi',
      },
      ribbonPosition: 'Konum',
      ribbonPositions: {
        bottom: 'Başlığın altında',
        underPhoto: 'Fotoğrafın altında',
      },
      ribbonRemove: 'Şeridi kaldır',
      statusBadges: 'Etkinlik',
      statusBadgesTooltip: 'Sayfanızda gerçek zamanlı etkinliği gösterin',
      addStatus: 'Etkinlik ekle',
      statusDisabledHint: 'Gizli · devre dışı',
      followersTitle: 'Takipçiler',
      followersCounter: 'Takipçi sayacı',
      followersTooltip: 'Bağlı sosyal hesaplarınızdan birleşik takipçi sayısını görüntüleyin',
    },
    text: {
      blockTitle: 'Metin',
      blockText: 'İstediğinizi yazabileceğiniz genel metin bloğu. Metninizi WYSIWYG düzenleyici ile biçimlendirebilirsiniz',
      blockShortText: 'Genel metin bloğu',
      title: 'Başlık',
      titleText: 'Başlık boyutunuzu özelleştirin',
      orderOfElements: 'Öğelerin sırası',
      orderOfElementsTooltip: 'Öğelerin sırasını değiştirmek için kaydırıcıyı sürükleyin',
      changeOrder: 'Sırayı değiştir',
      text: 'Metin',
      content: 'İçerik',
      image: 'Resim',
      button: 'Buton',
      addButtons: 'Daha fazla buton ekle',
      displayedContent: 'Görüntülenen içerik',
      displayedContentTooltip: 'İçeriği göster veya gizle',
      buttonLayout: 'Buton düzeni',
      buttonLayoutTooltip: 'Dikey veya yatay buton düzenini seçin',
    },
    timeline: {
      blockTitle: 'Zaman çizelgesi',
      blockText: 'Etkinliklerle dikey bir zaman çizelgesi görüntüleyin. Her etkinlikte tarih/saat, başlık, açıklama ve isteğe bağlı resim olabilir',
      blockShortText: 'Etkinlik zaman çizelgesini göster',
      editItem: 'Etkinliği düzenle',
      title: 'Başlık',
      titlePlaceholder: 'Etkinlik başlığı',
      subtitle: 'Alt başlık',
      subtitlePlaceholder: 'Rol veya bağlantı (isteğe bağlı)',
      description: 'Açıklama',
      descriptionPlaceholder: 'Etkinlik açıklaması (isteğe bağlı)',
      startTime: 'Başlangıç saati',
      endTime: 'Bitiş saati',
      startDate: 'Başlangıç tarihi',
      endDate: 'Bitiş tarihi',
      showEndDate: 'Bitiş tarihini göster',
      showEndDateTooltip: `Devam eden etkinlikler için kapatın (ör. "2023'ten beri burada çalışıyor")`,
      includeTime: 'Saati dahil et',
      includeTimeTooltip: 'Kapalıysa yalnızca tarih gösterilir, saat gösterilmez',
      image: 'Görsel',
      imagePlaceholder: 'Avatar veya simge yükleyin',
      imageUploadFailed: `Görsel yüklenemedi. Medyalarım'ı kullanın veya bağlantı yapıştırın.`,
      untitled: 'Başlıksız',
      listLayout: 'Liste düzeni',
      lineColor: 'Çizgi rengi',
    },
    trust: {
      blockTitle: 'Güven',
      blockShortText: 'Ortaklıklarınızı paylaşın',
      blockText: 'Tüm bağlantılarınızı tek bir yerde toplayın.',
      titleText: 'Başlık boyutunuzu özelleştirin',
      orderOfElements: 'Öğelerin sırası',
      orderOfElementsTooltip: 'Öğelerin sırasını değiştirmek için kaydırıcıyı sürükleyin',
      changeOrder: 'Sırayı değiştir',
      text: 'Metin',
      content: 'İçerik',
      image: 'Görsel',
      button: 'Düğme',
      displayedContent: 'Görüntülenen içerik',
      displayedContentTooltip: 'İçeriği göster veya gizle',
      enterTrustLink: `Ortağın URL'sini girin`,
      enterTrustLinkTooltip: `Ortağın URL'sini yapıştırın`,
      enterPartnerName: 'Ortak adını girin',
      enterPartnerUrl: 'https://www.yourPartner.com/',
      enterDescription: 'Açıklama girin (isteğe bağlı)',
      partnerLogo: 'Ortak Logosu',
      uploadPartnerLogo: 'Ortağınızın logosunu yükleyin',
    },
    link: {
      blockTitle: 'Bağlantılar',
      blockText: 'Web sitenize, blogunuza, çevrimiçi mağazanıza veya diğer web sayfalarına trafik çekin',
      blockShortText: 'Web sitesine trafik çekin',
      addLink: 'Bağlantı ekle',
      addNewLink: 'Yeni bağlantı ekle',
      restrictedTitle: '{platform} bağlantıları bir PRO özelliğidir',
      restrictedText: '{platform} bağlantıları eklemek PRO planında kullanılabilir. Bu bağlantıyı sayfanıza eklemek için planınızı yükseltin.',
      upgradeToPro: `PRO'ya yükselt`,
      showMore: 'Daha fazla göster',
      showLess: 'Daha az göster',
      viewArchive: 'Arşivi görüntüle',
      archivedLinks: 'Arşivlenen bağlantılar',
      noArchivedLinks: 'Şu anda kullanmadığınız bağlantıları arşivleyerek bağlantı yöneticinizi temiz ve odaklı tutun.',
      archiveAllUnpublished: 'Tüm yayımlanmamış bağlantıları arşivle',
      addFormExisting: 'Mevcut bağlantılardan ekle',
      addYourLink: 'Bağlantınızı gruba ekleyin',
      add: 'Ekle',
      otherTypes: 'Aksiyon tipi',
      link: 'Bağlantı',
      navigate: 'Yönlendir',
      navigateTo: 'Şuraya yönlendir',
      scrollBlock: 'Şuraya kaydır',
      copyText: 'Metni Kopyala',
      navigatePage: 'Sayfa',
      navigateProduct: 'Ürün',
      navigateBlock: 'Blok',
      modal: 'Modal',
      showModal: 'Modalı Göster',
      modalBlock: 'Bloku Göster',
      modalItem: 'Öğeyi Göster',
      modalCustom: 'Özel',
      document: 'Belge',
      privat24: 'Privat24',
      phone: 'Telefon Araması',
      viber: `Viber'ı Aç`,
      skype: `Skype'ı Aç`,
      email: 'E-posta Gönder',
      discount: 'İndirim',
      smartLink: 'Akıllı Bağlantı',
      mobileApp: 'Deep Link',
      enterURL: 'URL Girin',
      enterPrivat: 'Private Bank kartınızı girin',
      enterPhone: 'Telefon numarası girin',
      enterViber: 'Viber numarası girin',
      enterSkype: 'Skype girin',
      enterEmail: 'E-posta girin',
      enterTitle: 'Başlık girin',
      enterCopyText: 'Kopyalanacak metni girin',
      enterPromoCode: 'Promosyon kodu girin',
      group: 'Grup Oluştur',
      content: 'İçerik',
      links: 'Bağlantılar',
      heading: 'Başlık',
      settings: 'Ayarlar',
      thumbnail: 'Küçük Resim',
      typeTooltip: '  Tıklama bu bağlantıyı açar',
      title: 'Başlık',
      titleTooltip: 'Bağlantınızın adı',
      description: 'Açıklama',
      descriptionTooltip: 'Bağlantı özellikleri, türleri, rengi, boyutları vb. için isteğe bağlı açıklama.',
      label: 'Etiket',
      labelTooltip: 'Etiket adı ekleyin',
      button: 'Düğme',
      buttonTooltip: 'Düğme adı ekleyin',
      buttonText: 'Düğme metni',
      buttonTextTooltip: 'Düğmenizin adı',
      buttonUrl: 'Düğme URL',
      buttonUrlTooltip: `Düğme URL'sini girin`,
      addLinkToGroup: 'Bağlantıyı gruba ekle',
      removeFromGroup: 'Gruptan kaldır',
      deletePermanently: 'Kalıcı Olarak Sil',
      image: 'Görsel',
      buttonBg: 'Düğme arka planı',
      postPreview: 'Gönderi Önizlemesi',
      separatorType: 'Ayraç türü',
      separatorTypeTooltip: 'Düğmenize ayraç türü ekleyin',
      section: 'Bölüm',
      sectionTooltip: 'Bağlantı bölümü',
      descriptionSeparator: 'Açıklama',
      descriptionSeparatorTooltip: 'Bölüm için isteğe bağlı açıklama',
      sectionText: 'Bölüm metni',
      linkInstant: 'Anında bağlantı yönlendirme',
      spotlight: 'Bağlantıyı öne çıkar',
      addEffect: 'Özel efekt ekle',
      countdown: 'Geri Sayım',
      countdownTimer: 'Geri sayım sayacı',
      countdownText: 'Bağlantınızın tıklanabilir hale geleceği zamana kadar canlı bir geri sayım ekleyin',
      chooseDate: 'Tarih seçin',
      chooseDateTooltip: 'Bağlantınız için tarih seçin',
      chooseAction: 'Eylem seçin',
      chooseActionTooltip: 'Bağlantınız için eylem seçin',
      addCountdown: 'Bağlantı için geri sayım ekle',
      scheduler: 'Zamanlayıcı',
      schedule: 'Zamanla',
      scheduleText: 'Bağlantınızın etkinleşmesi için gelecekte bir tarih ve saat seçin',
      activateOn: 'Etkinleştirme',
      activateOnTooltip: 'Tarih seçin',
      deactivateOn: 'Devre dışı bırakma',
      deactivateOnTooltip: 'Tarih seçin',
      addSchedule: 'Zamanlama ekle:',
      scheduleError: 'Bitiş tarihi başlangıç tarihinden önce olamaz ve başlangıç tarihi geçmişte olamaz.',
      scheduleErrorPast: 'Etkinleştirme tarihi geçmişte olamaz.',
      scheduleErrorPastDeactivate: 'Devre dışı bırakma tarihi geçmişte olamaz.',
      scheduleErrorOrder: 'Devre dışı bırakma tarihi etkinleştirme tarihinden sonra olmalıdır.',
      activatesIn: 'Etkinleşme süresi',
      deactivatesIn: 'Devre dışı kalma süresi',
      lock: 'Kilit',
      lockText: 'Ziyaretçiler bu bağlantıya yalnızca kriterlerden birini yerine getirerek erişebilir.',
      lockCode: 'Kod',
      lockCodeTitle: 'Bu bağlantının kilidini açacak kod',
      lockCodeText: 'Ziyaretçilerin bu bağlantının kilidini açmak için 4 haneli bir kod girmesi gerekir',
      lockSubscribe: 'Abone Ol',
      lockSubscribeTitle: `Ziyaretçiler, bağlantının kilidini açmak için UniLink'inize abone olmalıdır.`,
      lockSubscribeText: 'Kilit başarıyla yapılandırıldı.',
      lockPayment: 'Ödeme',
      lockPaymentText: 'Kilit başarıyla yapılandırıldı.',
      price: 'Fiyat',
      priceTooltip: 'Ürününüzün fiyatını ekleyin',
      lockAge: 'Doğum tarihi (Yaş)',
      lockAgeTitle: 'Minimum yaşı belirleyin',
      lockAgeText: 'Ziyaretçilerin doğum tarihleriyle bağlantının kilidini açabilmeleri için belirli bir yaşın üzerinde olmaları gerekir',
      lockAgeAlert: 'Kilit başarıyla yapılandırıldı.',
      lockSensitive: 'Hassas içerik',
      lockSensitiveText: 'Ziyaretçiler, bu bağlantının tüm kitleler için uygun olmayan içerik barındırabileceğini onaylamalıdır.',
      makeLink: 'Bağlantıyı ücretli yap',
      addLock: 'Bağlantı için kilit ekle',
      save: 'Kaydet',
      clear: 'Temizle',
      buttonColor: 'Düğme rengi',
      labelColor: 'Etiket rengi',
      background: 'Arka plan',
      imageHeight: 'Görsel yüksekliği',
      imageHeightTooltip: 'Görselin yüksekliğini değiştirmek için kaydırıcıyı sürükleyin',
      buttonMinimum: 'Minimum yükseklik',
      buttonMinimumTooltip: 'Düğmenin yüksekliğini değiştirmek için kaydırıcıyı sürükleyin',
      textPosition: 'Metin konumu',
      textPositionTooltip: 'Metnin dikey konumunu seçin',
      preview: 'önizleme',
      defaultDesign: 'Varsayılan tasarım',
      defaultDesignTooltip: 'Bağlantılar için varsayılan tasarımı ayarlayın',
      defaultDesignTitle: 'Bu tasarımın tüm bağlantılara uygulanacağını lütfen unutmayın.',
      defaultDesignText: 'Varsayılan bağlantı tasarımını değiştirebilirsiniz',
      changeDefault: 'Varsayılanı değiştir',
      applyDefault: 'Varsayılanı uygula',
      scheduled: 'Zamanlandı',
      scheduledVisible: 'Zamanlanmış bağlantı artık görünür',
      scheduledHidden: 'Zamanlanmış bağlantı artık gizli',
      linkClickable: 'Bağlantı şu süre sonra tıklanabilir',
      linkDisable: 'Bağlantı şu süre sonra devre dışı',
      lockedBy: 'Kilitleyen',
      items: 'Öğeler',
      doNotAnyLinks: 'Henüz hiç bağlantınız yok',
      sublinks: 'Alt bağlantılar',
      layout: 'Düzen',
      layoutTooltip: 'İstediğiniz alt bağlantı düzenini seçin',
      hideGroupLink: 'Grup bağlantısını gizle',
      rules: 'Kurallar',
      rulesText: 'Bu bağlantının görünürlüğünü sayfanızı kimin ziyaret ettiğine göre değiştirin.',
      rulesEmpty: 'Henüz koşul yok. Bu bağlantıyı kimin göreceğini kontrol etmek için bir koşul ekleyin.',
      rulesAddCondition: 'Koşul ekle',
      rulesActive: 'Görünürlük kuralları',
      rulesIf: 'Eğer',
      rulesThen: 'O zaman',
      ruleTypeLocation: 'Konum',
      ruleTypeDevice: 'Cihaz',
      ruleTypeTime: 'Gün ve saat',
      ruleOperatorIs: 'ise',
      ruleOperatorIsNot: 'değilse',
      ruleActionHide: 'Bağlantıyı gizle',
      ruleActionShow: 'Bağlantıyı göster',
      ruleSelectLocations: 'Konumları seç',
      ruleSearchLocations: 'Ülke ara…',
      ruleFrom: 'Başlangıç',
      ruleTo: 'Bitiş',
      ruleAnyTime: 'Herhangi',
    },
    'data-collect': {
      blockTitle: 'Veri toplama',
      blockText: 'Ziyaretçilerinizden e-posta veya telefon numarası toplayın',
      blockShortText: 'E-posta topla',
      maxSize: 'En fazla 3 kanal ekleyebilirsiniz',
      customTerms: 'Özel Şartlar ve Koşullar',
      customTermsTooltip: 'Formunuza özel Şartlar ve Koşullar ekleyin',
      termsConditions: 'Şartlar ve Koşullar',
      text: 'Metin',
      subscribe: 'Abone Ol',
      title: 'Başlık',
      titleTooltip: 'Şartlar ve koşullar için başlık girin',
      titleResultTooltip: 'Gönderiminiz için başlık girin',
      url: 'URL',
      urlTooltip: 'URL girin',
      editItem: 'Öğeyi düzenle',
      placeholder: 'Yer tutucu',
      placeholderTooltip: 'Yer tutucu metnini girin',
      button: 'Buton',
      buttonTooltip: 'Ziyaretçiyi e-posta girmeye motive edecek metin (%10 indirim, hemen abone ol, dosyayı indir vb.)',
      successMessage: 'Başarı mesajı',
      successMessageTooltip: 'Aboneliklerinizin başarı mesajı',
      botURL: 'Bot URL (isteğe bağlı)',
      botURLTooltip: `Botunuzun URL'sini girin`,
      botToken: 'Bot Token',
      botTokenTooltip: 'Botunuzun tokenını girin',
      rewards: 'Yanıtlar',
      rewardsTooltip: 'Aboneliklerinizin yanıtlarını ekleyin',
      addReward: 'Yanıt ekle',
      thankYou: 'Teşekkür mesajı',
      email: {
        none: 'Yok',
        display: 'Yanıtı anında göster',
        send: 'Yanıtı E-postaya gönder',
        redirect: `URL'ye yönlendir`,
      },
      phone: {
        none: 'Yok',
        display: 'Yanıtı anında göster',
        send: 'Yanıtı Telefona gönder',
        redirect: `URL'ye yönlendir`,
      },
      telegram: {
        none: 'Yok',
        display: 'Yanıtı anında göster',
        send: 'Yanıtı Telegram botunda gönder',
        redirect: `URL'ye yönlendir`,
      },
      whatsapp: {
        none: 'Yok',
        display: 'Yanıtı anında göster',
        send: 'Yanıtı WhatsApp botunda gönder',
        redirect: `URL'ye yönlendir`,
      },
      instagram: {
        none: 'Yok',
        display: 'Yanıtı anında göster',
        send: 'Yanıtı Instagram botunda gönder',
        redirect: `URL'ye yönlendir`,
      },
      messenger: {
        none: 'Yok',
        display: 'Yanıtı anında göster',
        send: 'Yanıtı Messenger botunda gönder',
        redirect: `URL'ye yönlendir`,
      },
      viber: {
        none: 'Yok',
        display: 'Yanıtı anında göster',
        send: 'Yanıtı Viber botunda gönder',
        redirect: `URL'ye yönlendir`,
      },
      connect: 'Bağlan',
      toChangeReward: 'Yanıt türünü değiştirmek için mevcut olanı kaldırmalısınız',
      remove: 'Kaldır',
      viewTypes: 'Görünüm Türleri',
    },
    form: {
      blockTitle: 'Form',
      blockText: 'Kitlenizden bilgi ve veri toplamanızı sağlar',
      blockShortText: 'Bilgi topla',
      fields: 'Alanlar',
      fieldsTooltip: 'Forma alan ekleyin',
      addCustomField: 'Özel alan ekle',
      addItem: 'Öğe ekle',
      editItem: 'Öğeyi düzenle',
      type: 'Tür',
      typeTooltip: 'Alan türünü seçin',
      string: 'Kısa yanıt',
      textarea: 'Uzun yanıt',
      dropdown: 'Açılır liste',
      radio: 'Radyo',
      checkbox: 'Onay kutusu',
      date: 'Tarih',
      time: 'Saat',
      country: 'Ülke',
      file: 'Dosya yükleme',
      rating: 'Puan',
      submissionsClosed: 'Yanıt almayı durdur',
      submissionsClosedTooltip: 'Formun yerine kısa bir not görünür. Toplanan yanıtlar olduğu gibi kalır.',
      closedTitle: 'Kapanış başlığı',
      closedText: 'Kapanış mesajı',
      templates: {
        contact: 'İletişim formu',
        contactCaption: 'Bir cümle, alanlar ve tek düğme — beklenen form',
        steps: 'Çok adımlı',
        stepsCaption: 'Ekran başına iki soru ve ilerleme çubuğu. Uzun form uzun görünmez',
        upload: 'Dosya yükleme',
        uploadCaption: 'Önce yükleme alanı — görseller, brifingler ve belgeler için',
        schedule: 'Gün ve saat',
        scheduleCaption: 'Bir gün ve saat seç, sonra adını bırak',
        rating: 'Puan ve geri bildirim',
        ratingCaption: 'Yıldızlar, dokunulacak birkaç konu ve tek yorum alanı',
        card: 'Klasik',
        cardCaption: 'Sade form: alanlar sayfada alt alta, düğme altta',
        button: 'Pop-up düğmesi',
        buttonCaption: 'Sayfada tek düğme; form pop-up olarak açılır',
      },
      fieldName: 'Alan Adı',
      fieldNameTooltip: 'Alan adını girin',
      name: 'Ad',
      placeholder: 'Yer tutucu',
      placeholderTooltip: 'Yer tutucu metnini girin',
      required: 'Zorunlu',
      requiredTooltip: 'Alanın zorunlu olup olmadığını işaretleyin',
      value: 'Değer',
      enterTitle: 'Başlığı girin',
      addValue: 'Değer ekle',
      delete: 'Sil',
      update: 'Güncelle',
      add: 'Ekle',
      confirmationPage: 'Onay işlemi',
      confirmationPageSubtitle: 'Form gönderildikten sonraki sonuç işlemini seçin',
      successMessage: 'Başarı mesajı',
      successMessageTooltip: 'Form gönderildikten sonra gösterilecek başarı mesajı',
      thankYou: 'Teşekkür mesajı',
      submit: 'Gönder',
    },
    contact: {
      blockTitle: 'İletişim',
      blockText: 'İletişim, kullanıcıların sizinle doğrudan iletişim kurmasını sağlar. Telefonunuzu, e-postanızı, mesajlaşma uygulamanızı veya konumunuzu ekleyin',
      blockShortText: 'Kullanıcılarla iletişim kurun',
      addNewContact: 'Yeni kişi ekle',
      newContact: 'Yeni kişi',
      friendlyName: 'Kolay ad',
    },
    faq: {
      blockTitle: 'SSS',
      blockText: 'Sıkça Sorulan Sorular — kullanıcıların sorabileceği tipik soruların yanıtlarının listesini ifade etmek için kullanılır',
      blockShortText: 'Sıkça Sorulanlar',
      addNewItem: 'Yeni öğe ekle',
      editItem: 'Öğeyi düzenle',
      title: 'Başlık',
      titleTooltip: 'Başlığı girin',
      description: 'Açıklama',
      descriptionTooltip: 'Açıklamayı girin',
      update: 'Güncelle',
      add: 'Ekle',
      howToFind: 'Bize nasıl ulaşırsınız',
      view: 'Görünüm',
      viewTooltip: 'SSS öğelerinin nasıl gösterileceğini seçin',
      feed: 'Akış',
      slider: 'Kaydırıcı',
      emptyTitle: 'Henüz hiç öğeniz yok',
      emptyText: 'Bu bloğu doldurmak için ilk sorunuzu ekleyin.',
    },
    ama: {
      blockTitle: 'Bana Her Şeyi Sor',
      blockShortText: 'Hayranlardan gelen soruları yanıtlayın',
      blockText: 'Kitlenizin soru sormasına izin verin ve bunları doğrudan sayfanızda yanıtlayın',
    },
    feature: {
      blockTitle: 'Özellikler',
      blockText: 'Kullanıcılarınıza işletmenizin neden en iyisi olduğunu anlatan görselli metin bölümü',
      blockShortText: 'Kullanıcılarınıza nedenini anlatın',
      title: 'Başlık',
      titleTooltip: 'Öğenin başlığını değiştir',
      description: 'Açıklama',
      descriptionTooltip: 'Öğenin açıklamasını değiştir',
    },
    highlight: {
      blockTitle: 'Öne Çıkanlar',
      blockText: 'En önemli bağlantıları küçük resimlerle öne çıkarın (en fazla 3)',
      blockShortText: 'En önemlileri öne çıkarın',
      title: 'Başlık',
      titleTooltip: 'Öğenin başlığını değiştir',
      url: 'URL',
      urlTooltip: `Öğenin URL'sini değiştir`,
      modeLink: 'Bağlantı',
      modeStory: 'Hikâye',
      coverPhoto: 'Fotoğraf',
      coverIcon: 'Simge',
      templates: {
        scroll: 'Kayan sıra',
        scrollCaption: 'Özgün blok — satırlara yayılan yuvarlak kapaklar, üçten sonrası kaydırılır',
        story: 'Hikâyeler',
        storyCaption: 'Degrade halka içinde daha büyük kapaklar; ziyaretçi bunları dokunulacak hikâye olarak okur',
        square: 'Kare kapaklar',
        squareCaption: 'Kayan bir sırada kare kapaklar — hikâye şeridi değil, raf gibi görünür',
        tall: 'Uzun kartlar',
        tallCaption: 'Adı görselin üzerine basılmış dikey kartlar. Asıl mesele kapaksa en iyisi',
        icon: 'Simge kapaklar',
        iconCaption: 'Fotoğraf yerine simge ızgarası — henüz görsel yokken',
        grid: 'Izgara',
        gridCaption: 'Kaydırmak için fazla uzun bir küme için, dört sütunlu ızgarada hepsi bir arada',
      },
    },
    banner: {
      blockTitle: 'Banner',
      blockText: 'Öne çıkması için görsel, video veya en yeni ürününüzü sergileyin. Kullanıcıları hedef dönüşümünüze yönlendirmek için CTA düğmesi ekleyebilirsiniz',
      blockShortText: 'Görsel, video sergileyin',
      height: 'Yükseklik',
      heightTooltip: 'Banner yüksekliğini değiştir',
      badge: 'Etiket',
      badgeTooltip: 'Bu şablonda başlığın üstünde yazan küçük satır',
      badgePlaceholder: 'Yeni basıldı',
      templates: {
        classic: 'Klasik',
        classicCaption: 'Özgün banner — görselin ortasında duran metin, boyutunu en boy ayarı belirler',
        coverTop: 'Üst başlıklı kapak',
        coverTopCaption: 'Başlığın üstünde küçük bir satır, her şey ortada. Banner kim olduğunuzu söylüyorsa ideal',
        coverTitle: 'Yalnızca başlık',
        coverTitleCaption: 'Tek kelime büyük ve harf aralıklı, altında bir satır. Düğme yok, başka bir şey yok',
        coverLeft: 'Sola hizalı',
        coverLeftCaption: 'Metin alt köşede ve iki düğme yan yana — bir açılış sayfası böyle başlar',
        coverCenter: 'Ortalanmış düğmeler',
        coverCenterCaption: 'Her şey ortada, düğmeler kapsül biçiminde üst üste. Altısının en doğrudanı',
        coverVideo: 'Videolu kapak',
        coverVideoCaption: 'Video oynatan banner için — durum kapsülü, ses kontrolü ve tek düğme',
        coverBadge: 'Etiket ve CTA',
        coverBadgeCaption: 'Daha kısa bir çerçeve: yeniliği duyuran beyaz kapsül, bir başlık ve tek düğme',
      },
    },
    slider: {
      blockTitle: 'Slider',
      blockText: 'Görsel içeriğinizi sergilemenize ve farklı özellikler eklemenize olanak tanıyan görsel karuseli',
      blockShortText: 'Görsel karuseli',
      image: 'Görsel',
      imageTooltip: 'Galerinizin görseli',
      addText: 'Metin ekle',
      title: 'Başlık',
      titleTooltip: 'Slaytınızın başlığı',
      titleSize: 'Başlık boyutu',
      titleSizeTooltip: 'Daha iyi okuma için boyut seçin',
      description: 'Açıklama',
      descriptionTooltip: 'Slaytınızın açıklaması',
      textColor: 'Metin rengi',
      addButton: 'Düğme ekle',
      url: 'URL',
      urlTooltip: `Görselinizin URL'si`,
      button: 'Düğme',
      buttonTooltip: 'Düğmenizin başlığı',
      buttonText: 'Düğme metni',
      buttonColor: 'Düğme rengi',
      height: 'Yükseklik',
      heightTooltip: 'Slaytların yüksekliğini değiştir',
      view: 'Görünüm',
      viewTooltip: 'Slider için görünüm seçin',
      auto: 'Otomatik',
      square: 'Kare',
      rectangle: 'Dikdörtgen',
      single: 'Tekli',
      multi: 'Çoklu',
      templates: {
        multi: 'Çoklu',
        multiCaption: 'Özgün kart şeridi, bir sonraki kenardan görünür',
        single: 'Tekli',
        singleCaption: 'Özgün tek tek slider, altında noktalar',
        showcase: 'Vitrin',
        showcaseCaption: 'Özgün vitrin — büyük sıra numarası, sayaç ve küçük görsel şeridi',
        full: 'Taşmalı, noktalı',
        fullCaption: 'Kenardan kenara tek görsel, tek süs noktalar. Alt yazıya ihtiyaç duymayan fotoğraflar için',
        peek: 'Sonraki slayt görünür',
        peekCaption: 'Sonraki slayt kenardan görünür, böylece kaydırma denemeden önce belli olur',
        caption: 'Alt yazılı slayt',
        captionCaption: 'Görsel bir kartın içinde, altında slaydın kendi başlığı ve açıklaması',
        thumbs: 'Küçük görsellerle',
        thumbsCaption: 'Görselin altında bir şerit, uzun bir seti kaydırmak yerine atlayarak gezmek için',
        counter: 'Sayaç ve oklar',
        counterCaption: 'Sayı rakamla ve iki ok — bilinçli gezilmeye değer bir set için',
        auto: 'Otomatik oynatma çubukları',
        autoCaption: 'Hikâye çubukları: slider kendi ilerler ve ne kadar kaldığını söyler',
        compare: 'Öncesi ve sonrası',
        compareCaption: 'İlk iki slayt üst üste, aralarında sürüklenecek bir çizgi. Başlıkları etiket olur',
        video: 'Video slaytlar',
        videoCaption: 'Video dosyası olan slaytlar için — ziyaretçinin açtığı ses ve geçen süre',
        shop: 'Satış slaytları',
        shopCaption: 'Slaydın başlığı, açıklaması ve düğmesi ad, fiyat ve eylem olarak okunur',
      },
    },
    gallery: {
      blockTitle: 'Galeri',
      blockText: 'Görsel içeriğinizi sergilemenize olanak tanıyan görsel karuseli',
      blockShortText: 'Görsel karuseli',
      image: 'Görsel',
      imageTooltip: 'Galeri öğenizin görseli',
      layout: 'Düzen',
      layoutTooltip: 'Galeri için düzen seçin',
      feed: 'Akış',
      slider: 'Kaydırıcı',
    },
    blog: {
      blockTitle: 'Blog',
      blockText: 'Gönderilerinizden blog oluşturun',
      blockShortText: 'Blog oluştur',
      writeYourStory: 'Hikayenizi yazın',
      shortDescription: 'Kısa açıklama',
      shortDescriptionTooltip: 'Blogunuz için isteğe bağlı açıklama',
      description: 'Açıklama',
    },
    map: {
      blockTitle: 'Harita',
      blockText: 'Kullanıcıların yerel işletmenize ulaşmasına yardımcı olmak için Google haritası ekleyin',
      blockShortText: 'Google haritası ekle',
      buttonText: 'Buton metni',
      buttonTextTooltip: 'İkinci görünüm seçildiğinde buton görünür',
      text: 'Metin',
      addAddress: 'Başka bir adres ekle',
      address: 'Adres',
      addressTooltip: `Örneğin Google Haritalar'dan adresi yapıştırın`,
      googleMap: 'Google haritası (yerleştirme kodu)',
      googleMapTooltip: `Google Haritalar'dan yerleştirme kodunu yapıştırın`,
      howToFind: 'Yerleştirme kodu nasıl bulunur',
      incorrectCode: 'Geçersiz yerleştirme kodu.',
      moreInfo: 'Daha fazla bilgi',
      code: 'Kod',
      addressSettings: 'Adres ayarları',
      addressContent: 'URL, başlık ve buton metni veya ikon ekleyin',
      title: 'Başlık',
      titleTooltip: 'Adresinizin adı',
      url: 'URL',
      urlTooltip: `Örneğin Google Haritalar'dan adres URL'sini yapıştırın`,
      directionText: 'Yönlendirme metni',
      directionTextTooltip: 'Kullanıcılarınız için harekete geçirici metin',
    },
    footer: {
      templates: {
        minimal: 'Sade',
        minimalCaption: 'Marka, sosyal sıra ve yasal satır. Sayfayı ikinci bir menü olmadan kapatır',
        columns: 'İki bağlantı sütunu',
        columnsCaption: 'Başlıklar altında gruplanmış bağlantılar, iki sütun. Birkaç bölüm için',
        accordion: 'Akordeon menü',
        accordionCaption: 'Koyu panelde katlanabilir gruplar. Düz listeye sığmayan bölümler için',
        subscribe: 'Aboneli alt bilgi',
        subscribeCaption: 'Gezinme çipleri üstünde e-posta alanı. Adres toplayan alt bilgi için',
        contacts: 'İletişim alt bilgisi',
        contactsCaption: 'Telefon, e-posta ve adres dokunulabilir satırlar, altında mesajlaşma',
        shop: 'Büyük mağaza alt bilgisi',
        shopCaption: 'Kargo sözü, bağlantı sütunları, uygulama rozetleri ve ödeme yöntemleri',
        cta: 'Harekete çağrı',
        ctaCaption: 'Başlık ve iki eylemli dolu panel. Sayfanın kapanış sözü',
        sticky: 'Eylem çubuklu alt bilgi',
        stickyCaption: 'Sıradan bir alt bilgi ve altında arama, sohbet ve ana düğme',
        locale: 'Dil ve para birimi',
        localeCaption: 'Dil, para birimi ve teslimat ülkesi, mağaza yardım bağlantılarının üstünde',
      },
      defaults: {
        groups: [
          { title: 'Hizmetler', links: ['Tasarım', 'Geliştirme', 'Marka'] },
          { title: 'Şirket', links: ['Hakkımızda', 'Vakalar', 'Kariyer'] },
        ],
        subscribeTitle: 'Ayda bir mektup',
        subscribeText: 'Vakalar, süreçler ve biraz perde arkası. Spam yok.',
        subscribeButton: 'Abone ol',
        ctaTitle: 'Projenizden bahsedin',
        ctaText: 'İş günlerinde bir saat içinde yanıtlıyoruz.',
        ctaButton: 'Bize yazın',
        languages: [
          { code: 'tr', label: 'Tr' },
          { code: 'en', label: 'Eng' },
          { code: 'pl', label: 'Pl' },
        ],
        currency: '₺ Lira',
        country: 'Türkiye',
        contacts: [
          { icon: 'phone', value: '+90 212 123 45 67' },
          { icon: 'mail', value: 'hi@studio.com.tr' },
          { icon: 'pin', value: 'Khoryva Sk. 22, Kiev' },
        ],
      },
      blockTitle: 'Alt bilgi',
      blockText: 'Sayfanın en altındaki içerik bölümü. İletişim bilgileri, sosyal medya ikonları ve e-posta kayıt formu ekleyebilirsiniz',
      blockShortText: 'Alt içerik bölümü',
      addBlock: 'Blok ekle',
      blockType: 'Blok türü',
      blockTypeTooltip: 'Blok türünü seçin',
      addBlockTitle: 'Blok başlığı',
      addBlockTitleTooltip: 'Blok başlığını seçin',
      faq: 'SSS',
      'data-collect': 'Veri Toplama',
      contact: 'İletişim',
      pages: 'Sayfalar',
      payments: 'Ödemeler',
      social: 'Sosyal',
      cancel: 'İptal',
      add: 'Ekle',
      None: 'Yok',
      link: 'bağlantı',
      faqText: 'Sık sorulan soruları SSS bloğunda düzenleyebilirsiniz. Buna tıklayarak gidebilirsiniz',
      socialText: 'Sosyal ikonları Header bloğunda düzenleyebilirsiniz. Buna tıklayarak gidebilirsiniz',
      dataCollectText: 'Veri toplamayı Veri Toplama bloğunda düzenleyebilirsiniz. Buna tıklayarak gidebilirsiniz',
      contactText: 'İletişimi İletişim bloğunda düzenleyebilirsiniz. Buna tıklayarak gidebilirsiniz',
      pagesText: 'Web Sitesine yeni sayfalar ekleyebilirsiniz',
      paymentsText: 'Ödeme yöntemleri görüntülenecek',
      showOnAllpages: 'Tüm sayfalarda göster',
      footerText: 'Ana sayfanın Alt bilgisi şu anda etkin.',
      editSocialIcons: 'Sosyal ikonları Header bölümünde düzenleyebilirsiniz. Buna tıklayarak gidebilirsiniz',
      editSubscribe: 'Aboneliği Subscribe bölümünde düzenleyebilirsiniz. Buna tıklayarak gidebilirsiniz',
      editContacts: 'İletişim bilgilerini Contacts bölümünde düzenleyebilirsiniz. Buna tıklayarak gidebilirsiniz',
      editFrequently: 'Sıkça sorulan soruları SSS bölümünde düzenleyebilirsiniz. Buraya tıklayarak gidebilirsiniz',
      text: 'Metin',
      image: 'Görsel',
      divider: 'Ayırıcı',
      linkViewLabel: 'Düzen',
      linkViewTooltip: 'Bağlantıların nasıl düzenlendiği',
      linkViewSingle: 'Üst üste',
      linkViewRow: 'Bir sırada',
      linkItemsLabel: 'Bağlantılar',
      linkItemsTooltip: 'En fazla 5 bağlantı ekleyin (örn. Gizlilik Politikası, Şartlar)',
      linkLabelPlaceholder: 'Etiket',
      linkUrlPlaceholder: 'URL',
      linkAddMore: '+ Bağlantı ekle',
      alignLabel: 'Hizalama',
      alignTooltip: 'Yatay hizalama',
      alignLeft: 'Sol',
      alignCenter: 'Orta',
      alignRight: 'Sağ',
      imageLabel: 'Görsel',
      imageTooltip: 'Bir logo veya görsel yükleyin',
      imageLinkLabel: 'Bağlantı (isteğe bağlı)',
      imageLinkTooltip: 'Görseli tıklanabilir yapın',
      dividerLabel: 'Ayırıcı türü',
      dividerTooltip: 'Bir çizgi veya boşluk',
      dividerLine: 'Çizgi',
      dividerSpace: 'Boşluk',
      picker: {
        subtitle: 'Alt bilginize eklemek için bir öğe seçin',
        configureSubtitle: 'Yapılandırın ve alt bilginize ekleyin',
        back: 'Geri',
        saveButton: 'Kaydet',
        availableTitle: 'Eklenebilir',
        addedTitle: 'Zaten eklendi',
        addedLabel: 'Eklendi',
        addButton: 'Blok ekle',
        linkTitle: 'Bağlantılar',
        linkSub: `Herhangi bir URL'ye düğmeler`,
        socialTitle: 'Sosyal',
        socialSub: 'Sosyal profilleriniz için simgeler',
        textTitle: 'Metin',
        textSub: 'Bir başlık veya paragraf',
        pagesTitle: 'Sayfalar',
        pagesSub: 'İç içe alt sayfalara bağlantı',
        paymentsTitle: 'Ödemeler',
        paymentsSub: 'Kabul edilen ödeme yöntemleri',
        imageTitle: 'Görsel',
        imageSub: 'Bir logo veya resim',
        dividerTitle: 'Ayırıcı',
        dividerSub: 'Bir çizgi veya boşluk',
        faqTitle: 'SSS',
        faqSub: 'Sıkça sorulan sorular',
        dataCollectTitle: 'Veri Toplama',
        dataCollectSub: 'E-posta kayıt formu',
        contactTitle: 'İletişim',
        contactSub: 'İletişim bilgileri',
        importMode: 'Bloktan içe aktar',
        manualMode: 'Manuel ekle',
        noContactsToImport: 'İçe aktarılacak iletişim yok — bunları manuel olarak ekleyin.',
        noSocialsToImport: 'İçe aktarılacak sosyal simge yok — bunları manuel olarak ekleyin.',
        manualItemsLabel: 'Öğeler',
        manualItemsTooltip: 'Bir tür seçin ve değerini girin.',
        contactValuePlaceholder: '@kullanıcıadı / e-posta / telefon',
        socialUrlPlaceholder: 'https://...',
        addMore: '+ Daha fazla ekle',
      },
      contactDesign: {
        editSource: 'İletişim bilgilerini İletişim bloğunda düzenleyin —',
        variantLabel: 'Stil',
        variantList: 'Liste',
        variantButton: 'Düğme',
        shapeLabel: 'Şekil',
        shape_square: 'Kare',
        shape_rounded: 'Yuvarlatılmış',
        shape_pill: 'Hap',
        widthLabel: 'Genişlik',
        widthFull: 'Tam',
        widthHalf: 'Yarım',
        widthHalfStacked: 'Yarım sütun',
        borderLabel: 'Kenarlık',
        borderOn: 'Açık',
        borderOff: 'Kapalı',
        borderColorLabel: 'Kenarlık rengi',
      },
      layout: 'Düzen',
      splitImage: 'Yan görsel',
    },
    'chat-ai': {
      blockTitle: 'AI Sohbet',
      blockShortText: 'AI ile sohbet et',
      blockText: 'AI ile sohbet et',
      suggestionsTitle: 'Öneriler',
      suggestionsSubtitle: 'Hızlı komutlar',
    },
    custom: {
      blockTitle: 'Özel',
      blockShortText: 'AI destekli mikro uygulama',
      blockText: 'Bir mini etkileşimli uygulama tarif edin, AI sizin için oluştursun',
    },
    shop: {
      blockTitle: 'Mağaza',
      blockText: 'Ürün listenizi ekleyin',
      blockShortText: 'Ürünlerinizi ekleyin',
      view: 'Görüntüle',
      products: 'Ürünler',
      categories: 'Kategoriler',
      cardLayout: 'Kart düzeni',
      cardLayoutTooltip: 'Vitrin her ürünü satır başına bir tane olacak şekilde ayrıntılı bir satış kartı olarak gösterir',
      standardCards: 'Standart',
      showcaseCards: 'Vitrin',
      featured: 'Öne çıkan',
      shoppingCart: 'Alışveriş sepeti',
      shoppingCartNote: 'Sepet düğmesi, ziyaretçi bir ürün eklediğinde görünür',
      cartIconDisabledHint: 'Bunu kullanmak için alışveriş sepetini açın',
    },
    digital: {
      blockTitle: 'Dijital ürünler',
      blockText: 'Dijital İndirme Satışı: PDF, Tablolar, Şablonlar, Özel İçerikler',
      blockShortText: 'Dijital Ürün Sat',
    },
    podcast: {
      templates: {
        latest: 'Son bölüm',
        latestCaption: 'En yeni bölüm ve başlatmak için tek düğme',
        player: 'Oynatıcı',
        playerCaption: 'Sürgü, 15 geri, 30 ileri ve hız kontrolü',
        list: 'Bölüm listesi',
        listCaption: 'Çal, numara, başlık, süre — sade akış',
        resume: 'Kaldığın yerden',
        resumeCaption: 'Ziyaretçinin nerede bıraktığı, kendi tarayıcısında',
        bestOf: 'En iyiler',
        bestOfCaption: 'Başlamak için üç bölüm, senin sıranla',
        cover: 'Program kapağı',
        coverCaption: 'Kapak, neyle ilgili olduğu ve bulunduğu uygulamalar',
        subscribe: 'Abonelik satırı',
        subscribeCaption: 'Bir satır ve dizinler — kapak ve bölüm yok',
        trailer: 'Fragman',
        trailerCaption: '"Bu program bana göre mi" sorusuna iki dakikalık yanıt',
        guest: 'Konuklu bölüm',
        guestCaption: 'Konuğuyla satılan bir söyleşi',
        guests: 'Konuk kadrosu',
        guestsCaption: 'Programa gelen yüzler, ızgara düzeninde',
        hosts: 'Sunucular',
        hostsCaption: 'Programı kim yapıyor — bölümlerin yazar alanından',
        chapters: 'Bölümler ve notlar',
        chaptersCaption: 'Zaman damgalı satırlar; dokununca oynatıcı atlar',
        transcript: 'Metin',
        transcriptCaption: 'Bölümün yazılı hâli, her satır ses içinde atlar',
        clip: 'Paylaşılacak klip',
        clipCaption: 'Büyük punto tek cümle ve bir paylaş düğmesi',
        video: 'Video podcast',
        videoCaption: 'Kare ve izlemekle dinlemek arasında seçim',
        seasons: 'Sezonlar',
        seasonsCaption: 'Programların çip olarak, altında bölümleri',
        topics: 'Konu filtresi',
        topicsCaption: 'Programının kategorisine göre bölümler',
        showCards: 'Program kartları',
        showCardsCaption: 'Her program bir kart, yana kayan',
        ask: 'Dinleyici sorusu',
        askCaption: 'Bir çağrı, örnek soru ve yanıtların gideceği yer',
        ratings: 'Puanlar',
        ratingsCaption: 'Puanın ve alıntılamaya değer bir yorum',
        support: 'Programı destekle',
        supportCaption: 'Destekçiler ne alıyor ve nereden katılıyor',
        classic: 'Listen Now',
        classicCaption: 'Özgün blok — Programlar sekmeli akış',
        showcase: 'Vitrin',
        showcaseCaption: 'Editoryal görünüm: büyük bir kart ve kapak şeridi',
      },
      copy: {
        askTitle: 'Dinleyici sorusu',
        askHint: 'Çağrı, örnek bir soru ve yanıtların gideceği yer: bir form, bir e-posta, bir sesli kutu.',
        ratingTitle: 'Puanlar',
        ratingHint: 'Puanın ve alıntılanacak bir yorum. Blok ne yazarsan onu gösterir — Apple ya da Spotify’dan çekmez.',
        supportTitle: 'Programı destekle',
        supportHint: 'Destekçiler ne alıyor ve nereden katılıyor. Düğme, ödemeyi zaten aldığın yere gider.',
        title: 'Başlık',
        text: 'Metin',
        question: 'Örnek soru',
        url: 'Düğme bağlantısı',
        buttonText: 'Düğme metni',
        voiceUrl: 'Ses bağlantısı',
        value: 'Puan',
        count: 'Nereden',
        quote: 'Yorum',
        author: 'Kim söyledi',
        tiers: 'Seviyeler',
        tierName: 'Ad',
        tierPerk: 'Ne veriyor',
        tierPrice: 'Fiyat',
        addTier: '+ Seviye ekle',
        removeTier: 'Seviyeyi kaldır',
      },
      blockTitle: `Podcast'ler`,
      blockText: `Podcast'lerinizi tanıtın`,
      blockShortText: `Podcast'lerinizi tanıtın`,
    },
    'page-list': {
      blockTitle: 'Sayfa Listesi',
      blockText: 'Kolay gezinme için sayfalarınızın başlık ve açıklamalarıyla bir listesini gösterin.',
      blockShortText: 'Sayfalarınızı listeleyin.',
      description: 'Açıklama',
      addNewPageItem: 'Sayfa bağlantısı ekle',
    },
    appointment: {
      blockTitle: 'Randevular',
      blockText: 'Ziyaretçilerin takviminizden randevu almasına izin verin',
      blockShortText: 'Ziyaretçiler randevu alsın',
    },
    service: {
      modal: {
        title: 'Yeni hizmet ekle',
        subtitle: 'Temel bilgileri girin — gerisini hizmet sayfasında ekleyin',
        thumbnail: 'Küçük resim (isteğe bağlı)',
        thumbnailTooltip: 'Bir kapak fotoğrafı yükleyin',
        label: 'Etiket (isteğe bağlı)',
        labelTooltip: 'Bu hizmeti bir rozetle öne çıkarın',
        titleField: 'Başlık',
        titleTooltip: 'Hizmetiniz için bir başlık ekleyin',
        titlePlaceholder: 'örn. Aile fotoğraf çekimi — 1 saat',
        cancel: 'İptal',
        submit: 'Ekle',
      },
      blockTitle: 'Hizmetler',
      blockText: 'Size bir talep gönderildiğinde e-posta bildirimi alacaksınız',
      blockShortText: 'E-posta alın',
    },
    requests: {
      blockTitle: 'Hizmetler',
      blockText: 'Size bir talep gönderildiğinde e-posta bildirimi alacaksınız',
      blockShortText: 'E-posta alın',
    },
    tips: {
      blockTitle: 'Bahşişler',
      blockText: 'UniLink, desteklemeyi eğlenceli ve kolay hale getirir. Hayranlarınız birkaç dokunuşla ödeme yapıp mesaj bırakabilir',
      blockShortText: 'Desteklemeyi eğlenceli kılar',
    },
    tip: {
      blockTitle: 'Bahşişler',
      blockText: 'UniLink, desteklemeyi eğlenceli ve kolay hale getirir. Hayranlarınız birkaç dokunuşla ödeme yapıp mesaj bırakabilir',
      blockShortText: 'Desteklemeyi eğlenceli kılar',
    },
    donation: {
      blockTitle: 'Bağışlar',
      blockText: 'UniLink, desteklemeyi eğlenceli ve kolay hale getirir. Hayranlarınız birkaç dokunuşla ödeme yapıp mesaj bırakabilir',
      blockShortText: 'Desteklemeyi eğlenceli kılar',
    },
    course: {
      blockTitle: 'Kurs veya Eğitim',
      blockText: 'Ziyaretçilerin takviminizden randevu almasına izin verin',
      blockShortText: 'Ziyaretçiler randevu alsın',
    },
    event: {
      blockTitle: 'Etkinlikler veya Biletler',
      blockText: 'Kitleniz etkinliklerinize katılsın',
      blockShortText: 'Kitleniz katılsın',
    },
    menu: {
      blockTitle: 'Menü',
      blockText: 'Fiyatlarıyla benzersiz bir menü oluşturun',
      blockShortText: 'Benzersiz menü oluşturun',
    },
    recipe: {
      blockTitle: 'Tarif',
      blockText: 'Malzemeler, adımlar ve fotoğraflarla bir tarif paylaşın',
      blockShortText: 'Tarif paylaş',
    },
    booking: {
      blockTitle: 'Rezervasyon',
      blockText: 'Ziyaretçilerin alanlarınızı rezerve etmesine izin verin',
      blockShortText: 'Ziyaretçiler rezervasyon yapsın',
      name: 'Ad',
      nameCaption: 'Alanın adını girin',
      description: 'Açıklama',
      descriptionCaption: 'Bu alan için kısa açıklama',
      rentalType: 'Kiralama türü',
      rentalTypeCaption: 'Örneğin: daire, araba, ofis',
      duration: 'Süre',
      durationCaption: 'Örneğin: günlük, haftalık, aylık',
      price: 'Fiyat',
      priceCaption: 'Bu alan için temel fiyat',
      oldPrice: 'Eski fiyat',
      oldPriceCaption: 'İsteğe bağlı önceki fiyat',
      rating: 'Puan',
      ratingCaption: 'Ortalama puan (isteğe bağlı)',
      label: 'Etiket',
      labelCaption: 'HOT veya NEW gibi kısa rozet',
      image: 'Görsel',
      imageCaption: 'Bu alan için kapak görseli yükleyin',
      location: 'Konum',
      locationCaption: 'Şehir, bölge veya adres',
      capacity: 'Kapasite (misafir)',
      capacityCaption: 'Maksimum misafir sayısı',
      rooms: 'Odalar ve alan',
      roomsCaption: 'Yatak odaları, banyolar ve alan',
      bedrooms: 'Yatak odaları',
      bathrooms: 'Banyolar',
      areaSqM: 'Alan (m²)',
      minStay: 'Minimum konaklama (gün)',
      minStayCaption: 'Rezervasyon için minimum gün sayısı',
      requiresDeposit: 'Depozito gerektirir',
      depositAmount: 'Depozito tutarı',
      depositAmountCaption: 'Rezervasyonu onaylamak için peşin depozito',
      noSmoking: 'Sigara içilmez',
      noPets: 'Evcil hayvan kabul edilmez',
      amenitiesWifi: 'Wi‑Fi',
      amenitiesParking: 'Otopark',
      amenitiesKitchen: 'Mutfak',
      amenitiesHeating: 'Isıtma',
      amenitiesAC: 'Klima',
      amenitiesPool: 'Havuz',
      amenitiesSauna: 'Sauna',
      amenitiesRestrooms: 'Tuvaletler',
      validationNameRequired: 'İsim zorunludur',
      validationPriceRequired: 'Fiyat negatif olmayan bir sayı olmalıdır',
      validationDepositRequired: 'Depozito etkinleştirildiğinde depozito tutarı zorunludur',
      validationCapacityNumber: 'Kapasite negatif olmayan bir sayı olmalıdır',
      validationOldPriceNumber: 'Eski fiyat negatif olmayan bir sayı olmalıdır',
      brand: 'Marka',
      brandCaption: 'Araç markası, ör. Tesla',
      model: 'Model',
      modelCaption: 'Araç modeli, ör. Model 3',
      year: 'Yıl',
      yearCaption: 'Üretim yılı',
      color: 'Renk',
      colorCaption: 'Dış renk, ör. siyah',
      fuelType: 'Yakıt türü',
      fuelTypeCaption: 'Benzin, dizel, elektrik, hibrit vb.',
      transmission: 'Şanzıman',
      transmissionCaption: 'Otomatik veya manuel',
      seatCount: 'Koltuk sayısı',
      seatCountCaption: 'Araçtaki koltuk sayısı',
      edit: 'Öğeyi düzenle',
      add: 'Öğe ekle',
    },
    membership: {
      blockTitle: 'Üyelik',
      blockText: 'İçeriğiniz için ücretsiz veya ücretli abonelik oluşturun',
      blockShortText: 'Abonelik oluştur',
    },
    pricing: {
      blockTitle: 'Fiyatlandırma',
      blockText: 'Fiyatlarla benzersiz menü oluşturun',
      blockShortText: 'Benzersiz menü oluşturun',
      name: 'Ad',
      nameTooltip: 'Ürününüzün adını girin',
      pricingPlanName: 'Fiyatlandırma planı adı',
      pricingPlanNameTooltip: 'Fiyatlandırma planı adınızı girin',
      description: 'Açıklama',
      descriptionTooltip: 'Ürününüzün açıklamasını girin',
      pricingPlanDescriptionTooltip: 'Fiyatlandırma planınızın açıklamasını girin',
      priceValue: 'Fiyat değeri',
      priceUnit: 'Fiyat birimi',
      label: 'Etiket',
      labelTooltip: 'Fiyatlandırma planınızın etiketini girin',
      orderButtonText: 'Sipariş butonu metni',
      orderButtonTextDescriptionTooltip: 'Fiyatlandırma planınızın sipariş butonu metnini girin',
      orderButtonLink: 'Sipariş butonu bağlantısı',
      orderButtonLinkDescriptionTooltip: 'Fiyatlandırma planınızın sipariş butonu bağlantısını girin',
      subtitle: 'Alt başlık',
      subtitleTooltip: 'Ürününüzün alt başlığını girin',
      price: 'Fiyat',
      priceTooltip: 'Ürününüzün fiyatını girin',
      pricingTiers: 'Fiyat kademeleri',
      pricingTiersTooltip: 'Ürününüzün fiyat kademelerini girin',
      addPriceValue: 'Daha fazla fiyat ekle',
      group: 'Grup',
      groupTooltip: 'Ürününüzün grubunu seçin',
      image: 'Görsel',
      imageTooltip: 'Ürününüz için görsel yükleyin',
      unit: 'Fiyat birimi',
      unitTooltip: 'Fiyatınızın birimini girin',
      addUnitTitle: 'Fiyat birimleri',
      addPriceUnitValue: 'Daha fazla fiyat birimi ekle',
      addUnitButtonText: 'Kaydet',
      button: 'Buton',
      buttonTooltip: 'Ürününüz için buton ekleyin',
      buttonAddText: '+ Buton ekle',
      buttonModalTextField: 'Buton metni',
      buttonModalTextFieldTooltip: 'Buton metnini girin',
      buttonModalURLField: `Buton URL'si`,
      buttonModalURLFieldTooltip: `Buton URL'sini girin`,
      buttonModalTitle: 'Buton ekle',
      groups: {
        title: 'Gruplar',
        subtitle: 'Grupları ekleyin, düzenleyin ve silin',
        groups: 'Gruplar',
        groupsTooltip: 'Grupları ekleyin, düzenleyin ve silin',
        addNewGroup: 'Yeni grup ekle',
        newGroup: 'Yeni grup',
        titleGroup: 'Başlık',
        titleGroupTooltip: 'Grubunuzun başlığını girin',
        descriptionGroup: 'Açıklama',
        descriptionGroupTooltip: 'Grubunuzun açıklamasını girin',
      },
    },
    menuBlock: {
      title: 'Menü',
      subtitle: 'Ürünler ve fiyatlarla bir menü oluşturun',
      add: 'Yeni öğe ekle',
      edit: 'Öğeyi düzenle',
      name: 'Ad',
      nameCaption: 'Öğe adını girin',
      description: 'Açıklama',
      descriptionCaption: 'Kısa bir açıklama girin',
      ingredients: 'İçindekiler',
      ingredientsCaption: 'İçindekileri veya bileşimi listeleyin',
      price: 'Fiyat',
      priceCaption: 'Fiyatı girin',
      weight: 'Ağırlık (g)',
      weightCaption: 'Ağırlığı gram cinsinden girin',
      calories: 'Kalori (kcal)',
      caloriesCaption: 'Kaloriyi kcal cinsinden girin',
      label: 'Etiket',
      labelCaption: 'Etiket metnini girin',
      labelColor: 'Etiket rengi',
      labelColorCaption: 'Etiket arka plan rengi seçin',
      image: 'Görsel',
      imageCaption: 'Öğeniz için bir görsel yükleyin',
      available: 'Sipariş için uygun',
      visible: 'Sayfada görünür',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'OpenSea platformundan veya kişisel cüzdanınızdan bir NFT görüntüleyin',
      blockShortText: 'Bir NFT görüntüleyin',
    },
    wallet: {
      wallet: 'Cüzdan',
      blockTitle: 'Banka/Kripto Cüzdanı',
      blockText: 'Kullanıcılarınızın para transferi için kopyalamasını kolaylaştırmak amacıyla Kredi Kartınızı veya Bitcoin cüzdanınızı görüntüleyin',
      blockShortText: 'Cüzdanlarınızı görüntüleyin',
      title: 'Başlık',
      titleTooltip: 'Cüzdanınızın başlığı',
      walletNumber: 'Cüzdan numarası',
      walletNumberTooltip: 'Cüzdan numaranızı yapıştırın',
      icon: 'Simge',
      iconTooltip: 'Cüzdanınız için simge belirleyin',
      card: 'Kart',
      bank: 'Banka',
      crypto: 'Kripto',
      transfer: 'Transfer',
      paymentLink: 'Ödeme bağlantısı',
      cardNumber: 'Kart numarası',
      cardNumberTooltip: 'Kart numaranızı yapıştırın',
      cardHolder: 'Kart sahibi',
      cardHolderTooltip: 'Kart sahibini girin',
      bankAccountDetails: 'Banka hesap bilgileri',
      bankAccountDetailsTooltip: 'Banka hesap bilgilerinizi girin',
      walletAddress: 'Cüzdan adresi',
      walletAddressTooltip: 'Cüzdan adresinizi girin',
      network: 'Ağ',
      networkTooltip: 'Ağınızı girin',
      publicKey: 'Genel anahtar',
      publicKeyTooltip: 'Genel anahtarınızı girin',
      providerName: 'Sağlayıcı adı',
      providerNameTooltip: 'Sağlayıcı adınızı girin',
      link: 'Bağlantı',
      linkTooltip: 'Bağlantınızı girin',
      serviceName: 'Hizmet adı',
      serviceNameTooltip: 'Hizmet adınızı girin',
      email: 'E-posta',
      emailTooltip: 'E-postanızı girin',
      phone: 'Telefon',
      phoneTooltip: 'Telefonunuzu girin',
      username: 'Kullanıcı adı',
      usernameTooltip: 'Kullanıcı adınızı girin',
      fullName: 'Ad soyad',
      fullNameTooltip: 'Ad soyadınızı girin',
      referenceNumber: 'Referans numarası',
      referenceNumberTooltip: 'Referans numaranızı girin',
      country: 'Ülke',
      countryTooltip: 'Ülkenizi girin',
      transferProvider: 'Transfer sağlayıcısı',
      transferProviderTooltip: 'Transfer sağlayıcınızı girin',
      cryptoCurrency: 'Kripto Para Birimi',
      cryptoCurrencyTooltip: 'Kripto para biriminizi girin',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'En iyi Instagram medyanızı ve videolarınızı öne çıkarın veya alışveriş yapılabilir Instagram akışıyla ürünlerinizi satın',
      blockShortText: 'En iyi Instagram medyanız',
      blockConnectTitle: 'Instagram bağlı değil',
      blockConnectText: 'Görünüşe göre Instagram ürünleriniz henüz içe aktarılmamış. Hesabınızı şimdi bağlayın',
      blockConnectButton: 'Instagram Ekle',
      emptyList: 'Henüz Instagram medyanız yok.',
      addInstagramUsername: 'Instagram kullanıcı adı ekle',
      username: 'Kullanıcı adı',
      downloadTakes: 'İndirme işlemi 2 dakikaya kadar sürer',
      displayPost: 'Gönderiyi web sitenizde görüntüleyin',
      view: 'Görüntüle',
      redirect: 'URL Yönlendirme',
      text: 'Metin ve Düğme',
      actionType: 'Eylem türü',
      url: 'URL',
      openInNewTab: 'Yeni sekmede aç',
      delete: 'Sil',
      cancel: 'İptal',
      save: 'Kaydet',
      editMedia: 'Medyayı Düzenle',
      title: 'Başlık',
      automation: 'Otomasyon',
      automationText: 'Hesabınızı Autopilot özellikleriyle otomatikleştirin',
      autopilot: 'Autopilot',
      autopilotTooltip: 'Örnek başlıkla bir gönderi yükleyin; ürün etiketleriniz/bağlantılarınız otomatik olarak oluşturulacak',
      switchTitle: 'Başlık, fiyat ve bağlantıları otomatik olarak algıla',
      sampleCaption: 'Örnek başlık: #49.99 #GüzelElbise https://google.com',
      integrations: 'Entegrasyonlar',
      integrationsText: 'Web sitenize Instagram ekleyin',
      connectInstagram: `Instagram'ı Bağla`,
      connectInstagramText: `Seçtiğiniz gönderileri veya reels'leri görüntülemek için Instagram hesabınızı bağlayın.`,
      selectAccount: 'Hesap seç',
      connectNewInstagram: 'Yeni bir Instagram hesabı bağla',
      continue: 'Devam Et',
      disconnectInstagram: 'Instagram Bağlantısını Kes',
      addTag: 'Etiket ekle',
      tagClickHint: 'Etiketi yerleştirmek için resme tıklayın',
      tagPositionSet: 'Konum ayarlandı. Aşağıdaki ayrıntıları doldurun.',
      tagTypeLink: 'Bağlantı',
      tagTypeProduct: 'Ürün',
      tagLabel: 'Etiket',
      tagSelectProduct: 'Ürün seç',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'En iyi TikTok videonuzu öne çıkarın veya alışveriş yapılabilir TikTok akışıyla ürünlerinizi satın',
      blockShortText: 'En iyi TikTok videonuz',
      addTikTok: 'TikTok hesabı ekle',
      individualVideo: 'Tek video',
      videoCollection: 'Video koleksiyonu',
      add: 'Ekle',
      blockConnectTitle: 'TikTok bağlı değil',
      blockConnectText: 'Görünüşe göre TikTok ürünleriniz henüz içe aktarılmamış. Hesabınızı şimdi bağlayın',
      blockConnectButton: `TikTok'u Bağla`,
      enterUsername: 'Kullanıcı adını girin',
      enterVideo: `Bir TikTok video URL'si girin`,
      emptyList: 'Henüz TikTok medyanız yok.',
      editMedia: 'Medyayı Düzenle',
      addTikTokVideo: 'TikTok videosu ekle',
      displayPost: 'Gönderiyi web sitenizde gösterin',
      delete: 'Sil',
      cancel: 'İptal',
      save: 'Kaydet',
      integrations: 'Entegrasyonlar',
      integrationsText: `TikTok'u web sitenize ekleyin`,
      connectTikTok: `TikTok'u Bağla`,
      disconnectTikTok: 'TikTok Bağlantısını Kes',
      individualText: `TikTok hesabını bu blok türüne ('individual') bağlayamazsınız.`,
      individualText2: 'Lütfen bunun yerine tek bir TikTok videosu ekleyin.',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'Sayfanızda bir YouTube videosu veya yayını öne çıkarın. YouTube videosunda ürünleri etiketleyin',
      blockShortText: 'Bir YouTube videosu öne çıkarın',
      enterYouTubeLink: `YouTube URL'sini girin`,
      enterYouTubeLinkTooltip: `YouTube URL'sini yapıştırın`,
    },
    overview: {
      blockTitle: 'Genel Bakış',
      blockText: 'Sayfanızda bir video veya yayını öne çıkarın. Videoda ürünleri etiketleyin',
      blockShortText: 'Videoda ürünleri etiketleyin',
    },
    video: {
      blockTitle: 'Video',
      blockText: 'Sayfanızda bir video veya yayını öne çıkarın',
      blockShortText: 'Bir video öne çıkarın',
    },
    short: {
      blockTitle: 'Shorts / Reels',
      blockText: 'Dikey kısa videolar ekleyin — Shorts, Reels, TikTok',
      blockShortText: 'Dikey videolar',
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: `Etkileşimi artırmak için Tweet'lerinizi UniLink sayfanızda gösterin`,
      blockShortText: `Tweet'lerinizi gösterin`,
      twitterURL: `Twitter URL'si`,
      twitterURLTooltip: `Yerleşik kod oluşturmak için Twitter'dan URL ekleyin`,
      enterTwitterURL: `Bir Twitter URL'si girin`,
    },
    music: {
      templates: {
        nowPlaying: 'Oynatıcı',
        nowPlayingCaption: 'Kapak, ilerleme çubuğu ve kontrollerle koyu bir kart — bloğun parçaları arasında geçer',
        compact: 'Kompakt oynatıcı',
        compactCaption: 'Aynı oynatıcının üçte bir yüksekliği, ana odak olmayan bir şarkı için',
        tracklist: 'Parça listesi',
        tracklistCaption: 'Süre ve çal düğmesiyle numaralı satırlar — bir plağın arka yüzü gibi',
        queue: 'Çalma sırası',
        queueCaption: 'Ne çalıyor ve sırada ne var: kuyruğuyla küçük bir albüm oynatıcısı',
        featured: 'Öne çıkan parça',
        featuredCaption: 'Kapak tam boy, üzerinde başlık ve tek bir çal düğmesi',
        waveform: 'Dalga formu',
        waveformCaption: 'Çalarken dolan bir dalga formu olarak tek kayıt — demo veya kaba miks için',
        mix: 'DJ mix',
        mixCaption: 'Taşan bir fotoğraf, setin süresi ve bir düğmenin arkasında parça listesi',
        release: 'Bağlantılı yayın',
        releaseCaption: 'Kapak, başlık ve her yayın servisi için bir satır — smart-link kartı',
        streaming: 'Streaming bağlantıları',
        streamingCaption: 'Kapak olmadan sadece servisler: ziyaretçiyi kullandığı platforma gönderir',
        presave: 'Ön kayıt',
        presaveCaption: 'Henüz çıkmamış bir plak ve çıkış günü kütüphaneye ekleyen dokunuşlar',
        shelf: 'Albüm rafı',
        shelfCaption: 'Her yayın bir kapak olarak, yana kayan. Dokununca bağlantıları açılır',
        playlistCard: 'Çalma listesi kartı',
        playlistCardCaption: 'Listede ne olduğunun mozaiği, süresi ve dinlemek için tek düğme',
        record: 'Plağı satın al',
        recordCaption: 'Kapak, fiyat ve iki düğme — satın al ya da önce dinle',
        classic: 'Sekmeler',
        classicCaption: 'Özgün blok: Parçalar, Çalma listeleri ve Yayınlar sekmelerde, alışıldık kartlarla',
        showcase: 'Vitrin',
        showcaseCaption: 'Editoryal görünüm — büyük yayın kartları ve altında gerisi için bir şerit',
      },
      blockTitle: 'Müzik',
      blockText: 'Spotify, SoundCloud şarkısı, çalma listesi yerleştirin veya kendi ses dosyanızı yükleyin',
      blockShortText: 'Müziğinizi ekleyin',
      brand: 'Marka',
      brandTooltip: 'Müziğinizi eklemek için tür seçin',
      url: 'URL',
      embed: 'Yerleşik kod',
      custom: 'Özel',
      musicUrl: `Müzik URL'si`,
      musicUrlTooltip: `Müzik URL'sini girin`,
      embedCodeTitle: 'Yerleşik kod',
      embedCodeTooltip: 'Seçtiğiniz müzik platformundan şarkınızın yerleşik kodunu yapıştırın',
      audioFile: 'Ses dosyası',
      uploadAudios: 'Buraya yalnızca ses yükleyebilirsiniz',
      title: 'Başlık',
      titleTooltip: 'Müziğinizin başlığını girin',
      artist: 'Sanatçı',
      artistTooltip: 'Müziğinizin sanatçısını girin',
      audioFileTitle: 'Ses dosyası',
      audioFileTooltip: 'Ses dosyanızın adı',
      coverImage: 'Kapak resmi',
      coverImageTooltip: 'Müziğiniz için resim yükleyin',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'Sayfanıza Twitch videosu veya yayını yerleştirin',
      blockShortText: 'Twitch videosu yerleştirin',
      twitchURL: `Twitch URL'si`,
      twitchURLTooltip: `Kanal URL'sini veya kanal adını yapıştırın`,
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Twitch kanalımı göster',
      displayChat: 'Hem Twitch kanalımı hem de sohbeti göster',
    },
    splash: {
      blockTitle: 'Açılış ekranı',
      blockText: 'Herhangi bir ürünü veya etkinliği tanıtmak için site yüklenmeden önce metin ve düğme içeren tam ekran banner görünür',
      blockShortText: 'Tam ekran banner',
    },
    pageList: {
      templates: {
        classic: 'Basit liste',
        classicCaption: 'Özgün blok — satır başına bir sayfa ve ok. Beş sayfaya kadar iyi',
        described: 'Açıklamalı liste',
        describedCaption: 'Numaralı satırlar, her sayfa nereye gittiğini anlatan bir satırla',
        icons: 'Simge ızgarası',
        iconsCaption: 'Adın üstünde simge olan iki kolon. Altı sayfadan itibaren iyi',
        covers: 'Kapaklı kartlar',
        coversCaption: 'Her sayfanın yanında bir görsel — gösterilmeye değer bölümler için',
        groups: 'Gruplanmış bölümler',
        groupsCaption: 'Site haritası: sayfalar, onlara verdiğiniz grup adlarının altında',
        headline: 'Büyük satırlar',
        headlineCaption: 'Dolu panel üzerinde iri satırlar, dört-beş güçlü hedef için',
        tiles: 'Fotoğraf karoları',
        tilesCaption: 'Satırda iki fotoğraf karosu; tek kalan son karo tam genişlikte',
        tags: 'Etiketler',
        tagsCaption: 'Her sayfa bir kapsül. On ve üzeri sayfa için derli toplu seçim',
        prevNext: 'Önceki ve sonraki',
        prevNextCaption: 'Bunun iki yanındaki sayfalar, uzun bir sayfanın altı için',
      },
    },
    promo: {
      blockTitle: 'Promosyon çubuğu',
      blockText: 'Promosyonlarınızı göstermenizi sağlayan vurgu',
      blockShortText: 'Promosyonlarınızı öne çıkarın',
    },
    welcome: {
      blockTitle: 'Karşılama mesajı',
      blockText: 'Ziyaretçileri sohbet etmeye yönlendiren karşılama mesajları yazın. Sayfanın altında açılır pencere şeklinde görünerek ziyaretçileri karşılar ve yardım sunar',
      blockShortText: 'Karşılama mesajları yazın',
    },
    review: {
      blockTitle: 'Yorumlar',
      blockText: 'Yorumlar, müşterilerin ürün hakkında daha fazla bilgi edinmesine ve doğru ürün olup olmadığına karar vermesine yardımcı olur',
      blockShortText: 'Yorumlar müşterilere yardımcı olur',
      name: 'Ad',
      nameTooltip: 'Yorum yapanın adını girin',
      comment: 'Yorum',
      commentTooltip: 'Yorum yapanın yorumunu girin',
      date: 'Tarih',
      dateTooltip: 'Yorum tarihini girin',
      rate: 'Puan',
      rateTooltip: 'Yorum puanını ayarlayın',
      image: 'Görsel',
      imageTooltip: 'Yorum yapanın görselini yükleyin',
    },
    coupon: {
      blockTitle: 'Kuponlar',
      blockText: 'Çevrimiçi kupon, bir web sitesinde kullanılabilen indirim kodunu veya numarasını ifade eder',
      blockShortText: 'Çevrimiçi kupon ifade eder',
    },
    timer: {
      blockTitle: 'Countdown',
      blockText:
        'Geri sayım sayacı, bir etkinlik veya teklifin başlangıcını ya da bitişini belirtmek için belirli bir sayıdan veya tarihten geriye doğru sayan, sayfa üzerindeki sanal bir saattir',
      blockShortText: 'Geri sayım sayacı',
    },
    outfit: {
      blockTitle: 'Kıyafetler',
      blockText: 'Kendi ürün listenizi oluşturun',
      blockShortText: 'Ürün listesi oluşturun',
    },
    spacer: {
      blockTitle: 'Boşluk',
      blockText: 'Sayfanıza dikey boş alan ekleyin',
      blockShortText: 'Boşluk ekleyin',
    },
    html: {
      blockTitle: 'Embed',
      blockText: `Kendi HTML kodunuzu UniLink sayfasına yapıştırabilirsiniz. HTML, web sayfası oluşturmak için kullanılan standart bir işaretleme dilidir. iframe'lere, bölümlere, paragraflara ve bağlantılara izin verir.`,
      blockShortText: 'Kendi HTML kodunuzu yapıştırın',
      markupCode: 'İşaretleme kodu',
      markupCodeTooltip: 'HTML işaretleme kodunuzu yapıştırın',
      strippedWarning: 'Görüntülenirken güvenlik nedeniyle kaldırıldı:',
    },
    unlock: {
      blockTitle: 'Kilidi aç',
      blockText: 'İçeriği parola, e-posta, ödeme veya özel kurallar arkasında kilitleyin. Özel içerik ve ücretli erişim için mükemmeldir.',
      blockShortText: 'İçeriği kilitleyin.',
    },
    file: {
      blockTitle: 'Dosya',
      blockText:
        'Bu blok, belge, görsel veya ses gibi dosyaları yüklemenizi ve paylaşmanızı sağlar. Ziyaretçiler bunları doğrudan sayfanızdan kolayca görüntüleyebilir veya indirebilir.',
      blockShortText: 'Dosyalarınızı yükleyin ve paylaşın.',
      addNewItem: 'Yeni dosya ekle',
      editFile: 'Dosyayı düzenle',
      fileName: 'Dosya adını girin',
      fileDescription: 'Dosya açıklaması (isteğe bağlı)',
      coverImage: 'Kapak görseli (isteğe bağlı)',
      templates: {
        classic: 'Klasik liste',
        classicCaption: 'Özgün blok — her dosya için simge, boyut ve erişim rozeti taşıyan bir satır',
        list: 'Dosya listesi',
        listCaption: 'Formatı plakette, indirme düğmesi sağda olan satırlar',
        single: 'Tek indirme',
        singleCaption: 'Tek kart, tek büyük düğme. Tek bir şey yayımlayan blok için',
        cover: 'Kapak önizlemesi',
        coverCaption: 'İlk sayfa görsel olarak, altında açıklama ve düğme',
        folders: 'Klasörler',
        foldersCaption: 'Türüne göre gruplanan dosyalar; her klasör adet ve boyut gösterir',
        formats: 'Formatlar',
        formatsCaption: 'Aynı materyalin tüm formatları, dokunulabilir çipler halinde',
        versions: 'Sürümler',
        versionsCaption: 'Güncel dosya üstte çerçeveli, eskiler altta erişilebilir',
        gate: 'E-posta karşılığı dosya',
        gateCaption: 'Ziyaretçi e-posta bıraktıktan sonra indirme açılır',
        transfer: 'Büyük aktarım',
        transferCaption: 'Ağır teslimler için koyu kart, boyut uyarısıyla',
      },
    },
    stat: {
      templates: {
        grid: 'Dört rakam',
        gridCaption: 'Satır başına iki, her birinin altında neyi saydığını söyleyen bir açıklama',
        hero: 'Tek büyük sayı',
        heroCaption: 'Bloğu dolduran tek bir rakam, sayfanın metin renginde',
        row: 'Üçlü satır',
        rowCaption: 'Tek satırda üç kısa rakam, ince çizgilerle ayrılmış',
        change: 'Değişimle',
        changeCaption: 'Bir rakam ve nasıl değiştiği — her verinin ek alanından',
        bars: 'Sütun grafik',
        barsCaption: 'Her veri için bir sütun, en yükseği vurgu renginizde',
        progress: 'İlerleme çubukları',
        progressCaption: 'Dolu çubuklarla dağılım: ad, rakam, çubuk',
        photo: 'Fotoğraflı',
        photoCaption: 'Blok başlığının görseli, rakam satırının üstünde',
        live: 'Canlı sayaç',
        liveCaption: 'Yanında yanıp sönen bir nokta olan tek rakam',
        source: 'Kaynak notu',
        sourceCaption: 'İki rakam ve nereden geldiklerini söyleyen bir satır',
        trend: 'Eğilim',
        trendCaption: 'Veriler zaman içinde çizgi olarak, en yeni rakam üstte',
        share: 'Pay dağılımı',
        shareCaption: 'Bir bütünün nasıl bölündüğü — açıklamalı halka',
        ranked: 'Sıralı liste',
        rankedCaption: 'Numaralı ilk beş, her satırın altında bir çubuk',
        feed: 'Akış',
        feedCaption: 'Özgün blok — satırlara kayan veri kutucukları',
        slider: 'Kaydırıcı',
        sliderCaption: 'Aynı kutucuklar, ziyaretçinin kaydırdığı bir rayda',
      },
      blockTitle: 'İstatistikler',
      blockText:
        'Bu blok, sayfanız hakkında görüntüleme, ziyaretçi veya etkileşim gibi önemli verileri görüntülemenizi sağlar. Kitlenizi takip etmenize ve sayfanızın nasıl performans gösterdiğini anlamanıza yardımcı olur.',
      blockShortText: 'Sayfanıza istatistikler ekleyin.',
      addNewItem: 'Yeni istatistik ekle',
      editItem: 'İstatistiği düzenle',
      statName: 'İstatistik adını girin',
      statValue: 'İstatistik değerini girin',
      statDescription: 'İstatistik açıklamasını girin',
      statProgress: 'İlerleme çubuğu, % (isteğe bağlı)',
      statLabel: 'Değişim veya kaynak notu',
      statLabelTooltip: '«Değişimle» ve «Eğilim» şablonlarında rakamın yanındaki rozet («+18%», «−1,1») ya da «Kaynak notu» şablonunda rakamların altındaki satır',
      matchScreenshot: 'Ekran görüntüsünü uygula',
      matchScreenshotRunning: 'Tasarım okunuyor…',
      matchScreenshotSkipped: 'Kutu rengi ve yazı tipi olduğu gibi bırakıldı',
      compose: 'Tasarla',
      composePlaceholder: 'Görünümü anlat — “açık ve modern”, “daha cesur”',
      composeHint: 'Rengi palet verir; metin kontrastı otomatik sağlanır',
      composeDone: 'Tasarım güncellendi',
      review: 'İncele',
      reviewClean: 'İncelendi — düzeltilecek bir şey yok',
      reviewFixed: 'İncelendi ve düzeltildi',
      statItemFields: 'Görüntülenecek alanları seçin.',
      columns: 'Sütunlar',
      subtitleColumns: 'Bir satıra kaç istatistik sığar',
      feed: 'Akış',
      slider: 'Kaydırıcı',
      titleSize: 'Başlık boyutu',
      subtitleTitleSize: 'Başlık boyutunu değiştirebilirsiniz',
    },
    listing: {
      blockTitle: 'Liste',
      blockText: 'Görseller, detaylar ve fiyatlandırma ile mülk veya ürün ilanlarını gösterin.',
      blockShortText: 'Sayfanıza ilanlar ekleyin.',
    },
    rental: {
      blockTitle: 'Kiralama',
      blockText: 'Müsaitlik ve dönemsel fiyatlandırma ile kiralık mülk veya eşyaları listeleyin.',
      blockShortText: 'Sayfanıza kiralıklar ekleyin.',
    },
    'single-product': {
      blockTitle: 'Tek Ürün',
      blockText: 'Görsel, açıklama ve satın al düğmesiyle tek bir ürünü öne çıkarın.',
      blockShortText: 'Bir ürün öne çıkarın.',
    },
    team: {
      blockTitle: 'Ekip',
      blockText: 'Ekip üyelerinizi fotoğraflar, isimler, roller ve sosyal medya bağlantılarıyla tanıtın.',
      blockShortText: 'Ekibinizi gösterin.',
    },
    timetable: {
      blockTitle: 'Ders Programı',
      blockText: 'Dersler, etkinlikler veya seanslarla haftalık bir program gösterin.',
      blockShortText: 'Haftalık bir program ekleyin.',
    },
    wall: {
      blockTitle: 'Duvar',
      blockShortText: 'Ziyaretçilerden mesajlar toplayın',
      blockText: 'Ziyaretçilerin mesaj bırakabileceği ve içeriğinizle etkileşime geçebileceği herkese açık bir duvar gösterin',
    },
    'live-stream': {
      blockTitle: 'Canlı Yayın',
      blockShortText: 'Sayfanızda canlı yayın yapın',
      blockText: 'Kitlenize canlı yayın yapın — platformumuz üzerinden yerel olarak veya YouTube / Twitch gömerek',
    },
    workout: {
      blockTitle: 'Antrenman',
      blockShortText: 'Antrenmanları paylaşın ve satın',
      blockText: 'Yapılandırılmış bir antrenman yayınlayın — setler, tekrarlar ve demo videolarıyla egzersizler. Satın veya ücretsiz paylaşın',
      templates: {
        sessionCard: 'Antrenman kartı',
        sessionCardCaption: 'Kapak, ad ve tek satır bilgi; altında bir başlat düğmesi',
        exerciseList: 'Egzersiz listesi',
        exerciseListCaption: 'Her egzersiz küçük görseli, setleri ve ağırlığıyla',
        setTracker: 'Set takibi',
        setTrackerCaption: 'Set başına bir satır — biten, sıradaki, bekleyen',
        restTimer: 'Dinlenme sayacı',
        restTimerCaption: 'Setler arasında büyük geri sayım ve sırada ne var',
        weekPlan: 'Hafta planı',
        weekPlanCaption: 'Haftanın günleri; bugün başlamaya hazır',
        videoExercise: 'Egzersiz videosu',
        videoExerciseCaption: 'Dikey teknik videosu, altında ipuçları',
        progress: 'Gelişim',
        progressCaption: 'Ayın antrenmanları çubuklarla ve iki toplam',
        circuit: 'Devre',
        circuitCaption: 'Çalışma ve dinlenme turları, süren egzersiz vurgulu',
        sessionDone: 'Antrenman tamam',
        sessionDoneCaption: 'Az önce biteni, gün serisini ve nasıl geçtiğini yazacak bir yer',
      },
      defaults: {
        mon: 'Pzt',
        tue: 'Sal',
        wed: 'Çar',
        thu: 'Per',
        fullBody: 'Tüm vücut',
        legsAndCore: 'Bacak ve merkez',
        upperBody: 'Üst vücut',
        restDay: 'Dinlenme',
      },
    },
    videoFeedback: {
      blockTitle: 'Video Geri Bildirimi',
      blockShortText: 'Video referansları toplayın',
      blockText: 'Kitlenizden kısa video referansları ve geri bildirimler toplayın',
    },
    'premium-inbox': {
      blockTitle: 'Premium Gelen Kutusu',
      blockShortText: 'Hayranlardan ücretli mesajlar',
      blockText: 'Hayranların size doğrudan premium gelen kutunuza ücretli mesajlar ve istekler göndermesine izin verin',
    },
    'order-form': {
      blockTitle: 'Sipariş Formu',
      blockShortText: 'Sayfanızdan sipariş toplayın',
      blockText: 'Özelleştirilebilir bir sipariş formuyla doğrudan sayfanızdan sipariş toplayın',
    },
  },
  pinnedDock: {
    title: 'Sabitlenen bloklar',
    label: 'SABİTLENDİ',
    expand: 'Sabitlenen blokları genişlet',
    collapse: 'Sabitlenen blokları daralt',
  },
  reviewButton: {
    title: 'Değerlendirme bırak düğmesi',
    desc: 'Değerlendirmelerin altında, ziyaretçileri değerlendirme bırakabilecekleri yere yönlendiren bir düğme göster.',
    buttonText: 'Düğme metni',
    link: 'Bağlantı',
    leaveReview: 'Değerlendirme bırak',
    googleHint: 'Google değerlendirme sayfanızı kullanmak için boş bırakın.',
    design: 'Düğme tasarımı',
    background: 'Arka plan',
    textColor: 'Metin',
  },
  themeTokens: {
    title: 'Tema stili',
    subtitle: 'Tipografi, köşeler ve boşluk',
    typography: 'Tipografi',
    corners: 'Köşeler',
    density: 'Yoğunluk',
  },
  headingDesign: {
    title: 'Başlık',
    subtitle: 'Blok metin rengini devralır',
    hint: 'Dokunulmayan renk bloğun metin rengini izler. Bir renk seçilirse yalnızca o bölüm için geçerlidir.',
    titleColor: 'Başlık',
    descriptionColor: 'Açıklama',
    inherited: 'devralındı',
    reset: 'Sıfırla',
    custom: 'özel',
  },
  advancedDesign: {
    inherited: 'devralındı',
    reset: 'Sıfırla',
    title: 'Gelişmiş',
    subtitle: 'Her bölümü ince ayarlayın',
    slot_title: 'Başlık',
    slot_description: 'Açıklama',
    slot_label: 'Üst etiket',
    fontSize: 'Yazı boyutu',
    fontWeight: 'Kalınlık',
    textTransform: 'Büyük/küçük harf',
    textAlign: 'Hizalama',
    color: 'Renk',
  },
  layoutPicker: {
    title: 'Düzen',
    tooltip: 'Öğelerin nasıl düzenleneceğini seçin',
    layout_list: 'Liste',
    layout_grid: 'Izgara',
    layout_cards: 'Kartlar',
  },
  importDesign: {
    title: 'Tasarımı içe aktar',
    subtitle: 'Bir ekran görüntüsünden tasarımı yeniden oluşturun',
    upload: 'Ekran görüntüsü yükle',
    extracting: 'Analiz ediliyor…',
    apply: 'Sayfaya uygula',
    applying: 'Uygulanıyor…',
    blocksCount: '+{n} blok',
    applied: 'Tasarım uygulandı — {n} blok eklendi',
  },
  adminUi: {
    podcastEnterShowTitle: 'Program başlığını girin',
    podcastMaximum: 'En fazla',
    podcastCharacters: 'karakter',
    podcastShowTitleExists: 'Bu başlığa sahip bir program zaten var',
    podcastEditShow: 'Programı düzenle',
    podcastNewShow: 'Yeni program',
    podcastCover: 'Kapak',
    podcastTitle: 'Başlık',
    podcastShowTitlePlaceholder: 'Program başlığı',
    podcastCategory: 'Kategori',
    podcastCategoryPlaceholder: 'örn. Gerçek Suç',
    podcastDescription: 'Açıklama',
    podcastDescriptionPlaceholder: 'Bu program neyle ilgili…',
    podcastSubscribeButtons: '“Abone ol” düğmeleri',
    podcastAddPlatform: 'Platform ekle',
    podcastSave: 'Kaydet',
    podcastCreate: 'Oluştur',
    episodeOne: 'bölüm',
    episodeFew: 'bölüm',
    episodeMany: 'bölüm',
    edit: 'Düzenle',
    delete: 'sil',
    addShow: 'Program ekle',
    importFromRss: `RSS'ten içe aktar`,
    importFromRssFeed: 'RSS akışından içe aktar',
    importFromRssHint: 'Bir podcast RSS bağlantısı yapıştırın — bölümler otomatik olarak yeni bir programa aktarılır.',
    import: 'İçe aktar',
    trackWordOne: 'parça',
    trackWordFew: 'parça',
    trackWordMany: 'parça',
    albumLabel: 'Albüm',
    pause: 'Duraklat',
    play: 'Oynat',
    emptyTracks: 'Bu albümde henüz parça yok',
    untitled: 'Başlıksız',
    show: 'Program',
    audioFileNotAttached: 'Ses dosyası eklenmedi',
    paypalConnectionTitle: 'PayPal bağlantı yöntemini seçin',
    paypalConnectionSubtitle: 'Sizin için en uygun bağlantı yöntemini seçin',
    paypalRecommendedBadge: 'Önerilen',
    paypalPartnerTitle: 'PayPal Partner ile',
    paypalPartnerFeatureQuickConnect: 'Tek tıkla hızlı bağlantı',
    paypalPartnerFeatureAutoTokens: 'Otomatik token yenileme',
    paypalPartnerFeatureMostSecure: 'En güvenli yöntem',
    paypalPartnerFeatureNoApiKeys: 'API anahtarı kopyalamaya gerek yok',
    paypalPartnerButton: 'Partner ile bağlan',
    paypalDirectTitle: 'Doğrudan (API Kimlik Bilgileri)',
    paypalDirectFeatureClientIdSecret: 'Client ID ve Secret gerekir',
    paypalDirectFeatureManualSetup: 'Manuel kurulum',
    paypalDirectFeatureFullControl: 'API üzerinde tam kontrol',
    paypalDirectFeatureAdvancedUsers: 'İleri düzey kullanıcılar için',
    paypalDirectButton: 'Doğrudan bağlan',
    clientIdRequired: 'Client ID zorunlu bir alandır',
    clientSecretRequired: 'Client Secret zorunlu bir alandır',
    invalidPaypalCredentials: 'Geçersiz PayPal kimlik bilgileri',
    connectPaypalDirectly: `PayPal'ı doğrudan bağla`,
    paypalConnectedSuccessfully: 'PayPal başarıyla bağlandı!',
    yourPaypalClientId: `Dashboard'daki PayPal Client ID'niz`,
    yourPaypalClientSecret: `Dashboard'daki PayPal Client Secret'ınız`,
    chooseOperatingMode: 'Çalışma modunu seçin',
    sandboxTest: 'Sandbox (Test)',
    liveProduction: 'Canlı (Production)',
    whereToFindCredentials: '💡 Kimlik bilgileri nerede bulunur?',
    goTo: 'Şuraya gidin',
    createOrSelectApp: 'Yeni bir App oluşturun veya mevcut olanı seçin',
    copyClientIdAndSecret: `Client ID ve Secret'ı kopyalayın`,
    cancel: 'İptal',
    connected: 'Bağlandı!',
    connect: 'Bağlan',
    monobankTokenTooltip: `Monobank Business Acquiring token'ı`,
    monobankTokenPlaceholder: `Monobank token'ını girin`,
    whereToGetToken: 'Token nereden alınır?',
    statusChangedTo: 'Durum şu şekilde değiştirildi',
    all: 'Tümü',
    loading: 'Yükleniyor...',
    noBookingsYet: 'Henüz rezervasyon yok',
    noBookingsWithStatus: 'Bu durumda rezervasyon yok',
    nightsAbbr: 'gece',
    uah: 'UAH',
    oneNightDeposit: 'Bir gecelik depozito',
    fullPrepayment: 'Tam ön ödeme',
    online: 'Çevrimiçi',
    confirm: 'Onayla',
    complete: 'Tamamla',
    restore: 'Geri yükle',
    bookingCalendarBooked: 'Rezerve edildi',
    bookingCalendarBlockedManually: 'Manuel olarak engellendi',
    bookingCalendarAvailable: 'Müsait',
    bookingCalendarNoSettings: 'Ayar yok',
    bookingCalendarSaveItemFirst: 'Önce öğeyi kaydedin',
    bookingCalendarLoading: 'Yükleniyor...',
    bookingCalendarBlocked: 'Engellendi',
    bookingCalendarSelected: 'Seçildi',
    bookingCalendarSelectedDates: 'Seçilen tarihler',
    bookingCalendarPricePerDay: 'Günlük fiyat',
    bookingCalendarOpen: 'Aç',
    bookingCalendarBlock: 'Engelle',
    bookingCalendarCancel: 'İptal',
    responseDeleted: 'Yanıt silindi',
    deleteAllConfirm: 'Tüm yanıtlar silinsin mi? Bu işlem geri alınamaz.',
    allResponsesDeleted: 'Tüm yanıtlar silindi',
    responseOne: 'yanıt',
    responseFew: 'yanıt',
    responseMany: 'yanıt',
    deleteAll: 'Tümünü sil',
    allForms: 'Tüm formlar',
    noResponsesYet: 'Henüz yanıt yok',
    fieldName: 'Ad',
    fieldPhone: 'Telefon',
    fieldAddress: 'Adres',
    fieldComment: 'Yorum',
    customFields: 'Ek alanlar',
    more: 'Daha fazla',
    view: 'Görüntüle',
    track: 'Takip et',
    showing: 'Gösterilen',
    of: '/',
    ordersLower: 'sipariş',
    ordersEmpty: 'Henüz kayıt yok',
    ordersCountLabel: 'kayıt',
    ordersName: 'Ad',
    ordersPhone: 'Telefon',
    ordersLoading: 'Yükleniyor...',
    ordersComment: 'Yorum',
    ordersPayment: 'Ödeme',
    ordersPrev: 'Önceki',
    ordersNext: 'Sonraki',
    revokeAccessConfirm: 'Erişim iptal edilsin mi?',
    accessRevoked: 'Erişim iptal edildi',
    activeGrants: 'aktif yetki',
    noActiveGrants: 'Aktif yetki yok',
    type: 'Tür',
    grantedBy: 'Veren',
    started: 'Başladı',
    until: 'Bitiş',
    revoke: 'İptal et',
    deleted: 'Silindi',
    subscribers: 'abone',
    noSubscribersYet: 'Henüz abone yok',
    phone: 'Telefon',
    name: 'Ad',
    step: 'Adım',
    done: 'tamamlandı',
    stepFailedSingular: 'adım başarısız oldu',
    stepFailedPlural: 'adım başarısız oldu',
    done2: 'Tamamlandı.',
    actionFailed: 'İşlem gerçekleştirilemedi.',
    starterCoffeeSite: 'Bir kahve dükkanı için web sitesi oluştur',
    starterFaq: '5 soruluk bir SSS bloğu ekle',
    starterTranslate: 'Tüm siteyi İngilizceye çevir',
    starterBrandColors: 'Markama uygun renkler seç',
    stopped: 'Durduruldu.',
    scopeSite: 'Site',
    scopePage: 'Sayfa',
    followUpAddPhoto: 'Bir fotoğraf daha ekle',
    followUpAddQuestion: 'Başka bir soru ekle',
    followUpAddPlan: 'Başka bir fiyat planı ekle',
    followUpAddService: 'Başka bir hizmet ekle',
    followUpAddBlock: 'Bir blok daha ekle',
    followUpMakeBetter: 'Daha da iyi yap',
    followUpTweakColors: 'Renkleri markama uyacak şekilde ayarla',
    followUpChangeColors: 'Renkleri değiştir',
    followUpTranslateEnglish: 'İngilizceye çevir',
    undoneDeletedPrefix: 'Geri alındı — kaldırıldı',
    undoneOf: '/',
    undoneCreatedBlocks: 'oluşturulan blok',
    planAnalyzing: 'İstek analiz ediliyor',
    planCheckingSite: 'Site durumu kontrol ediliyor',
    planChoosingBlocks: 'Bloklar seçiliyor',
    planPreparing: 'Plan hazırlanıyor',
    hideDetails: 'Ayrıntıları gizle',
    details: 'Ayrıntılar',
    emptyStateTitle: 'Nasıl yardımcı olabilirim?',
    emptyStateSubtitle: 'Ne yapılacağını açıklayın — ya da aşağıdan bir örnek seçin',
    undoing: 'Geri alınıyor…',
    undo: 'Geri al',
    blockSingular: 'blok',
    blockPlural: 'blok',
    usageCostTitle: 'Bu isteğin maliyeti',
    tokens: 'token',
    stop: 'Durdur',
    scopeSiteTitle: 'Tüm sitede değişiklikler',
    scopePageTitle: 'Yalnızca mevcut sayfada değişiklikler',
    customDesign: 'Özel tasarım',
    appointmentEmbedTitle: `Yerleştirme URL'si`,
    appointmentEmbedSubtitle: `Calendly'yi satır içi iframe olarak yerleştir`,
    appointmentEmbedCaption: `Calendly URL'si`,
    appointmentEmbedTooltip: `Calendly etkinlik URL'nizi yapıştırın (ör. https://calendly.com/you/30min)`,
    appointmentEmbedInvalid: `Geçerli bir Calendly URL'si girin (ör. https://calendly.com/you/30min)`,
  },
  ama: {
    questions: 'soru',
    all: 'Tümü',
    unanswered: 'Yanıtlanmamış',
    answered: 'Yanıtlanmış',
    loading: 'Yükleniyor...',
    noQuestions: 'Henüz soru yok',
    anonymous: 'Anonim',
    noName: 'İsimsiz',
    yourAnswer: 'Yanıtınız',
    edit: 'Düzenle',
    delete: 'Sil',
    cancel: 'İptal',
    enterAnswer: 'Yanıtınızı girin...',
    saveAnswer: 'Yanıtı kaydet',
    confirmDelete: 'Bu soru silinsin mi?',
    answerSaved: 'Yanıt kaydedildi',
    deleted: 'Silindi',
  },
  adsManager: {
    estimatedAudience: 'Tahmini kitle boyutu',
    audienceTooLarge: 'Kitleniz çok geniş — daraltmayı düşünün.',
    audienceTooNarrow: 'Kitleniz çok küçük — genişletmeyi düşünün.',
    audience: 'Kitle',
    suggestedAudience: 'Önerilen kitleyi kullan',
    suggestedAudienceHint: 'Geniş hedefleme, erişim için en iyisi',
    buildYourOwn: 'Kendin oluştur',
    buildYourOwnHint: 'Yaş, cinsiyet ve ülkeleri ayarla',
    expectedViewers: 'Beklenen reklam izleyicisi',
    totalBudget: 'Toplam kampanya bütçesi',
    duration: 'Süre',
    days: 'gün',
    advancedSchedule: 'Gelişmiş zamanlama',
    hideAdvanced: 'Gelişmiş zamanlamayı gizle',
    adPreview: 'Reklam önizlemesi',
    sponsored: 'Sponsorlu',
    seeMore: 'Daha fazla gör',
    learnMore: 'Daha Fazla Bilgi',
    yourPage: 'Sayfanız',
  },
  virtualBackgrounds: {
    title: 'Sanal Arka Planlar',
    canvasSize: 'Tuval boyutu',
    fmtCall: 'Zoom · Teams · Meet',
    fmtStories: 'Stories · Reels',
    fmtSquare: 'Kare',
    fmtClassic: 'Klasik',
    background: 'Arka plan',
    bg_color: 'Renk',
    bg_gradient: 'Gradyan',
    bg_photo: 'Fotoğraf',
    bg_pattern: 'Desen',
    from: 'Başlangıç',
    to: 'Bitiş',
    angle: 'Açı',
    ink: 'Mürekkep',
    paper: 'Kağıt',
    blur: 'Bulanıklık',
    darken: 'Karart',
    presets: 'Hazır ayarlar',
    uploadImage: 'Görsel yükle',
    removeImage: 'Görseli kaldır',
    replace: 'Değiştir',
    remove: 'Kaldır',
    photoPlaceholder: 'Panelden bir görsel yükleyin',
    overlay: 'Katman',
    showName: 'Adı göster',
    namePlaceholder: 'Adınız',
    subtitlePlaceholder: 'Alt başlık / kullanıcı adı',
    typeface: 'Yazı tipi',
    textColour: 'Metin rengi',
    nameSizeLabel: 'Ad boyutu',
    position: 'Konum',
    showQr: 'QR kodunu göster',
    qrPlaceholder: 'https://link',
    style: 'Stil',
    qrCard: 'Kart',
    qrBrand: 'Marka',
    qrLight: 'Açık',
    qrSolid: 'Düz',
    qrSizeLabel: 'QR boyutu',
    logo: 'Logo / avatar',
    uploadLogo: 'Logo yükle (PNG)',
    logoSizeLabel: 'Logo boyutu',
    finishing: 'Son işlem',
    vignette: 'Vinyet',
    vignetteHint: 'Derinlik için yumuşak koyu kenarlar',
    shuffle: 'Karıştır',
    reset: 'Sıfırla',
    dragHint: 'Yeniden konumlandırmak için ad, QR veya logoyu tuval üzerinde sürükleyin',
    preparing: 'Hazırlanıyor…',
    download: 'İndir',
    sizeHint: '1920 × 1080 JPG olarak kaydedildi',
  },
  emailSignatures: {
    title: 'E-posta İmzaları',
    details: 'Ayrıntılar',
    name: 'Ad',
    jobTitle: 'Unvan',
    company: 'Şirket',
    email: 'E-posta',
    phone: 'Telefon',
    website: 'Web sitesi',
    style: 'Stil',
    styleModern: 'Modern',
    styleClassic: 'Klasik',
    styleMinimal: 'Minimal',
    styleBold: 'Kalın',
    styleCard: 'Kart',
    accent: 'Vurgu rengi',
    showAvatar: 'Fotoğrafı göster',
    showQr: 'QR kodunu göster',
    preview: 'Önizleme',
    copySignature: 'İmzayı kopyala',
    copyHtml: `HTML'yi kopyala`,
    copied: 'İmza kopyalandı',
    copiedHtml: 'HTML kopyalandı',
    instructions: {
      gmail: 'Gmail: Ayarlar → Tüm ayarları gör → Genel → İmza → Yeni oluştur, ardından yapıştırın (Ctrl/Cmd+V) ve değişiklikleri kaydedin.',
      outlook: 'Outlook: Dosya → Seçenekler → Posta → İmzalar → Yeni, ardından yapıştırın. Yeni Outlook / web: Ayarlar → Posta → Yaz ve yanıtla → imza kutusuna yapıştırın.',
      apple: 'Apple Mail: Mail → Ayarlar → İmzalar → bir imza ekleyin, ardından yapıştırın. “Her zaman varsayılan mesaj yazı tipimi kullan” seçeneğinin işaretini kaldırın.',
    },
  },
};
